/*! jQuery v1.12.0 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="1.12.0",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(e=arguments[h]))for(d in e)a=g[d],c=e[d],g!==c&&(j&&c&&(n.isPlainObject(c)||(b=n.isArray(c)))?(b?(b=!1,f=a&&n.isArray(a)?a:[]):f=a&&n.isPlainObject(a)?a:{},g[d]=n.extend(j,f,c)):void 0!==c&&(g[d]=c));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray||function(a){return"array"===n.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},isPlainObject:function(a){var b;if(!a||"object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;try{if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(c){return!1}if(!l.ownFirst)for(b in a)return k.call(a,b);for(b in a);return void 0===b||k.call(a,b)},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(b){b&&n.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(h)return h.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var c=+b.length,d=0,e=a.length;while(c>d)a[e++]=b[d++];if(c!==c)while(void 0!==b[d])a[e++]=b[d++];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(f=a[b],b=a,a=f),n.isFunction(a)?(c=e.call(arguments,2),d=function(){return a.apply(b||this,c.concat(e.call(arguments)))},d.guid=a.guid=a.guid||n.guid++,d):void 0},now:function(){return+new Date},support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=R.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return n.inArray(a,b)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;e>b;b++)if(n.contains(d[b],this))return!0}));for(b=0;e>b;b++)n.find(a,d[b],c);return c=this.pushStack(e>1?n.unique(c):c),c.selector=this.selector?this.selector+" "+a:a,c},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a.charAt(0)&&">"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}if(f=d.getElementById(e[2]),f&&f.parentNode){if(f.id!==e[2])return A.find(a);this.length=1,this[0]=f}return this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b,c=n(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(n.contains(this,c[b]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?n.inArray(this[0],n(a)):n.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return n.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||(e=n.uniqueSort(e)),D.test(a)&&(e=e.reverse())),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=!0,c||j.disable(),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.addEventListener?(d.removeEventListener("DOMContentLoaded",K),a.removeEventListener("load",K)):(d.detachEvent("onreadystatechange",K),a.detachEvent("onload",K))}function K(){(d.addEventListener||"load"===a.event.type||"complete"===d.readyState)&&(J(),n.ready())}n.ready.promise=function(b){if(!I)if(I=n.Deferred(),"complete"===d.readyState)a.setTimeout(n.ready);else if(d.addEventListener)d.addEventListener("DOMContentLoaded",K),a.addEventListener("load",K);else{d.attachEvent("onreadystatechange",K),a.attachEvent("onload",K);var c=!1;try{c=null==a.frameElement&&d.documentElement}catch(e){}c&&c.doScroll&&!function f(){if(!n.isReady){try{c.doScroll("left")}catch(b){return a.setTimeout(f,50)}J(),n.ready()}}()}return I.promise(b)},n.ready.promise();var L;for(L in n(l))break;l.ownFirst="0"===L,l.inlineBlockNeedsLayout=!1,n(function(){var a,b,c,e;c=d.getElementsByTagName("body")[0],c&&c.style&&(b=d.createElement("div"),e=d.createElement("div"),e.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(e).appendChild(b),"undefined"!=typeof b.style.zoom&&(b.style.cssText="display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1",l.inlineBlockNeedsLayout=a=3===b.offsetWidth,a&&(c.style.zoom=1)),c.removeChild(e))}),function(){var a=d.createElement("div");l.deleteExpando=!0;try{delete a.test}catch(b){l.deleteExpando=!1}a=null}();var M=function(a){var b=n.noData[(a.nodeName+" ").toLowerCase()],c=+a.nodeType||1;return 1!==c&&9!==c?!1:!b||b!==!0&&a.getAttribute("classid")===b},N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){if(void 0===c&&1===a.nodeType){var d="data-"+b.replace(O,"-$1").toLowerCase();if(c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}n.data(a,b,c)}else c=void 0}return c}function Q(a){var b;for(b in a)if(("data"!==b||!n.isEmptyObject(a[b]))&&"toJSON"!==b)return!1;
return!0}function R(a,b,d,e){if(M(a)){var f,g,h=n.expando,i=a.nodeType,j=i?n.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||void 0!==d||"string"!=typeof b)return k||(k=i?a[h]=c.pop()||n.guid++:h),j[k]||(j[k]=i?{}:{toJSON:n.noop}),("object"==typeof b||"function"==typeof b)&&(e?j[k]=n.extend(j[k],b):j[k].data=n.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),void 0!==d&&(g[n.camelCase(b)]=d),"string"==typeof b?(f=g[b],null==f&&(f=g[n.camelCase(b)])):f=g,f}}function S(a,b,c){if(M(a)){var d,e,f=a.nodeType,g=f?n.cache:a,h=f?a[n.expando]:n.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){n.isArray(b)?b=b.concat(n.map(b,n.camelCase)):b in d?b=[b]:(b=n.camelCase(b),b=b in d?[b]:b.split(" ")),e=b.length;while(e--)delete d[b[e]];if(c?!Q(d):!n.isEmptyObject(d))return}(c||(delete g[h].data,Q(g[h])))&&(f?n.cleanData([a],!0):l.deleteExpando||g!=g.window?delete g[h]:g[h]=void 0)}}}n.extend({cache:{},noData:{"applet ":!0,"embed ":!0,"object ":"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(a){return a=a.nodeType?n.cache[a[n.expando]]:a[n.expando],!!a&&!Q(a)},data:function(a,b,c){return R(a,b,c)},removeData:function(a,b){return S(a,b)},_data:function(a,b,c){return R(a,b,c,!0)},_removeData:function(a,b){return S(a,b,!0)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=n.data(f),1===f.nodeType&&!n._data(f,"parsedAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));n._data(f,"parsedAttrs",!0)}return e}return"object"==typeof a?this.each(function(){n.data(this,a)}):arguments.length>1?this.each(function(){n.data(this,a,b)}):f?P(f,a,n.data(f,a)):void 0},removeData:function(a){return this.each(function(){n.removeData(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=n._data(a,b),c&&(!d||n.isArray(c)?d=n._data(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return n._data(a,c)||n._data(a,c,{empty:n.Callbacks("once memory").add(function(){n._removeData(a,b+"queue"),n._removeData(a,c)})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=n._data(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}}),function(){var a;l.shrinkWrapBlocks=function(){if(null!=a)return a;a=!1;var b,c,e;return c=d.getElementsByTagName("body")[0],c&&c.style?(b=d.createElement("div"),e=d.createElement("div"),e.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(e).appendChild(b),"undefined"!=typeof b.style.zoom&&(b.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1",b.appendChild(d.createElement("div")).style.width="5px",a=3!==b.offsetWidth),c.removeChild(e),a):void 0}}();var T=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,U=new RegExp("^(?:([+-])=|)("+T+")([a-z%]*)$","i"),V=["Top","Right","Bottom","Left"],W=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function X(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&U.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var Y=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)Y(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},Z=/^(?:checkbox|radio)$/i,$=/<([\w:-]+)/,_=/^$|\/(?:java|ecma)script/i,aa=/^\s+/,ba="abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";function ca(a){var b=ba.split("|"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}!function(){var a=d.createElement("div"),b=d.createDocumentFragment(),c=d.createElement("input");a.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",l.leadingWhitespace=3===a.firstChild.nodeType,l.tbody=!a.getElementsByTagName("tbody").length,l.htmlSerialize=!!a.getElementsByTagName("link").length,l.html5Clone="<:nav></:nav>"!==d.createElement("nav").cloneNode(!0).outerHTML,c.type="checkbox",c.checked=!0,b.appendChild(c),l.appendChecked=c.checked,a.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!a.cloneNode(!0).lastChild.defaultValue,b.appendChild(a),c=d.createElement("input"),c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),a.appendChild(c),l.checkClone=a.cloneNode(!0).cloneNode(!0).lastChild.checked,l.noCloneEvent=!!a.addEventListener,a[n.expando]=1,l.attributes=!a.getAttribute(n.expando)}();var da={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:l.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]};da.optgroup=da.option,da.tbody=da.tfoot=da.colgroup=da.caption=da.thead,da.th=da.td;function ea(a,b){var c,d,e=0,f="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):void 0;if(!f)for(f=[],c=a.childNodes||a;null!=(d=c[e]);e++)!b||n.nodeName(d,b)?f.push(d):n.merge(f,ea(d,b));return void 0===b||b&&n.nodeName(a,b)?n.merge([a],f):f}function fa(a,b){for(var c,d=0;null!=(c=a[d]);d++)n._data(c,"globalEval",!b||n._data(b[d],"globalEval"))}var ga=/<|&#?\w+;/,ha=/<tbody/i;function ia(a){Z.test(a.type)&&(a.defaultChecked=a.checked)}function ja(a,b,c,d,e){for(var f,g,h,i,j,k,m,o=a.length,p=ca(b),q=[],r=0;o>r;r++)if(g=a[r],g||0===g)if("object"===n.type(g))n.merge(q,g.nodeType?[g]:g);else if(ga.test(g)){i=i||p.appendChild(b.createElement("div")),j=($.exec(g)||["",""])[1].toLowerCase(),m=da[j]||da._default,i.innerHTML=m[1]+n.htmlPrefilter(g)+m[2],f=m[0];while(f--)i=i.lastChild;if(!l.leadingWhitespace&&aa.test(g)&&q.push(b.createTextNode(aa.exec(g)[0])),!l.tbody){g="table"!==j||ha.test(g)?"<table>"!==m[1]||ha.test(g)?0:i:i.firstChild,f=g&&g.childNodes.length;while(f--)n.nodeName(k=g.childNodes[f],"tbody")&&!k.childNodes.length&&g.removeChild(k)}n.merge(q,i.childNodes),i.textContent="";while(i.firstChild)i.removeChild(i.firstChild);i=p.lastChild}else q.push(b.createTextNode(g));i&&p.removeChild(i),l.appendChecked||n.grep(ea(q,"input"),ia),r=0;while(g=q[r++])if(d&&n.inArray(g,d)>-1)e&&e.push(g);else if(h=n.contains(g.ownerDocument,g),i=ea(p.appendChild(g),"script"),h&&fa(i),c){f=0;while(g=i[f++])_.test(g.type||"")&&c.push(g)}return i=null,p}!function(){var b,c,e=d.createElement("div");for(b in{submit:!0,change:!0,focusin:!0})c="on"+b,(l[b]=c in a)||(e.setAttribute(c,"t"),l[b]=e.attributes[c].expando===!1);e=null}();var ka=/^(?:input|select|textarea)$/i,la=/^key/,ma=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,na=/^(?:focusinfocus|focusoutblur)$/,oa=/^([^.]*)(?:\.(.+)|)/;function pa(){return!0}function qa(){return!1}function ra(){try{return d.activeElement}catch(a){}}function sa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)sa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=qa;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=n._data(a);if(r){c.handler&&(i=c,c=i.handler,e=i.selector),c.guid||(c.guid=n.guid++),(g=r.events)||(g=r.events={}),(k=r.handle)||(k=r.handle=function(a){return"undefined"==typeof n||a&&n.event.triggered===a.type?void 0:n.event.dispatch.apply(k.elem,arguments)},k.elem=a),b=(b||"").match(G)||[""],h=b.length;while(h--)f=oa.exec(b[h])||[],o=q=f[1],p=(f[2]||"").split(".").sort(),o&&(j=n.event.special[o]||{},o=(e?j.delegateType:j.bindType)||o,j=n.event.special[o]||{},l=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},i),(m=g[o])||(m=g[o]=[],m.delegateCount=0,j.setup&&j.setup.call(a,d,p,k)!==!1||(a.addEventListener?a.addEventListener(o,k,!1):a.attachEvent&&a.attachEvent("on"+o,k))),j.add&&(j.add.call(a,l),l.handler.guid||(l.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,l):m.push(l),n.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=n.hasData(a)&&n._data(a);if(r&&(k=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=oa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=k[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),i=f=m.length;while(f--)g=m[f],!e&&q!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&("**"!==d||!g.selector)||(m.splice(f,1),g.selector&&m.delegateCount--,l.remove&&l.remove.call(a,g));i&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete k[o])}else for(o in k)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(k)&&(delete r.handle,n._removeData(a,"events"))}},trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(i=m=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!na.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),h=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),l=n.event.special[q]||{},f||!l.trigger||l.trigger.apply(e,c)!==!1)){if(!f&&!l.noBubble&&!n.isWindow(e)){for(j=l.delegateType||q,na.test(j+q)||(i=i.parentNode);i;i=i.parentNode)p.push(i),m=i;m===(e.ownerDocument||d)&&p.push(m.defaultView||m.parentWindow||a)}o=0;while((i=p[o++])&&!b.isPropagationStopped())b.type=o>1?j:l.bindType||q,g=(n._data(i,"events")||{})[b.type]&&n._data(i,"handle"),g&&g.apply(i,c),g=h&&i[h],g&&g.apply&&M(i)&&(b.result=g.apply(i,c),b.result===!1&&b.preventDefault());if(b.type=q,!f&&!b.isDefaultPrevented()&&(!l._default||l._default.apply(p.pop(),c)===!1)&&M(e)&&h&&e[q]&&!n.isWindow(e)){m=e[h],m&&(e[h]=null),n.event.triggered=q;try{e[q]()}catch(s){}n.event.triggered=void 0,m&&(e[h]=m)}return b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(n._data(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.rnamespace||a.rnamespace.test(g.namespace))&&(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!=this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ma.test(f)?this.mouseHooks:la.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=g.srcElement||d),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,h.filter?h.filter(a,g):a},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button,h=b.fromElement;return null==a.pageX&&null!=b.clientX&&(e=a.target.ownerDocument||d,f=e.documentElement,c=e.body,a.pageX=b.clientX+(f&&f.scrollLeft||c&&c.scrollLeft||0)-(f&&f.clientLeft||c&&c.clientLeft||0),a.pageY=b.clientY+(f&&f.scrollTop||c&&c.scrollTop||0)-(f&&f.clientTop||c&&c.clientTop||0)),!a.relatedTarget&&h&&(a.relatedTarget=h===a.target?b.toElement:h),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==ra()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:"focusin"},blur:{trigger:function(){return this===ra()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return n.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b),d.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=d.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)}:function(a,b,c){var d="on"+b;a.detachEvent&&("undefined"==typeof a[d]&&(a[d]=null),a.detachEvent(d,c))},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?pa:qa):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:qa,isPropagationStopped:qa,isImmediatePropagationStopped:qa,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=pa,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=pa,a&&!this.isSimulated&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=pa,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),l.submit||(n.event.special.submit={setup:function(){return n.nodeName(this,"form")?!1:void n.event.add(this,"click._submit keypress._submit",function(a){var b=a.target,c=n.nodeName(b,"input")||n.nodeName(b,"button")?n.prop(b,"form"):void 0;c&&!n._data(c,"submit")&&(n.event.add(c,"submit._submit",function(a){a._submitBubble=!0}),n._data(c,"submit",!0))})},postDispatch:function(a){a._submitBubble&&(delete a._submitBubble,this.parentNode&&!a.isTrigger&&n.event.simulate("submit",this.parentNode,a))},teardown:function(){return n.nodeName(this,"form")?!1:void n.event.remove(this,"._submit")}}),l.change||(n.event.special.change={setup:function(){return ka.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(n.event.add(this,"propertychange._change",function(a){"checked"===a.originalEvent.propertyName&&(this._justChanged=!0)}),n.event.add(this,"click._change",function(a){this._justChanged&&!a.isTrigger&&(this._justChanged=!1),n.event.simulate("change",this,a)})),!1):void n.event.add(this,"beforeactivate._change",function(a){var b=a.target;ka.test(b.nodeName)&&!n._data(b,"change")&&(n.event.add(b,"change._change",function(a){!this.parentNode||a.isSimulated||a.isTrigger||n.event.simulate("change",this.parentNode,a)}),n._data(b,"change",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||"radio"!==b.type&&"checkbox"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return n.event.remove(this,"._change"),!ka.test(this.nodeName)}}),l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=n._data(d,b);e||d.addEventListener(a,c,!0),n._data(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=n._data(d,b)-1;e?n._data(d,b,e):(d.removeEventListener(a,c,!0),n._removeData(d,b))}}}),n.fn.extend({on:function(a,b,c,d){return sa(this,a,b,c,d)},one:function(a,b,c,d){return sa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=qa),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var ta=/ jQuery\d+="(?:null|\d+)"/g,ua=new RegExp("<(?:"+ba+")[\\s/>]","i"),va=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,wa=/<script|<style|<link/i,xa=/checked\s*(?:[^=]|=\s*.checked.)/i,ya=/^true\/(.*)/,za=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,Aa=ca(d),Ba=Aa.appendChild(d.createElement("div"));function Ca(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function Da(a){return a.type=(null!==n.find.attr(a,"type"))+"/"+a.type,a}function Ea(a){var b=ya.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Fa(a,b){if(1===b.nodeType&&n.hasData(a)){var c,d,e,f=n._data(a),g=n._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)n.event.add(b,c,h[c][d])}g.data&&(g.data=n.extend({},g.data))}}function Ga(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!l.noCloneEvent&&b[n.expando]){e=n._data(b);for(d in e.events)n.removeEvent(b,d,e.handle);b.removeAttribute(n.expando)}"script"===c&&b.text!==a.text?(Da(b).text=a.text,Ea(b)):"object"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),l.html5Clone&&a.innerHTML&&!n.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):"input"===c&&Z.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):"option"===c?b.defaultSelected=b.selected=a.defaultSelected:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}}function Ha(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&xa.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),Ha(f,b,c,d)});if(o&&(k=ja(b,a[0].ownerDocument,!1,a,d),e=k.firstChild,1===k.childNodes.length&&(k=e),e||d)){for(i=n.map(ea(k,"script"),Da),h=i.length;o>m;m++)g=k,m!==p&&(g=n.clone(g,!0,!0),h&&n.merge(i,ea(g,"script"))),c.call(a[m],g,m);if(h)for(j=i[i.length-1].ownerDocument,n.map(i,Ea),m=0;h>m;m++)g=i[m],_.test(g.type||"")&&!n._data(g,"globalEval")&&n.contains(j,g)&&(g.src?n._evalUrl&&n._evalUrl(g.src):n.globalEval((g.text||g.textContent||g.innerHTML||"").replace(za,"")));k=e=null}return a}function Ia(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(ea(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&fa(ea(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(va,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h,i=n.contains(a.ownerDocument,a);if(l.html5Clone||n.isXMLDoc(a)||!ua.test("<"+a.nodeName+">")?f=a.cloneNode(!0):(Ba.innerHTML=a.outerHTML,Ba.removeChild(f=Ba.firstChild)),!(l.noCloneEvent&&l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(d=ea(f),h=ea(a),g=0;null!=(e=h[g]);++g)d[g]&&Ga(e,d[g]);if(b)if(c)for(h=h||ea(a),d=d||ea(f),g=0;null!=(e=h[g]);g++)Fa(e,d[g]);else Fa(a,f);return d=ea(f,"script"),d.length>0&&fa(d,!i&&ea(a,"script")),d=h=e=null,f},cleanData:function(a,b){for(var d,e,f,g,h=0,i=n.expando,j=n.cache,k=l.attributes,m=n.event.special;null!=(d=a[h]);h++)if((b||M(d))&&(f=d[i],g=f&&j[f])){if(g.events)for(e in g.events)m[e]?n.event.remove(d,e):n.removeEvent(d,e,g.handle);j[f]&&(delete j[f],k||"undefined"==typeof d.removeAttribute?d[i]=void 0:d.removeAttribute(i),c.push(f))}}}),n.fn.extend({domManip:Ha,detach:function(a){return Ia(this,a,!0)},remove:function(a){return Ia(this,a)},text:function(a){return Y(this,function(a){return void 0===a?n.text(this):this.empty().append((this[0]&&this[0].ownerDocument||d).createTextNode(a))},null,a,arguments.length)},append:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.appendChild(a)}})},prepend:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){1===a.nodeType&&n.cleanData(ea(a,!1));while(a.firstChild)a.removeChild(a.firstChild);a.options&&n.nodeName(a,"select")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return Y(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a)return 1===b.nodeType?b.innerHTML.replace(ta,""):void 0;if("string"==typeof a&&!wa.test(a)&&(l.htmlSerialize||!ua.test(a))&&(l.leadingWhitespace||!aa.test(a))&&!da[($.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(ea(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ha(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(ea(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=0,e=[],f=n(a),h=f.length-1;h>=d;d++)c=d===h?this:this.clone(!0),n(f[d])[b](c),g.apply(e,c.get());return this.pushStack(e)}});var Ja,Ka={HTML:"block",BODY:"block"};function La(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function Ma(a){var b=d,c=Ka[a];return c||(c=La(a,b),"none"!==c&&c||(Ja=(Ja||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=(Ja[0].contentWindow||Ja[0].contentDocument).document,b.write(),b.close(),c=La(a,b),Ja.detach()),Ka[a]=c),c}var Na=/^margin/,Oa=new RegExp("^("+T+")(?!px)[a-z%]+$","i"),Pa=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Qa=d.documentElement;!function(){var b,c,e,f,g,h,i=d.createElement("div"),j=d.createElement("div");if(j.style){j.style.cssText="float:left;opacity:.5",l.opacity="0.5"===j.style.opacity,l.cssFloat=!!j.style.cssFloat,j.style.backgroundClip="content-box",j.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===j.style.backgroundClip,i=d.createElement("div"),i.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",j.innerHTML="",i.appendChild(j),l.boxSizing=""===j.style.boxSizing||""===j.style.MozBoxSizing||""===j.style.WebkitBoxSizing,n.extend(l,{reliableHiddenOffsets:function(){return null==b&&k(),f},boxSizingReliable:function(){return null==b&&k(),e},pixelMarginRight:function(){return null==b&&k(),c},pixelPosition:function(){return null==b&&k(),b},reliableMarginRight:function(){return null==b&&k(),g},reliableMarginLeft:function(){return null==b&&k(),h}});function k(){var k,l,m=d.documentElement;m.appendChild(i),j.style.cssText="-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",b=e=h=!1,c=g=!0,a.getComputedStyle&&(l=a.getComputedStyle(j),b="1%"!==(l||{}).top,h="2px"===(l||{}).marginLeft,e="4px"===(l||{width:"4px"}).width,j.style.marginRight="50%",c="4px"===(l||{marginRight:"4px"}).marginRight,k=j.appendChild(d.createElement("div")),k.style.cssText=j.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",k.style.marginRight=k.style.width="0",j.style.width="1px",g=!parseFloat((a.getComputedStyle(k)||{}).marginRight),j.removeChild(k)),j.style.display="none",f=0===j.getClientRects().length,f&&(j.style.display="",j.innerHTML="<table><tr><td></td><td>t</td></tr></table>",k=j.getElementsByTagName("td"),k[0].style.cssText="margin:0;border:0;padding:0;display:none",f=0===k[0].offsetHeight,f&&(k[0].style.display="",k[1].style.display="none",f=0===k[0].offsetHeight)),m.removeChild(i)}}}();var Ra,Sa,Ta=/^(top|right|bottom|left)$/;a.getComputedStyle?(Ra=function(b){var c=b.ownerDocument.defaultView;return c.opener||(c=a),c.getComputedStyle(b)},Sa=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ra(a),g=c?c.getPropertyValue(b)||c[b]:void 0,c&&(""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),!l.pixelMarginRight()&&Oa.test(g)&&Na.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0===g?g:g+""}):Qa.currentStyle&&(Ra=function(a){return a.currentStyle},Sa=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ra(a),g=c?c[b]:void 0,null==g&&h&&h[b]&&(g=h[b]),Oa.test(g)&&!Ta.test(b)&&(d=h.left,e=a.runtimeStyle,f=e&&e.left,f&&(e.left=a.currentStyle.left),h.left="fontSize"===b?"1em":g,g=h.pixelLeft+"px",h.left=d,f&&(e.left=f)),void 0===g?g:g+""||"auto"});function Ua(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Va=/alpha\([^)]*\)/i,Wa=/opacity\s*=\s*([^)]*)/i,Xa=/^(none|table(?!-c[ea]).+)/,Ya=new RegExp("^("+T+")(.*)$","i"),Za={position:"absolute",visibility:"hidden",display:"block"},$a={letterSpacing:"0",fontWeight:"400"},_a=["Webkit","O","Moz","ms"],ab=d.createElement("div").style;function bb(a){if(a in ab)return a;var b=a.charAt(0).toUpperCase()+a.slice(1),c=_a.length;while(c--)if(a=_a[c]+b,a in ab)return a}function cb(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=n._data(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&W(d)&&(f[g]=n._data(d,"olddisplay",Ma(d.nodeName)))):(e=W(d),(c&&"none"!==c||!e)&&n._data(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}function db(a,b,c){var d=Ya.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function eb(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+V[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+V[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+V[f]+"Width",!0,e))):(g+=n.css(a,"padding"+V[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+V[f]+"Width",!0,e)));return g}function fb(b,c,e){var f=!0,g="width"===c?b.offsetWidth:b.offsetHeight,h=Ra(b),i=l.boxSizing&&"border-box"===n.css(b,"boxSizing",!1,h);if(d.msFullscreenElement&&a.top!==a&&b.getClientRects().length&&(g=Math.round(100*b.getBoundingClientRect()[c])),0>=g||null==g){if(g=Sa(b,c,h),(0>g||null==g)&&(g=b.style[c]),Oa.test(g))return g;f=i&&(l.boxSizingReliable()||g===b.style[c]),g=parseFloat(g)||0}return g+eb(b,c,e||(i?"border":"content"),f,h)+"px"}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Sa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":l.cssFloat?"cssFloat":"styleFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;if(b=n.cssProps[h]||(n.cssProps[h]=bb(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c)return g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b];if(f=typeof c,"string"===f&&(e=U.exec(c))&&e[1]&&(c=X(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),!(g&&"set"in g&&void 0===(c=g.set(a,c,d)))))try{i[b]=c}catch(j){}}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=bb(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(f=g.get(a,!0,c)),void 0===f&&(f=Sa(a,b,d)),"normal"===f&&b in $a&&(f=$a[b]),""===c||c?(e=parseFloat(f),c===!0||isFinite(e)?e||0:f):f}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Xa.test(n.css(a,"display"))&&0===a.offsetWidth?Pa(a,Za,function(){return fb(a,b,d)}):fb(a,b,d):void 0},set:function(a,c,d){var e=d&&Ra(a);return db(a,c,d?eb(a,b,d,l.boxSizing&&"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),l.opacity||(n.cssHooks.opacity={get:function(a,b){return Wa.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=n.isNumeric(b)?"alpha(opacity="+100*b+")":"",f=d&&d.filter||c.filter||"";c.zoom=1,(b>=1||""===b)&&""===n.trim(f.replace(Va,""))&&c.removeAttribute&&(c.removeAttribute("filter"),""===b||d&&!d.filter)||(c.filter=Va.test(f)?f.replace(Va,e):f+" "+e)}}),n.cssHooks.marginRight=Ua(l.reliableMarginRight,function(a,b){return b?Pa(a,{display:"inline-block"},Sa,[a,"marginRight"]):void 0}),n.cssHooks.marginLeft=Ua(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Sa(a,"marginLeft"))||(n.contains(a.ownerDocument,a)?a.getBoundingClientRect().left-Pa(a,{
marginLeft:0},function(){return a.getBoundingClientRect().left}):0))+"px":void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+V[d]+b]=f[d]||f[d-2]||f[0];return e}},Na.test(a)||(n.cssHooks[a+b].set=db)}),n.fn.extend({css:function(a,b){return Y(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ra(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return cb(this,!0)},hide:function(){return cb(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){W(this)?n(this).show():n(this).hide()})}});function gb(a,b,c,d,e){return new gb.prototype.init(a,b,c,d,e)}n.Tween=gb,gb.prototype={constructor:gb,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=gb.propHooks[this.prop];return a&&a.get?a.get(this):gb.propHooks._default.get(this)},run:function(a){var b,c=gb.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):gb.propHooks._default.set(this),this}},gb.prototype.init.prototype=gb.prototype,gb.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},gb.propHooks.scrollTop=gb.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=gb.prototype.init,n.fx.step={};var hb,ib,jb=/^(?:toggle|show|hide)$/,kb=/queueHooks$/;function lb(){return a.setTimeout(function(){hb=void 0}),hb=n.now()}function mb(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=V[e],d["margin"+c]=d["padding"+c]=a;return b&&(d.opacity=d.width=a),d}function nb(a,b,c){for(var d,e=(qb.tweeners[b]||[]).concat(qb.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function ob(a,b,c){var d,e,f,g,h,i,j,k,m=this,o={},p=a.style,q=a.nodeType&&W(a),r=n._data(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,m.always(function(){m.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[p.overflow,p.overflowX,p.overflowY],j=n.css(a,"display"),k="none"===j?n._data(a,"olddisplay")||Ma(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(l.inlineBlockNeedsLayout&&"inline"!==Ma(a.nodeName)?p.zoom=1:p.display="inline-block")),c.overflow&&(p.overflow="hidden",l.shrinkWrapBlocks()||m.always(function(){p.overflow=c.overflow[0],p.overflowX=c.overflow[1],p.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],jb.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(q?"hide":"show")){if("show"!==e||!r||void 0===r[d])continue;q=!0}o[d]=r&&r[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(o))"inline"===("none"===j?Ma(a.nodeName):j)&&(p.display=j);else{r?"hidden"in r&&(q=r.hidden):r=n._data(a,"fxshow",{}),f&&(r.hidden=!q),q?n(a).show():m.done(function(){n(a).hide()}),m.done(function(){var b;n._removeData(a,"fxshow");for(b in o)n.style(a,b,o[b])});for(d in o)g=nb(q?r[d]:0,d,m),d in r||(r[d]=g.start,q&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function pb(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function qb(a,b,c){var d,e,f=0,g=qb.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=hb||lb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:hb||lb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(pb(k,j.opts.specialEasing);g>f;f++)if(d=qb.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,nb,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(qb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return X(c.elem,a,U.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],qb.tweeners[c]=qb.tweeners[c]||[],qb.tweeners[c].unshift(b)},prefilters:[ob],prefilter:function(a,b){b?qb.prefilters.unshift(a):qb.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(W).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=qb(this,n.extend({},a),f);(e||n._data(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=n._data(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&kb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=n._data(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(mb(b,!0),a,d,e)}}),n.each({slideDown:mb("show"),slideUp:mb("hide"),slideToggle:mb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=n.timers,c=0;for(hb=n.now();c<b.length;c++)a=b[c],a()||b[c]!==a||b.splice(c--,1);b.length||n.fx.stop(),hb=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){ib||(ib=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(ib),ib=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a,b=d.createElement("input"),c=d.createElement("div"),e=d.createElement("select"),f=e.appendChild(d.createElement("option"));c=d.createElement("div"),c.setAttribute("className","t"),c.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",a=c.getElementsByTagName("a")[0],b.setAttribute("type","checkbox"),c.appendChild(b),a=c.getElementsByTagName("a")[0],a.style.cssText="top:1px",l.getSetAttribute="t"!==c.className,l.style=/top/.test(a.getAttribute("style")),l.hrefNormalized="/a"===a.getAttribute("href"),l.checkOn=!!b.value,l.optSelected=f.selected,l.enctype=!!d.createElement("form").enctype,e.disabled=!0,l.optDisabled=!f.disabled,b=d.createElement("input"),b.setAttribute("value",""),l.input=""===b.getAttribute("value"),b.value="t",b.setAttribute("type","radio"),l.radioValue="t"===b.value}();var rb=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(rb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)if(d=e[g],n.inArray(n.valHooks.option.get(d),f)>=0)try{d.selected=c=!0}catch(h){d.scrollHeight}else d.selected=!1;return c||(a.selectedIndex=-1),e}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var sb,tb,ub=n.expr.attrHandle,vb=/^(?:checked|selected)$/i,wb=l.getSetAttribute,xb=l.input;n.fn.extend({attr:function(a,b){return Y(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?tb:sb)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)?xb&&wb||!vb.test(c)?a[d]=!1:a[n.camelCase("default-"+c)]=a[d]=!1:n.attr(a,c,""),a.removeAttribute(wb?c:d)}}),tb={set:function(a,b,c){return b===!1?n.removeAttr(a,c):xb&&wb||!vb.test(c)?a.setAttribute(!wb&&n.propFix[c]||c,c):a[n.camelCase("default-"+c)]=a[c]=!0,c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=ub[b]||n.find.attr;xb&&wb||!vb.test(b)?ub[b]=function(a,b,d){var e,f;return d||(f=ub[b],ub[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,ub[b]=f),e}:ub[b]=function(a,b,c){return c?void 0:a[n.camelCase("default-"+b)]?b.toLowerCase():null}}),xb&&wb||(n.attrHooks.value={set:function(a,b,c){return n.nodeName(a,"input")?void(a.defaultValue=b):sb&&sb.set(a,b,c)}}),wb||(sb={set:function(a,b,c){var d=a.getAttributeNode(c);return d||a.setAttributeNode(d=a.ownerDocument.createAttribute(c)),d.value=b+="","value"===c||b===a.getAttribute(c)?b:void 0}},ub.id=ub.name=ub.coords=function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&""!==d.value?d.value:null},n.valHooks.button={get:function(a,b){var c=a.getAttributeNode(b);return c&&c.specified?c.value:void 0},set:sb.set},n.attrHooks.contenteditable={set:function(a,b,c){sb.set(a,""===b?!1:b,c)}},n.each(["width","height"],function(a,b){n.attrHooks[b]={set:function(a,c){return""===c?(a.setAttribute(b,"auto"),c):void 0}}})),l.style||(n.attrHooks.style={get:function(a){return a.style.cssText||void 0},set:function(a,b){return a.style.cssText=b+""}});var yb=/^(?:input|select|textarea|button|object)$/i,zb=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return Y(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return a=n.propFix[a]||a,this.each(function(){try{this[a]=void 0,delete this[a]}catch(b){}})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):yb.test(a.nodeName)||zb.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.hrefNormalized||n.each(["href","src"],function(a,b){n.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this}),l.enctype||(n.propFix.enctype="encoding");var Ab=/[\t\r\n\f]/g;function Bb(a){return n.attr(a,"class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,Bb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=Bb(c),d=1===c.nodeType&&(" "+e+" ").replace(Ab," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&n.attr(c,"class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,Bb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=Bb(c),d=1===c.nodeType&&(" "+e+" ").replace(Ab," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&n.attr(c,"class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,Bb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(void 0===a||"boolean"===c)&&(b=Bb(this),b&&n._data(this,"__className__",b),n.attr(this,"class",b||a===!1?"":n._data(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+Bb(c)+" ").replace(Ab," ").indexOf(b)>-1)return!0;return!1}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}});var Cb=a.location,Db=n.now(),Eb=/\?/,Fb=/(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;n.parseJSON=function(b){if(a.JSON&&a.JSON.parse)return a.JSON.parse(b+"");var c,d=null,e=n.trim(b+"");return e&&!n.trim(e.replace(Fb,function(a,b,e,f){return c&&b&&(d=0),0===d?a:(c=e||b,d+=!f-!e,"")}))?Function("return "+e)():n.error("Invalid JSON: "+b)},n.parseXML=function(b){var c,d;if(!b||"string"!=typeof b)return null;try{a.DOMParser?(d=new a.DOMParser,c=d.parseFromString(b,"text/xml")):(c=new a.ActiveXObject("Microsoft.XMLDOM"),c.async="false",c.loadXML(b))}catch(e){c=void 0}return c&&c.documentElement&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var Gb=/#.*$/,Hb=/([?&])_=[^&]*/,Ib=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Jb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Kb=/^(?:GET|HEAD)$/,Lb=/^\/\//,Mb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,Nb={},Ob={},Pb="*/".concat("*"),Qb=Cb.href,Rb=Mb.exec(Qb.toLowerCase())||[];function Sb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d.charAt(0)?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Tb(a,b,c,d){var e={},f=a===Ob;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Ub(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(d in b)void 0!==b[d]&&((e[d]?a:c||(c={}))[d]=b[d]);return c&&n.extend(!0,a,c),a}function Vb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===e&&(e=a.mimeType||b.getResponseHeader("Content-Type"));if(e)for(g in h)if(h[g]&&h[g].test(e)){i.unshift(g);break}if(i[0]in c)f=i[0];else{for(g in c){if(!i[0]||a.converters[g+" "+i[0]]){f=g;break}d||(d=g)}f=f||d}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Wb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Qb,type:"GET",isLocal:Jb.test(Rb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Pb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Ub(Ub(a,n.ajaxSettings),b):Ub(n.ajaxSettings,a)},ajaxPrefilter:Sb(Nb),ajaxTransport:Sb(Ob),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var d,e,f,g,h,i,j,k,l=n.ajaxSetup({},c),m=l.context||l,o=l.context&&(m.nodeType||m.jquery)?n(m):n.event,p=n.Deferred(),q=n.Callbacks("once memory"),r=l.statusCode||{},s={},t={},u=0,v="canceled",w={readyState:0,getResponseHeader:function(a){var b;if(2===u){if(!k){k={};while(b=Ib.exec(g))k[b[1].toLowerCase()]=b[2]}b=k[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===u?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return u||(a=t[c]=t[c]||a,s[a]=b),this},overrideMimeType:function(a){return u||(l.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>u)for(b in a)r[b]=[r[b],a[b]];else w.always(a[w.status]);return this},abort:function(a){var b=a||v;return j&&j.abort(b),y(0,b),this}};if(p.promise(w).complete=q.add,w.success=w.done,w.error=w.fail,l.url=((b||l.url||Qb)+"").replace(Gb,"").replace(Lb,Rb[1]+"//"),l.type=c.method||c.type||l.method||l.type,l.dataTypes=n.trim(l.dataType||"*").toLowerCase().match(G)||[""],null==l.crossDomain&&(d=Mb.exec(l.url.toLowerCase()),l.crossDomain=!(!d||d[1]===Rb[1]&&d[2]===Rb[2]&&(d[3]||("http:"===d[1]?"80":"443"))===(Rb[3]||("http:"===Rb[1]?"80":"443")))),l.data&&l.processData&&"string"!=typeof l.data&&(l.data=n.param(l.data,l.traditional)),Tb(Nb,l,c,w),2===u)return w;i=n.event&&l.global,i&&0===n.active++&&n.event.trigger("ajaxStart"),l.type=l.type.toUpperCase(),l.hasContent=!Kb.test(l.type),f=l.url,l.hasContent||(l.data&&(f=l.url+=(Eb.test(f)?"&":"?")+l.data,delete l.data),l.cache===!1&&(l.url=Hb.test(f)?f.replace(Hb,"$1_="+Db++):f+(Eb.test(f)?"&":"?")+"_="+Db++)),l.ifModified&&(n.lastModified[f]&&w.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&w.setRequestHeader("If-None-Match",n.etag[f])),(l.data&&l.hasContent&&l.contentType!==!1||c.contentType)&&w.setRequestHeader("Content-Type",l.contentType),w.setRequestHeader("Accept",l.dataTypes[0]&&l.accepts[l.dataTypes[0]]?l.accepts[l.dataTypes[0]]+("*"!==l.dataTypes[0]?", "+Pb+"; q=0.01":""):l.accepts["*"]);for(e in l.headers)w.setRequestHeader(e,l.headers[e]);if(l.beforeSend&&(l.beforeSend.call(m,w,l)===!1||2===u))return w.abort();v="abort";for(e in{success:1,error:1,complete:1})w[e](l[e]);if(j=Tb(Ob,l,c,w)){if(w.readyState=1,i&&o.trigger("ajaxSend",[w,l]),2===u)return w;l.async&&l.timeout>0&&(h=a.setTimeout(function(){w.abort("timeout")},l.timeout));try{u=1,j.send(s,y)}catch(x){if(!(2>u))throw x;y(-1,x)}}else y(-1,"No Transport");function y(b,c,d,e){var k,s,t,v,x,y=c;2!==u&&(u=2,h&&a.clearTimeout(h),j=void 0,g=e||"",w.readyState=b>0?4:0,k=b>=200&&300>b||304===b,d&&(v=Vb(l,w,d)),v=Wb(l,v,w,k),k?(l.ifModified&&(x=w.getResponseHeader("Last-Modified"),x&&(n.lastModified[f]=x),x=w.getResponseHeader("etag"),x&&(n.etag[f]=x)),204===b||"HEAD"===l.type?y="nocontent":304===b?y="notmodified":(y=v.state,s=v.data,t=v.error,k=!t)):(t=y,(b||!y)&&(y="error",0>b&&(b=0))),w.status=b,w.statusText=(c||y)+"",k?p.resolveWith(m,[s,y,w]):p.rejectWith(m,[w,y,t]),w.statusCode(r),r=void 0,i&&o.trigger(k?"ajaxSuccess":"ajaxError",[w,l,k?s:t]),q.fireWith(m,[w,y]),i&&(o.trigger("ajaxComplete",[w,l]),--n.active||n.event.trigger("ajaxStop")))}return w},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){if(n.isFunction(a))return this.each(function(b){n(this).wrapAll(a.call(this,b))});if(this[0]){var b=n(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&1===a.firstChild.nodeType)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}});function Xb(a){return a.style&&a.style.display||n.css(a,"display")}function Yb(a){while(a&&1===a.nodeType){if("none"===Xb(a)||"hidden"===a.type)return!0;a=a.parentNode}return!1}n.expr.filters.hidden=function(a){return l.reliableHiddenOffsets()?a.offsetWidth<=0&&a.offsetHeight<=0&&!a.getClientRects().length:Yb(a)},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var Zb=/%20/g,$b=/\[\]$/,_b=/\r?\n/g,ac=/^(?:submit|button|image|reset|file)$/i,bc=/^(?:input|select|textarea|keygen)/i;function cc(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||$b.test(a)?d(a,e):cc(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)cc(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)cc(c,a[c],b,e);return d.join("&").replace(Zb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&bc.test(this.nodeName)&&!ac.test(a)&&(this.checked||!Z.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(_b,"\r\n")}}):{name:b.name,value:c.replace(_b,"\r\n")}}).get()}}),n.ajaxSettings.xhr=void 0!==a.ActiveXObject?function(){return this.isLocal?hc():d.documentMode>8?gc():/^(get|post|head|put|delete|options)$/i.test(this.type)&&gc()||hc()}:gc;var dc=0,ec={},fc=n.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in ec)ec[a](void 0,!0)}),l.cors=!!fc&&"withCredentials"in fc,fc=l.ajax=!!fc,fc&&n.ajaxTransport(function(b){if(!b.crossDomain||l.cors){var c;return{send:function(d,e){var f,g=b.xhr(),h=++dc;if(g.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(f in b.xhrFields)g[f]=b.xhrFields[f];b.mimeType&&g.overrideMimeType&&g.overrideMimeType(b.mimeType),b.crossDomain||d["X-Requested-With"]||(d["X-Requested-With"]="XMLHttpRequest");for(f in d)void 0!==d[f]&&g.setRequestHeader(f,d[f]+"");g.send(b.hasContent&&b.data||null),c=function(a,d){var f,i,j;if(c&&(d||4===g.readyState))if(delete ec[h],c=void 0,g.onreadystatechange=n.noop,d)4!==g.readyState&&g.abort();else{j={},f=g.status,"string"==typeof g.responseText&&(j.text=g.responseText);try{i=g.statusText}catch(k){i=""}f||!b.isLocal||b.crossDomain?1223===f&&(f=204):f=j.text?200:404}j&&e(f,i,j,g.getAllResponseHeaders())},b.async?4===g.readyState?a.setTimeout(c):g.onreadystatechange=ec[h]=c:c()},abort:function(){c&&c(void 0,!0)}}}});function gc(){try{return new a.XMLHttpRequest}catch(b){}}function hc(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}n.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c=d.head||n("head")[0]||d.documentElement;return{send:function(e,f){b=d.createElement("script"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||f(200,"success"))},c.insertBefore(b,c.firstChild)},abort:function(){b&&b.onload(void 0,!0)}}}});var ic=[],jc=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=ic.pop()||n.expando+"_"+Db++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(jc.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&jc.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(jc,"$1"+e):b.jsonp!==!1&&(b.url+=(Eb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,ic.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),l.createHTMLDocument=function(){if(!d.implementation.createHTMLDocument)return!1;var a=d.implementation.createHTMLDocument("");return a.body.innerHTML="<form></form><form></form>",2===a.body.childNodes.length}(),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||(l.createHTMLDocument?d.implementation.createHTMLDocument(""):d);var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ja([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var kc=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&kc)return kc.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h,a.length)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(g,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function lc(a){return n.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&n.inArray("auto",[f,i])>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d={top:0,left:0},e=this[0],f=e&&e.ownerDocument;if(f)return b=f.documentElement,n.contains(b,e)?("undefined"!=typeof e.getBoundingClientRect&&(d=e.getBoundingClientRect()),c=lc(f),{top:d.top+(c.pageYOffset||b.scrollTop)-(b.clientTop||0),left:d.left+(c.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):d},position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return"fixed"===n.css(d,"position")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(c=a.offset()),c.top+=n.css(a[0],"borderTopWidth",!0)-a.scrollTop(),c.left+=n.css(a[0],"borderLeftWidth",!0)-a.scrollLeft()),{top:b.top-c.top-n.css(d,"marginTop",!0),left:b.left-c.left-n.css(d,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Qa})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c=/Y/.test(b);n.fn[a]=function(d){return Y(this,function(a,d,e){var f=lc(a);return void 0===e?f?b in f?f[b]:f.document.documentElement[d]:a[d]:void(f?f.scrollTo(c?n(f).scrollLeft():e,c?e:n(f).scrollTop()):a[d]=e)},a,d,arguments.length,null)}}),n.each(["top","left"],function(a,b){
n.cssHooks[b]=Ua(l.pixelPosition,function(a,c){return c?(c=Sa(a,b),Oa.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return Y(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var mc=a.jQuery,nc=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=nc),b&&a.jQuery===n&&(a.jQuery=mc),n},b||(a.jQuery=a.$=n),n});
/*! jQuery Validation Plugin - v1.17.0 - 7/29/2017
 * https://jqueryvalidation.org/
 * Copyright (c) 2017 Jörn Zaefferer; Licensed MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.on("click.validate",":submit",function(b){c.submitButton=b.currentTarget,a(this).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(this).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.on("submit.validate",function(b){function d(){var d,e;return c.submitButton&&(c.settings.submitHandler||c.formSubmitted)&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),!c.settings.submitHandler||(e=c.settings.submitHandler.call(c,c.currentForm,b),d&&d.remove(),void 0!==e&&e)}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c,d;return a(this[0]).is("form")?b=this.validate().form():(d=[],b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b,b||(d=d.concat(c.errorList))}),c.errorList=d),b},rules:function(b,c){var d,e,f,g,h,i,j=this[0];if(null!=j&&(!j.form&&j.hasAttribute("contenteditable")&&(j.form=this.closest("form")[0],j.name=this.attr("name")),null!=j.form)){if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(a,b){i[b]=f[b],delete f[b]}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g)),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}}),a.extend(a.expr.pseudos||a.expr[":"],{blank:function(b){return!a.trim(""+a(b).val())},filled:function(b){var c=a(b).val();return null!==c&&!!a.trim(""+c)},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:void 0===c?b:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(b,c){var d=[16,17,18,20,35,36,37,38,39,40,45,144,225];9===c.which&&""===this.elementValue(b)||a.inArray(c.keyCode,d)!==-1||(b.name in this.submitted||b.name in this.invalid)&&this.element(b)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date (ISO).",number:"Please enter a valid number.",digits:"Please enter only digits.",equalTo:"Please enter the same value again.",maxlength:a.validator.format("Please enter no more than {0} characters."),minlength:a.validator.format("Please enter at least {0} characters."),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long."),range:a.validator.format("Please enter a value between {0} and {1}."),max:a.validator.format("Please enter a value less than or equal to {0}."),min:a.validator.format("Please enter a value greater than or equal to {0}."),step:a.validator.format("Please enter a multiple of {0}.")},autoCreateRanges:!1,prototype:{init:function(){function b(b){!this.form&&this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0],this.name=a(this).attr("name"));var c=a.data(this.form,"validator"),d="on"+b.type.replace(/^validate/,""),e=c.settings;e[d]&&!a(this).is(e.ignore)&&e[d].call(c,this,b)}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){d[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",b).on("click.validate","select, option, [type='radio'], [type='checkbox']",b),this.settings.invalidHandler&&a(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c,d,e=this.clean(b),f=this.validationTargetFor(e),g=this,h=!0;return void 0===f?delete this.invalid[e.name]:(this.prepareElement(f),this.currentElements=a(f),d=this.groups[f.name],d&&a.each(this.groups,function(a,b){b===d&&a!==f.name&&(e=g.validationTargetFor(g.clean(g.findByName(a))),e&&e.name in g.invalid&&(g.currentElements.push(e),h=g.check(e)&&h))}),c=this.check(f)!==!1,h=h&&c,c?this.invalid[f.name]=!1:this.invalid[f.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),a(b).attr("aria-invalid",!c)),h},showErrors:function(b){if(b){var c=this;a.extend(this.errorMap,b),this.errorList=a.map(this.errorMap,function(a,b){return{message:a,element:c.findByName(b)[0]}}),this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var b=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(b)},resetElements:function(a){var b;if(this.settings.unhighlight)for(b=0;a[b];b++)this.settings.unhighlight.call(this,a[b],this.settings.errorClass,""),this.findByName(a[b].name).removeClass(this.settings.validClass);else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)void 0!==a[b]&&null!==a[b]&&a[b]!==!1&&c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var d=this.name||a(this).attr("name");return!d&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0],this.name=d),!(d in c||!b.objectLength(a(this).rules()))&&(c[d]=!0,!0)})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([])},reset:function(){this.resetInternals(),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d,e=a(b),f=b.type;return"radio"===f||"checkbox"===f?this.findByName(b.name).filter(":checked").val():"number"===f&&"undefined"!=typeof b.validity?b.validity.badInput?"NaN":e.val():(c=b.hasAttribute("contenteditable")?e.text():e.val(),"file"===f?"C:\\fakepath\\"===c.substr(0,12)?c.substr(12):(d=c.lastIndexOf("/"),d>=0?c.substr(d+1):(d=c.lastIndexOf("\\"),d>=0?c.substr(d+1):c)):"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f,g=a(b).rules(),h=a.map(g,function(a,b){return b}).length,i=!1,j=this.elementValue(b);if("function"==typeof g.normalizer?f=g.normalizer:"function"==typeof this.settings.normalizer&&(f=this.settings.normalizer),f){if(j=f.call(b,j),"string"!=typeof j)throw new TypeError("The normalizer should return a string value.");delete g.normalizer}for(d in g){e={method:d,parameters:g[d]};try{if(c=a.validator.methods[d].call(this,j,b,e.parameters),"dependency-mismatch"===c&&1===h){i=!0;continue}if(i=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(k){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",k),k instanceof TypeError&&(k.message+=".  Exception occurred when checking element "+b.id+", check the '"+e.method+"' method."),k}}if(!i)return this.objectLength(g)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a]},defaultMessage:function(b,c){"string"==typeof c&&(c={method:c});var d=this.findDefined(this.customMessage(b.name,c.method),this.customDataMessage(b,c.method),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c.method],"<strong>Warning: No message defined for "+b.name+"</strong>"),e=/\$?\{(\d+)\}/g;return"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),d},formatAndAdd:function(a,b){var c=this.defaultMessage(a,b);this.errorList.push({message:c,element:a,method:b.method}),this.errorMap[a.name]=c,this.submitted[a.name]=c},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g,h=this.errorsFor(b),i=this.idOrName(b),j=a(b).attr("aria-describedby");h.length?(h.removeClass(this.settings.validClass).addClass(this.settings.errorClass),h.html(c)):(h=a("<"+this.settings.errorElement+">").attr("id",i+"-error").addClass(this.settings.errorClass).html(c||""),d=h,this.settings.wrapper&&(d=h.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement.call(this,d,a(b)):d.insertAfter(b),h.is("label")?h.attr("for",i):0===h.parents("label[for='"+this.escapeCssMeta(i)+"']").length&&(f=h.attr("id"),j?j.match(new RegExp("\\b"+this.escapeCssMeta(f)+"\\b"))||(j+=" "+f):j=f,a(b).attr("aria-describedby",j),e=this.groups[b.name],e&&(g=this,a.each(g.groups,function(b,c){c===e&&a("[name='"+g.escapeCssMeta(b)+"']",g.currentForm).attr("aria-describedby",h.attr("id"))})))),!c&&this.settings.success&&(h.text(""),"string"==typeof this.settings.success?h.addClass(this.settings.success):this.settings.success(h,b)),this.toShow=this.toShow.add(h)},errorsFor:function(b){var c=this.escapeCssMeta(this.idOrName(b)),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+this.escapeCssMeta(d).replace(/\s+/g,", #")),this.errors().filter(e)},escapeCssMeta:function(a){return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+this.escapeCssMeta(b)+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return!this.dependTypes[typeof a]||this.dependTypes[typeof a](a,b)},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(b){this.pending[b.name]||(this.pendingRequest++,a(b).addClass(this.settings.pendingClass),this.pending[b.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],a(b).removeClass(this.settings.pendingClass),c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.submitButton&&a("input:hidden[name='"+this.submitButton.name+"']",this.currentForm).remove(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b,c){return c="string"==typeof c&&c||"remote",a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,{method:c})})},destroy:function(){this.resetForm(),a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},normalizeAttributeRule:function(a,b,c,d){/min|max|step/.test(c)&&(null===b||/number|range|text/.test(b))&&(d=Number(d),isNaN(d)&&(d=void 0)),d||0===d?a[c]=d:b===c&&"range"!==b&&(a[c]=!0)},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),this.normalizeAttributeRule(e,g,c,d);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),this.normalizeAttributeRule(e,g,c,d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0===e.param||e.param:(a.data(c.form,"validator").resetElements(a(c)),delete b[d])}}),a.each(b,function(d,e){b[d]=a.isFunction(e)&&"normalizer"!==d?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:b.length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(a)},date:function(a,b){return this.optional(b)||!/Invalid|NaN/.test(new Date(a).toString())},dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e<=d},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||a<=c},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},step:function(b,c,d){var e,f=a(c).attr("type"),g="Step attribute on input type "+f+" is not supported.",h=["text","number","range"],i=new RegExp("\\b"+f+"\\b"),j=f&&!i.test(h.join()),k=function(a){var b=(""+a).match(/(?:\.(\d+))?$/);return b&&b[1]?b[1].length:0},l=function(a){return Math.round(a*Math.pow(10,e))},m=!0;if(j)throw new Error(g);return e=k(d),(k(b)>e||l(b)%l(d)!==0)&&(m=!1),this.optional(c)||m},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.not(".validate-equalTo-blur").length&&e.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d,e){if(this.optional(c))return"dependency-mismatch";e="string"==typeof e&&e||"remote";var f,g,h,i=this.previousValue(c,e);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),i.originalMessage=i.originalMessage||this.settings.messages[c.name][e],this.settings.messages[c.name][e]=i.message,d="string"==typeof d&&{url:d}||d,h=a.param(a.extend({data:b},d.data)),i.old===h?i.valid:(i.old=h,f=this,this.startRequest(c),g={},g[c.name]=b,a.ajax(a.extend(!0,{mode:"abort",port:"validate"+c.name,dataType:"json",data:g,context:f.currentForm,success:function(a){var d,g,h,j=a===!0||"true"===a;f.settings.messages[c.name][e]=i.originalMessage,j?(h=f.formSubmitted,f.resetInternals(),f.toHide=f.errorsFor(c),f.formSubmitted=h,f.successList.push(c),f.invalid[c.name]=!1,f.showErrors()):(d={},g=a||f.defaultMessage(c,{method:e,parameters:b}),d[c.name]=i.message=g,f.invalid[c.name]=!0,f.showErrors(d)),i.valid=j,f.stopRequest(c,j)}},d)),"pending")}}});var b,c={};return a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,d){var e=a.port;"abort"===a.mode&&(c[e]&&c[e].abort(),c[e]=d)}):(b=a.ajax,a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(c[f]&&c[f].abort(),c[f]=b.apply(this,arguments),c[f]):b.apply(this,arguments)}),a});
/*
 RequireJS 2.2.0 Copyright jQuery Foundation and other contributors.
 Released under MIT license, http://github.com/requirejs/requirejs/LICENSE
*/
var requirejs,require,define;
(function(ga){function ka(b,c,d,g){return g||""}function K(b){return"[object Function]"===Q.call(b)}function L(b){return"[object Array]"===Q.call(b)}function y(b,c){if(b){var d;for(d=0;d<b.length&&(!b[d]||!c(b[d],d,b));d+=1);}}function X(b,c){if(b){var d;for(d=b.length-1;-1<d&&(!b[d]||!c(b[d],d,b));--d);}}function x(b,c){return la.call(b,c)}function e(b,c){return x(b,c)&&b[c]}function D(b,c){for(var d in b)if(x(b,d)&&c(b[d],d))break}function Y(b,c,d,g){c&&D(c,function(c,e){if(d||!x(b,e))!g||"object"!==
typeof c||!c||L(c)||K(c)||c instanceof RegExp?b[e]=c:(b[e]||(b[e]={}),Y(b[e],c,d,g))});return b}function z(b,c){return function(){return c.apply(b,arguments)}}function ha(b){throw b;}function ia(b){if(!b)return b;var c=ga;y(b.split("."),function(b){c=c[b]});return c}function F(b,c,d,g){c=Error(c+"\nhttp://requirejs.org/docs/errors.html#"+b);c.requireType=b;c.requireModules=g;d&&(c.originalError=d);return c}function ma(b){function c(a,n,b){var h,k,f,c,d,l,g,r;n=n&&n.split("/");var q=p.map,m=q&&q["*"];
if(a){a=a.split("/");k=a.length-1;p.nodeIdCompat&&U.test(a[k])&&(a[k]=a[k].replace(U,""));"."===a[0].charAt(0)&&n&&(k=n.slice(0,n.length-1),a=k.concat(a));k=a;for(f=0;f<k.length;f++)c=k[f],"."===c?(k.splice(f,1),--f):".."===c&&0!==f&&(1!==f||".."!==k[2])&&".."!==k[f-1]&&0<f&&(k.splice(f-1,2),f-=2);a=a.join("/")}if(b&&q&&(n||m)){k=a.split("/");f=k.length;a:for(;0<f;--f){d=k.slice(0,f).join("/");if(n)for(c=n.length;0<c;--c)if(b=e(q,n.slice(0,c).join("/")))if(b=e(b,d)){h=b;l=f;break a}!g&&m&&e(m,d)&&
(g=e(m,d),r=f)}!h&&g&&(h=g,l=r);h&&(k.splice(0,l,h),a=k.join("/"))}return(h=e(p.pkgs,a))?h:a}function d(a){E&&y(document.getElementsByTagName("script"),function(n){if(n.getAttribute("data-requiremodule")===a&&n.getAttribute("data-requirecontext")===l.contextName)return n.parentNode.removeChild(n),!0})}function m(a){var n=e(p.paths,a);if(n&&L(n)&&1<n.length)return n.shift(),l.require.undef(a),l.makeRequire(null,{skipMap:!0})([a]),!0}function r(a){var n,b=a?a.indexOf("!"):-1;-1<b&&(n=a.substring(0,
b),a=a.substring(b+1,a.length));return[n,a]}function q(a,n,b,h){var k,f,d=null,g=n?n.name:null,p=a,q=!0,m="";a||(q=!1,a="_@r"+(Q+=1));a=r(a);d=a[0];a=a[1];d&&(d=c(d,g,h),f=e(v,d));a&&(d?m=f&&f.normalize?f.normalize(a,function(a){return c(a,g,h)}):-1===a.indexOf("!")?c(a,g,h):a:(m=c(a,g,h),a=r(m),d=a[0],m=a[1],b=!0,k=l.nameToUrl(m)));b=!d||f||b?"":"_unnormalized"+(T+=1);return{prefix:d,name:m,parentMap:n,unnormalized:!!b,url:k,originalName:p,isDefine:q,id:(d?d+"!"+m:m)+b}}function u(a){var b=a.id,
c=e(t,b);c||(c=t[b]=new l.Module(a));return c}function w(a,b,c){var h=a.id,k=e(t,h);if(!x(v,h)||k&&!k.defineEmitComplete)if(k=u(a),k.error&&"error"===b)c(k.error);else k.on(b,c);else"defined"===b&&c(v[h])}function A(a,b){var c=a.requireModules,h=!1;if(b)b(a);else if(y(c,function(b){if(b=e(t,b))b.error=a,b.events.error&&(h=!0,b.emit("error",a))}),!h)g.onError(a)}function B(){V.length&&(y(V,function(a){var b=a[0];"string"===typeof b&&(l.defQueueMap[b]=!0);G.push(a)}),V=[])}function C(a){delete t[a];
delete Z[a]}function J(a,b,c){var h=a.map.id;a.error?a.emit("error",a.error):(b[h]=!0,y(a.depMaps,function(h,f){var d=h.id,g=e(t,d);!g||a.depMatched[f]||c[d]||(e(b,d)?(a.defineDep(f,v[d]),a.check()):J(g,b,c))}),c[h]=!0)}function H(){var a,b,c=(a=1E3*p.waitSeconds)&&l.startTime+a<(new Date).getTime(),h=[],k=[],f=!1,g=!0;if(!aa){aa=!0;D(Z,function(a){var l=a.map,e=l.id;if(a.enabled&&(l.isDefine||k.push(a),!a.error))if(!a.inited&&c)m(e)?f=b=!0:(h.push(e),d(e));else if(!a.inited&&a.fetched&&l.isDefine&&
(f=!0,!l.prefix))return g=!1});if(c&&h.length)return a=F("timeout","Load timeout for modules: "+h,null,h),a.contextName=l.contextName,A(a);g&&y(k,function(a){J(a,{},{})});c&&!b||!f||!E&&!ja||ba||(ba=setTimeout(function(){ba=0;H()},50));aa=!1}}function I(a){x(v,a[0])||u(q(a[0],null,!0)).init(a[1],a[2])}function O(a){a=a.currentTarget||a.srcElement;var b=l.onScriptLoad;a.detachEvent&&!ca?a.detachEvent("onreadystatechange",b):a.removeEventListener("load",b,!1);b=l.onScriptError;a.detachEvent&&!ca||a.removeEventListener("error",
b,!1);return{node:a,id:a&&a.getAttribute("data-requiremodule")}}function P(){var a;for(B();G.length;){a=G.shift();if(null===a[0])return A(F("mismatch","Mismatched anonymous define() module: "+a[a.length-1]));I(a)}l.defQueueMap={}}var aa,da,l,R,ba,p={waitSeconds:7,baseUrl:"./",paths:{},bundles:{},pkgs:{},shim:{},config:{}},t={},Z={},ea={},G=[],v={},W={},fa={},Q=1,T=1;R={require:function(a){return a.require?a.require:a.require=l.makeRequire(a.map)},exports:function(a){a.usingExports=!0;if(a.map.isDefine)return a.exports?
v[a.map.id]=a.exports:a.exports=v[a.map.id]={}},module:function(a){return a.module?a.module:a.module={id:a.map.id,uri:a.map.url,config:function(){return e(p.config,a.map.id)||{}},exports:a.exports||(a.exports={})}}};da=function(a){this.events=e(ea,a.id)||{};this.map=a;this.shim=e(p.shim,a.id);this.depExports=[];this.depMaps=[];this.depMatched=[];this.pluginMaps={};this.depCount=0};da.prototype={init:function(a,b,c,h){h=h||{};if(!this.inited){this.factory=b;if(c)this.on("error",c);else this.events.error&&
(c=z(this,function(a){this.emit("error",a)}));this.depMaps=a&&a.slice(0);this.errback=c;this.inited=!0;this.ignore=h.ignore;h.enabled||this.enabled?this.enable():this.check()}},defineDep:function(a,b){this.depMatched[a]||(this.depMatched[a]=!0,--this.depCount,this.depExports[a]=b)},fetch:function(){if(!this.fetched){this.fetched=!0;l.startTime=(new Date).getTime();var a=this.map;if(this.shim)l.makeRequire(this.map,{enableBuildCallback:!0})(this.shim.deps||[],z(this,function(){return a.prefix?this.callPlugin():
this.load()}));else return a.prefix?this.callPlugin():this.load()}},load:function(){var a=this.map.url;W[a]||(W[a]=!0,l.load(this.map.id,a))},check:function(){if(this.enabled&&!this.enabling){var a,b,c=this.map.id;b=this.depExports;var h=this.exports,k=this.factory;if(!this.inited)x(l.defQueueMap,c)||this.fetch();else if(this.error)this.emit("error",this.error);else if(!this.defining){this.defining=!0;if(1>this.depCount&&!this.defined){if(K(k)){if(this.events.error&&this.map.isDefine||g.onError!==
ha)try{h=l.execCb(c,k,b,h)}catch(d){a=d}else h=l.execCb(c,k,b,h);this.map.isDefine&&void 0===h&&((b=this.module)?h=b.exports:this.usingExports&&(h=this.exports));if(a)return a.requireMap=this.map,a.requireModules=this.map.isDefine?[this.map.id]:null,a.requireType=this.map.isDefine?"define":"require",A(this.error=a)}else h=k;this.exports=h;if(this.map.isDefine&&!this.ignore&&(v[c]=h,g.onResourceLoad)){var f=[];y(this.depMaps,function(a){f.push(a.normalizedMap||a)});g.onResourceLoad(l,this.map,f)}C(c);
this.defined=!0}this.defining=!1;this.defined&&!this.defineEmitted&&(this.defineEmitted=!0,this.emit("defined",this.exports),this.defineEmitComplete=!0)}}},callPlugin:function(){var a=this.map,b=a.id,d=q(a.prefix);this.depMaps.push(d);w(d,"defined",z(this,function(h){var k,f,d=e(fa,this.map.id),M=this.map.name,r=this.map.parentMap?this.map.parentMap.name:null,m=l.makeRequire(a.parentMap,{enableBuildCallback:!0});if(this.map.unnormalized){if(h.normalize&&(M=h.normalize(M,function(a){return c(a,r,!0)})||
""),f=q(a.prefix+"!"+M,this.map.parentMap),w(f,"defined",z(this,function(a){this.map.normalizedMap=f;this.init([],function(){return a},null,{enabled:!0,ignore:!0})})),h=e(t,f.id)){this.depMaps.push(f);if(this.events.error)h.on("error",z(this,function(a){this.emit("error",a)}));h.enable()}}else d?(this.map.url=l.nameToUrl(d),this.load()):(k=z(this,function(a){this.init([],function(){return a},null,{enabled:!0})}),k.error=z(this,function(a){this.inited=!0;this.error=a;a.requireModules=[b];D(t,function(a){0===
a.map.id.indexOf(b+"_unnormalized")&&C(a.map.id)});A(a)}),k.fromText=z(this,function(h,c){var d=a.name,f=q(d),M=S;c&&(h=c);M&&(S=!1);u(f);x(p.config,b)&&(p.config[d]=p.config[b]);try{g.exec(h)}catch(e){return A(F("fromtexteval","fromText eval for "+b+" failed: "+e,e,[b]))}M&&(S=!0);this.depMaps.push(f);l.completeLoad(d);m([d],k)}),h.load(a.name,m,k,p))}));l.enable(d,this);this.pluginMaps[d.id]=d},enable:function(){Z[this.map.id]=this;this.enabling=this.enabled=!0;y(this.depMaps,z(this,function(a,
b){var c,h;if("string"===typeof a){a=q(a,this.map.isDefine?this.map:this.map.parentMap,!1,!this.skipMap);this.depMaps[b]=a;if(c=e(R,a.id)){this.depExports[b]=c(this);return}this.depCount+=1;w(a,"defined",z(this,function(a){this.undefed||(this.defineDep(b,a),this.check())}));this.errback?w(a,"error",z(this,this.errback)):this.events.error&&w(a,"error",z(this,function(a){this.emit("error",a)}))}c=a.id;h=t[c];x(R,c)||!h||h.enabled||l.enable(a,this)}));D(this.pluginMaps,z(this,function(a){var b=e(t,a.id);
b&&!b.enabled&&l.enable(a,this)}));this.enabling=!1;this.check()},on:function(a,b){var c=this.events[a];c||(c=this.events[a]=[]);c.push(b)},emit:function(a,b){y(this.events[a],function(a){a(b)});"error"===a&&delete this.events[a]}};l={config:p,contextName:b,registry:t,defined:v,urlFetched:W,defQueue:G,defQueueMap:{},Module:da,makeModuleMap:q,nextTick:g.nextTick,onError:A,configure:function(a){a.baseUrl&&"/"!==a.baseUrl.charAt(a.baseUrl.length-1)&&(a.baseUrl+="/");if("string"===typeof a.urlArgs){var b=
a.urlArgs;a.urlArgs=function(a,c){return(-1===c.indexOf("?")?"?":"&")+b}}var c=p.shim,h={paths:!0,bundles:!0,config:!0,map:!0};D(a,function(a,b){h[b]?(p[b]||(p[b]={}),Y(p[b],a,!0,!0)):p[b]=a});a.bundles&&D(a.bundles,function(a,b){y(a,function(a){a!==b&&(fa[a]=b)})});a.shim&&(D(a.shim,function(a,b){L(a)&&(a={deps:a});!a.exports&&!a.init||a.exportsFn||(a.exportsFn=l.makeShimExports(a));c[b]=a}),p.shim=c);a.packages&&y(a.packages,function(a){var b;a="string"===typeof a?{name:a}:a;b=a.name;a.location&&
(p.paths[b]=a.location);p.pkgs[b]=a.name+"/"+(a.main||"main").replace(na,"").replace(U,"")});D(t,function(a,b){a.inited||a.map.unnormalized||(a.map=q(b,null,!0))});(a.deps||a.callback)&&l.require(a.deps||[],a.callback)},makeShimExports:function(a){return function(){var b;a.init&&(b=a.init.apply(ga,arguments));return b||a.exports&&ia(a.exports)}},makeRequire:function(a,n){function m(c,d,f){var e,r;n.enableBuildCallback&&d&&K(d)&&(d.__requireJsBuild=!0);if("string"===typeof c){if(K(d))return A(F("requireargs",
"Invalid require call"),f);if(a&&x(R,c))return R[c](t[a.id]);if(g.get)return g.get(l,c,a,m);e=q(c,a,!1,!0);e=e.id;return x(v,e)?v[e]:A(F("notloaded",'Module name "'+e+'" has not been loaded yet for context: '+b+(a?"":". Use require([])")))}P();l.nextTick(function(){P();r=u(q(null,a));r.skipMap=n.skipMap;r.init(c,d,f,{enabled:!0});H()});return m}n=n||{};Y(m,{isBrowser:E,toUrl:function(b){var d,f=b.lastIndexOf("."),g=b.split("/")[0];-1!==f&&("."!==g&&".."!==g||1<f)&&(d=b.substring(f,b.length),b=b.substring(0,
f));return l.nameToUrl(c(b,a&&a.id,!0),d,!0)},defined:function(b){return x(v,q(b,a,!1,!0).id)},specified:function(b){b=q(b,a,!1,!0).id;return x(v,b)||x(t,b)}});a||(m.undef=function(b){B();var c=q(b,a,!0),f=e(t,b);f.undefed=!0;d(b);delete v[b];delete W[c.url];delete ea[b];X(G,function(a,c){a[0]===b&&G.splice(c,1)});delete l.defQueueMap[b];f&&(f.events.defined&&(ea[b]=f.events),C(b))});return m},enable:function(a){e(t,a.id)&&u(a).enable()},completeLoad:function(a){var b,c,d=e(p.shim,a)||{},g=d.exports;
for(B();G.length;){c=G.shift();if(null===c[0]){c[0]=a;if(b)break;b=!0}else c[0]===a&&(b=!0);I(c)}l.defQueueMap={};c=e(t,a);if(!b&&!x(v,a)&&c&&!c.inited)if(!p.enforceDefine||g&&ia(g))I([a,d.deps||[],d.exportsFn]);else return m(a)?void 0:A(F("nodefine","No define call for "+a,null,[a]));H()},nameToUrl:function(a,b,c){var d,k,f,m;(d=e(p.pkgs,a))&&(a=d);if(d=e(fa,a))return l.nameToUrl(d,b,c);if(g.jsExtRegExp.test(a))d=a+(b||"");else{d=p.paths;k=a.split("/");for(f=k.length;0<f;--f)if(m=k.slice(0,f).join("/"),
m=e(d,m)){L(m)&&(m=m[0]);k.splice(0,f,m);break}d=k.join("/");d+=b||(/^data\:|^blob\:|\?/.test(d)||c?"":".js");d=("/"===d.charAt(0)||d.match(/^[\w\+\.\-]+:/)?"":p.baseUrl)+d}return p.urlArgs&&!/^blob\:/.test(d)?d+p.urlArgs(a,d):d},load:function(a,b){g.load(l,a,b)},execCb:function(a,b,c,d){return b.apply(d,c)},onScriptLoad:function(a){if("load"===a.type||oa.test((a.currentTarget||a.srcElement).readyState))N=null,a=O(a),l.completeLoad(a.id)},onScriptError:function(a){var b=O(a);if(!m(b.id)){var c=[];
D(t,function(a,d){0!==d.indexOf("_@r")&&y(a.depMaps,function(a){if(a.id===b.id)return c.push(d),!0})});return A(F("scripterror",'Script error for "'+b.id+(c.length?'", needed by: '+c.join(", "):'"'),a,[b.id]))}}};l.require=l.makeRequire();return l}function pa(){if(N&&"interactive"===N.readyState)return N;X(document.getElementsByTagName("script"),function(b){if("interactive"===b.readyState)return N=b});return N}var g,B,C,H,O,I,N,P,u,T,qa=/(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,ra=/[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
U=/\.js$/,na=/^\.\//;B=Object.prototype;var Q=B.toString,la=B.hasOwnProperty,E=!("undefined"===typeof window||"undefined"===typeof navigator||!window.document),ja=!E&&"undefined"!==typeof importScripts,oa=E&&"PLAYSTATION 3"===navigator.platform?/^complete$/:/^(complete|loaded)$/,ca="undefined"!==typeof opera&&"[object Opera]"===opera.toString(),J={},w={},V=[],S=!1;if("undefined"===typeof define){if("undefined"!==typeof requirejs){if(K(requirejs))return;w=requirejs;requirejs=void 0}"undefined"===typeof require||
K(require)||(w=require,require=void 0);g=requirejs=function(b,c,d,m){var r,q="_";L(b)||"string"===typeof b||(r=b,L(c)?(b=c,c=d,d=m):b=[]);r&&r.context&&(q=r.context);(m=e(J,q))||(m=J[q]=g.s.newContext(q));r&&m.configure(r);return m.require(b,c,d)};g.config=function(b){return g(b)};g.nextTick="undefined"!==typeof setTimeout?function(b){setTimeout(b,4)}:function(b){b()};require||(require=g);g.version="2.2.0";g.jsExtRegExp=/^\/|:|\?|\.js$/;g.isBrowser=E;B=g.s={contexts:J,newContext:ma};g({});y(["toUrl",
"undef","defined","specified"],function(b){g[b]=function(){var c=J._;return c.require[b].apply(c,arguments)}});E&&(C=B.head=document.getElementsByTagName("head")[0],H=document.getElementsByTagName("base")[0])&&(C=B.head=H.parentNode);g.onError=ha;g.createNode=function(b,c,d){c=b.xhtml?document.createElementNS("http://www.w3.org/1999/xhtml","html:script"):document.createElement("script");c.type=b.scriptType||"text/javascript";c.charset="utf-8";c.async=!0;return c};g.load=function(b,c,d){var m=b&&b.config||
{},e;if(E){e=g.createNode(m,c,d);e.setAttribute("data-requirecontext",b.contextName);e.setAttribute("data-requiremodule",c);!e.attachEvent||e.attachEvent.toString&&0>e.attachEvent.toString().indexOf("[native code")||ca?(e.addEventListener("load",b.onScriptLoad,!1),e.addEventListener("error",b.onScriptError,!1)):(S=!0,e.attachEvent("onreadystatechange",b.onScriptLoad));e.src=d;if(m.onNodeCreated)m.onNodeCreated(e,m,c,d);P=e;H?C.insertBefore(e,H):C.appendChild(e);P=null;return e}if(ja)try{setTimeout(function(){},
0),importScripts(d),b.completeLoad(c)}catch(q){b.onError(F("importscripts","importScripts failed for "+c+" at "+d,q,[c]))}};E&&!w.skipDataMain&&X(document.getElementsByTagName("script"),function(b){C||(C=b.parentNode);if(O=b.getAttribute("data-main"))return u=O,w.baseUrl||-1!==u.indexOf("!")||(I=u.split("/"),u=I.pop(),T=I.length?I.join("/")+"/":"./",w.baseUrl=T),u=u.replace(U,""),g.jsExtRegExp.test(u)&&(u=O),w.deps=w.deps?w.deps.concat(u):[u],!0});define=function(b,c,d){var e,g;"string"!==typeof b&&
(d=c,c=b,b=null);L(c)||(d=c,c=null);!c&&K(d)&&(c=[],d.length&&(d.toString().replace(qa,ka).replace(ra,function(b,d){c.push(d)}),c=(1===d.length?["require"]:["require","exports","module"]).concat(c)));S&&(e=P||pa())&&(b||(b=e.getAttribute("data-requiremodule")),g=J[e.getAttribute("data-requirecontext")]);g?(g.defQueue.push([b,c,d]),g.defQueueMap[b]=!0):V.push([b,c,d])};define.amd={jQuery:!0};g.exec=function(b){return eval(b)};g(w)}})(this);

window.whatInput = (function() {

  'use strict';

  /*
    ---------------
    variables
    ---------------
  */

  // array of actively pressed keys
  var activeKeys = [];

  // cache document.body
  var body;

  // boolean: true if touch buffer timer is running
  var buffer = false;

  // the last used input type
  var currentInput = null;

  // `input` types that don't accept text
  var nonTypingInputs = [
    'button',
    'checkbox',
    'file',
    'image',
    'radio',
    'reset',
    'submit'
  ];

  // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  var mouseWheel = detectWheel();

  // list of modifier keys commonly used with the mouse and
  // can be safely ignored to prevent false keyboard detection
  var ignoreMap = [
    16, // shift
    17, // control
    18, // alt
    91, // Windows key / left Apple cmd
    93  // Windows menu / right Apple cmd
  ];

  // mapping of events to input types
  var inputMap = {
    'keydown': 'keyboard',
    'keyup': 'keyboard',
    'mousedown': 'mouse',
    'mousemove': 'mouse',
    'MSPointerDown': 'pointer',
    'MSPointerMove': 'pointer',
    'pointerdown': 'pointer',
    'pointermove': 'pointer',
    'touchstart': 'touch'
  };

  // add correct mouse wheel event mapping to `inputMap`
  inputMap[detectWheel()] = 'mouse';

  // array of all used input types
  var inputTypes = [];

  // mapping of key codes to a common name
  var keyMap = {
    9: 'tab',
    13: 'enter',
    16: 'shift',
    27: 'esc',
    32: 'space',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down'
  };

  // map of IE 10 pointer events
  var pointerMap = {
    2: 'touch',
    3: 'touch', // treat pen like touch
    4: 'mouse'
  };

  // touch buffer timer
  var timer;


  /*
    ---------------
    functions
    ---------------
  */

  // allows events that are also triggered to be filtered out for `touchstart`
  function eventBuffer() {
    clearTimer();
    setInput(event);

    buffer = true;
    timer = window.setTimeout(function() {
      buffer = false;
    }, 650);
  }

  function bufferedEvent(event) {
    if (!buffer) setInput(event);
  }

  function unBufferedEvent(event) {
    clearTimer();
    setInput(event);
  }

  function clearTimer() {
    window.clearTimeout(timer);
  }

  function setInput(event) {
    var eventKey = key(event);
    var value = inputMap[event.type];
    if (value === 'pointer') value = pointerType(event);

    // don't do anything if the value matches the input type already set
    if (currentInput !== value) {
      var eventTarget = target(event);
      var eventTargetNode = eventTarget.nodeName.toLowerCase();
      var eventTargetType = (eventTargetNode === 'input') ? eventTarget.getAttribute('type') : null;

      if (
        (// only if the user flag to allow typing in form fields isn't set
        !body.hasAttribute('data-whatinput-formtyping') &&

        // only if currentInput has a value
        currentInput &&

        // only if the input is `keyboard`
        value === 'keyboard' &&

        // not if the key is `TAB`
        keyMap[eventKey] !== 'tab' &&

        // only if the target is a form input that accepts text
        (
           eventTargetNode === 'textarea' ||
           eventTargetNode === 'select' ||
           (eventTargetNode === 'input' && nonTypingInputs.indexOf(eventTargetType) < 0)
        )) || (
          // ignore modifier keys
          ignoreMap.indexOf(eventKey) > -1
        )
      ) {
        // ignore keyboard typing
      } else {
        switchInput(value);
      }
    }

    if (value === 'keyboard') logKeys(eventKey);
  }

  function switchInput(string) {
    currentInput = string;
    body.setAttribute('data-whatinput', currentInput);

    if (inputTypes.indexOf(currentInput) === -1) inputTypes.push(currentInput);
  }

  function key(event) {
    return (event.keyCode) ? event.keyCode : event.which;
  }

  function target(event) {
    return event.target || event.srcElement;
  }

  function pointerType(event) {
    if (typeof event.pointerType === 'number') {
      return pointerMap[event.pointerType];
    } else {
      return (event.pointerType === 'pen') ? 'touch' : event.pointerType; // treat pen like touch
    }
  }

  // keyboard logging
  function logKeys(eventKey) {
    if (activeKeys.indexOf(keyMap[eventKey]) === -1 && keyMap[eventKey]) activeKeys.push(keyMap[eventKey]);
  }

  function unLogKeys(event) {
    var eventKey = key(event);
    var arrayPos = activeKeys.indexOf(keyMap[eventKey]);

    if (arrayPos !== -1) activeKeys.splice(arrayPos, 1);
  }

  function bindEvents() {
    body = document.body;

    // pointer events (mouse, pen, touch)
    if (window.PointerEvent) {
      body.addEventListener('pointerdown', bufferedEvent);
      body.addEventListener('pointermove', bufferedEvent);
    } else if (window.MSPointerEvent) {
      body.addEventListener('MSPointerDown', bufferedEvent);
      body.addEventListener('MSPointerMove', bufferedEvent);
    } else {

      // mouse events
      body.addEventListener('mousedown', bufferedEvent);
      body.addEventListener('mousemove', bufferedEvent);

      // touch events
      if ('ontouchstart' in window) {
        body.addEventListener('touchstart', eventBuffer);
      }
    }

    // mouse wheel
    body.addEventListener(mouseWheel, bufferedEvent);

    // keyboard events
    body.addEventListener('keydown', unBufferedEvent);
    body.addEventListener('keyup', unBufferedEvent);
    document.addEventListener('keyup', unLogKeys);
  }


  /*
    ---------------
    utilities
    ---------------
  */

  // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  function detectWheel() {
    return mouseWheel = 'onwheel' in document.createElement('div') ?
      'wheel' : // Modern browsers support "wheel"

      document.onmousewheel !== undefined ?
        'mousewheel' : // Webkit and IE support at least "mousewheel"
        'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
  }


  /*
    ---------------
    init
    don't start script unless browser cuts the mustard,
    also passes if polyfills are used
    ---------------
  */

  if (
    'addEventListener' in window &&
    Array.prototype.indexOf
  ) {

    // if the dom is already ready already (script was placed at bottom of <body>)
    if (document.body) {
      bindEvents();

    // otherwise wait for the dom to load (script was placed in the <head>)
    } else {
      document.addEventListener('DOMContentLoaded', bindEvents);
    }
  }


  /*
    ---------------
    api
    ---------------
  */

  return {

    // returns string: the current input type
    ask: function() { return currentInput; },

    // returns array: currently pressed keys
    keys: function() { return activeKeys; },

    // returns array: all the detected input types
    types: function() { return inputTypes; },

    // accepts string: manually set the input type
    set: switchInput
  };

}());

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-localstorage-addtest-mq-prefixes-setclasses-shiv-teststyles !*/
!function(e,t,n){function r(e,t){return typeof e===t}function o(){var e,t,n,o,a,i,s;for(var l in f)if(f.hasOwnProperty(l)){if(e=[],t=f[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,a=0;a<e.length;a++)i=e[a],s=i.split("."),1===s.length?Modernizr[s[0]]=o:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=o),u.push((o?"":"no-")+s.join("-"))}}function a(e){var t=h.className,n=Modernizr._config.classPrefix||"";if(p&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),p?h.className.baseVal=t:h.className=t)}function i(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):p?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function s(){var e=t.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,n,r,o){var a,l,c,u,f="modernizr",d=i("div"),m=s();if(parseInt(r,10))for(;r--;)c=i("div"),c.id=o?o[r]:f+(r+1),d.appendChild(c);return a=i("style"),a.type="text/css",a.id="s"+f,(m.fake?m:d).appendChild(a),m.appendChild(d),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(t.createTextNode(e)),d.id=f,m.fake&&(m.style.background="",m.style.overflow="hidden",u=h.style.overflow,h.style.overflow="hidden",h.appendChild(m)),l=n(d,e),m.fake?(m.parentNode.removeChild(m),h.style.overflow=u,h.offsetHeight):d.parentNode.removeChild(d),!!l}function c(e,t){if("object"==typeof e)for(var n in e)v(e,n)&&c(n,e[n]);else{e=e.toLowerCase();var r=e.split("."),o=Modernizr[r[0]];if(2==r.length&&(o=o[r[1]]),"undefined"!=typeof o)return Modernizr;t="function"==typeof t?t():t,1==r.length?Modernizr[r[0]]=t:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=t),a([(t&&0!=t?"":"no-")+r.join("-")]),Modernizr._trigger(e,t)}return Modernizr}var u=[],f=[],d={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){f.push({name:e,fn:t,options:n})},addAsyncTest:function(e){f.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr,Modernizr.addTest("localstorage",function(){var e="modernizr";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(t){return!1}});var m=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=m;var h=t.documentElement,p="svg"===h.nodeName.toLowerCase();p||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=E.elements;return"string"==typeof e?e.split(" "):e}function o(e,t){var n=E.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),E.elements=n+" "+e,c(t)}function a(e){var t=y[e[g]];return t||(t={},v++,e[g]=v,y[v]=t),t}function i(e,n,r){if(n||(n=t),f)return n.createElement(e);r||(r=a(n));var o;return o=r.cache[e]?r.cache[e].cloneNode():p.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!o.canHaveChildren||h.test(e)||o.tagUrn?o:r.frag.appendChild(o)}function s(e,n){if(e||(e=t),f)return e.createDocumentFragment();n=n||a(e);for(var o=n.frag.cloneNode(),i=0,s=r(),l=s.length;l>i;i++)o.createElement(s[i]);return o}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return E.shivMethods?i(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(E,t.frag)}function c(e){e||(e=t);var r=a(e);return!E.shivCSS||u||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),f||l(e,r),e}var u,f,d="3.7.3",m=e.html5||{},h=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,p=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g="_html5shiv",v=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",u="hidden"in e,f=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){u=!0,f=!0}}();var E={elements:m.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:d,shivCSS:m.shivCSS!==!1,supportsUnknownElements:f,shivMethods:m.shivMethods!==!1,type:"default",shivDocument:c,createElement:i,createDocumentFragment:s,addElements:o};e.html5=E,c(t),"object"==typeof module&&module.exports&&(module.exports=E)}("undefined"!=typeof e?e:this,t);var g=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return l("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}();d.mq=g;var v;d.testStyles=l;!function(){var e={}.hasOwnProperty;v=r(e,"undefined")||r(e.call,"undefined")?function(e,t){return t in e&&r(e.constructor.prototype[t],"undefined")}:function(t,n){return e.call(t,n)}}(),d._l={},d.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},d._trigger=function(e,t){if(this._l[e]){var n=this._l[e];setTimeout(function(){var e,r;for(e=0;e<n.length;e++)(r=n[e])(t)},0),delete this._l[e]}},Modernizr._q.push(function(){d.addTest=c}),o(),a(u),delete d.addTest,delete d.addAsyncTest;for(var y=0;y<Modernizr._q.length;y++)Modernizr._q[y]();e.Modernizr=Modernizr}(window,document);
/**
 * define jquery
 */
define('jquery', [], function() {
    return jQuery;
});

/**
 * auto load page specific js
 */
if (page_handle in path) {
	require([path[page_handle]]);
}
/**
 * utilities
 *
 * nodelist foreach polyfill for ie
 * remove polyfill for ie
 * custom event polyfill for ie
 * extend
 * namespace
 * ready
 * dom event
 * add event
 * remove event
 * get url parameter
 * debounce
 * media query
 * ajax
 * replace
 * is visible
 * has class
 * add class
 * remove class
 * transition
 * get hidden height
 * window resize
 * hide
 * show
 * get hidden height
 * slide up
 * slide down
 * get sized image url
 * remove protocol
 * format price
 * format price number
 * format price display
 * serialize
 * object to query string
 * is object
 * is object empty
 * get query string
 * encode
 * scroll to
 * index
 * waypoint
 * remap size values
 * array to lower
 * reduce array
 * loadJSONP
 * to number
 */

/**
 * nodelist foreach polyfill for ie
 */
(function () {
	if (typeof NodeList.prototype.forEach === 'function') return false;
	NodeList.prototype.forEach = Array.prototype.forEach;
})();

/**
 * remove polyfill for ie
 */
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/**
 * custom event polyfill for ie
 */
(function () {
	if ( typeof window.CustomEvent === 'function' ) return false;
	function CustomEvent ( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent( 'CustomEvent' );
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}
	CustomEvent.prototype = window.Event.prototype;
	window.CustomEvent = CustomEvent;
})();

/**
 * ready
 * equivalent of jQuery's $(document).ready();
 * @param  {Function} fn function to run when the document is ready
 * @return {Function} Rturns passed function when document is ready.
 */
_.ready = function(fn) {
	if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'){
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
};

/**
 * extend
 * extends a js object
 * @param  {Object} config
 * @param  {Object} obj
 * @return {Object}
 */
_.extend = function(config, obj) {
	obj = obj || {};
	Object.keys(config).forEach(function(key) {
		if (obj[key] === undefined) {
			obj[key] = config[key];
		} else {
			if (obj[key] && _.isObject(obj[key])) {
				if (typeof config[key] === 'object') {
					Object.keys(config[key]).forEach(function(childKey) {
						if (obj[key][childKey] === undefined) {
							obj[key][childKey] = config[key][childKey];
						}
					});
				}

			}
		}
	});

	return obj;
};

/**
 * namespace
 * @param  {Object} obj
 * @param  {String} Name
 * @return {Object}
 */
_.namespace = function(obj,name) {
	obj = obj || {};

	obj = JSON.parse(JSON.stringify(obj));

	var	objNode,
		namedVar;

	if (obj) {
		if (obj && _.isObject(obj)) {
			Object.keys(obj).forEach(function(key) {
				if (obj[key]) {
					if (typeof(obj[key]) !== 'object') {
						objNode = obj[key].toString();
						namedVar = name + objNode.charAt(0).toUpperCase() + objNode.slice(1);
						obj[key] = namedVar;
					} else if (Array.isArray(obj[key])) {
						obj[key].forEach(function(id, idx, arr) {
							objNode = name + id.charAt(0).toUpperCase() + id.slice(1);
							arr[idx] = objNode;
						});
					}
				}
			});
		} else {
			console.warn('obj is not defined, or is not an object');
		}
	}

	return obj;
};

/**
 * Dom Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 * @param {boolean} - applyEvent - Dictates whether to addEventListener or removeEventListener
 */
_.domEvent = function(opts,applyE) {
	var c = opts,
		eApply = applyE !== undefined ? applyE : true,
		$id,
		$class,
		isString,
		hasIds,
		hasEvents,
		$trigger,
		i,
		idArr,
		eventArr;

	/**
	 * init
	 * @return {function} Checks if c.id, c.fn, and c.event are defined. If not add event is skipped. This also maps the variables for $id and domClass
	 */
	function init() {
		if (c.id) { // Is c.id set?

			if (c.fn  || c.event) { // If c.fn and c.event are set then execute functions.

				checkForArray();

				if (hasIds) {
					idArr = c.id.split(',');

					for (i=0;i<idArr.length;i++) {
						c.id = idArr[i];
						bindEvents();
					}

				} else {
					bindEvents();
				}

			} else {
				if (c.fn === null) { // Check if c.fn is set, if not warn the developer.
					console.warn('No function defined.');
				}
				if (c.event === null) { // Check if c.event is set, if not warn the developer.
					console.warn('No event defined.');
				}
			}
		} else { // if c.id is not set, then warn the developer.
			console.warn('No ID defined.');
		}
	}

	/**
	 * check for array
	 */
	function checkForArray() {
		isString = typeof(c.id) === 'string' ? true : false;

		if (isString) {
			hasIds = _.isDelimitedArray(c.id);
		}

		hasEvents = _.isDelimitedArray(c.event);
	}

	/**
	 * bind events
	 * @type {Function}
	 */
	function bindEvents() {

		mapVars(); // Map vas called inside c.fn and c.event check to avoid unnecessary DOM search.

		if (c.className) {
			bindLoop(); // If a class value was set, bind the event to dom elements within a parent id.
		} else {
			bindSingle(); // If only an id was set and no className, then bind the event to a single id.
		}
	}

	/**
	 * map vars
	 * @return {function} Sets domId variable and if c.className exists, sets domClass value.
	 */
	function mapVars() {

		if (isString) {
			$id = document.getElementById(c.id);
		} else {
			$id = c.id;
		}

		if ($id) {
			if (c.className === null) {
				$class = null;
			} else {
				$class = $id.querySelectorAll('.' + c.className);
			}
		} else {
			if (isString) {
				console.warn('Could not find id '+ c.id);
			} else {
				console.warn('Could not find element.');
			}
		}
	}

	/**
	 * bind loop
	 * @return {function} Bind events to dom elements within the defined c.id dom element.
	 */
	function bindLoop() {
		if ($class) {
			for (i=0;i<$class.length;i++) {
				$trigger = $class[i];

				if ($trigger) {

					if (eApply) {
						if (hasEvents) {

							eventArr = c.event.split(',');

							for (i=0;i<eventArr.length;i++) {
								$trigger.addEventListener(eventArr[i],c.fn,null);
							}

						} else {
							$trigger.addEventListener(c.event,c.fn,null);
						}
					} else {
						$trigger.removeEventListener(c.event,c.fn,null);
					}
				}
			}
		}
	}

	/**
	 * bind single
	 * @return {function} Add event listener to a single dom element based on id.
	 */
	function bindSingle() {
		if ($id) {

			if (eApply) {
				if (hasEvents) {
					eventArr = c.event.split(',');

					for (i=0;i<eventArr.length;i++) {
						$id.addEventListener(eventArr[i],c.fn,null);
					}
				} else {
					$id.addEventListener(c.event,c.fn,null);
				}

			} else {
				$id.removeEventListener(c.event,c.fn,null);
			}
		}
	}

	return init();
};

/**
 * Add Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 */
_.addEvent = function(opts) {
	if (opts === undefined) {
		console.warn('_.addEvent requires a config object.');
	} else {
		_.domEvent(opts,true);
	}
};

 /**
  * Remove Event
  * @type {function}
  * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
  * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
  * @param {object | string} object.event - Event which triggers the function.
  * @param {object.function} object.fn - Function to bind to each element.
  */
_.removeEvent = function(opts) {
	if (opts === undefined) {
		console.warn('_.removeEvent requires a config object.');
	} else {
		_.domEvent(opts,false);
	}
};

/**
 * trigger event
 * @param  {object} el - Element that event is being triggered on. Must pass selected dom element, not just a string.
 * @param  {string} eventName - Name of custom event that needs to be trigger.
 * @param  {boolean} bubbles - A Boolean indicating whether the event bubbles up through the DOM or not. Default: true
 * @param  {boolean} cancelable - A Boolean indicating whether the event is cancelable. Default: true
 * @return {function} - Dispatches the custom event that's bound to the element.
 */
_.trigger = function(el,eventName,bubbles,cancelable) {
	if (el === undefined || eventName === undefined) return false;
	if (bubbles === undefined) bubbles = true;
	if (cancelable === undefined) cancelable = true;
	var event = new CustomEvent(eventName,{
		detail: {
			message: el,
			time: new Date()
		},
		bubbles: bubbles,
		cancelable: cancelable
	});
	el.dispatchEvent(event);
};

/**
 * get url parameter
 * @param {string} sParam - parameter name
 */
_.getUrlParameter = function(sParam) {
	var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
};

/**
 * debounce
 * @param {fn} The function that needs to be debounce
 * @param {int} Miliseconds for how often to execute the function
 * @param {boolean} Execute immediately or after function is complete
 */
_.debounce = function(func, threshold, execAsap) {
	var timeout;
	return function debounced () {
		var obj = this, args = arguments;

		function delayed () {
			if (!execAsap)
				func.apply(obj, args);
			timeout = null;
		}

		if (timeout)
			clearTimeout(timeout);
		else if (execAsap)
			func.apply(obj, args);

		timeout = setTimeout(delayed, threshold || 100);
	};
};

/**
 * media query
 * @param {object} argument object
 * @param {string} object.view - the targetted screen size to execute the function
 * @param {fn} oject.callback - function to execute
 * @param {object} oject.views - array of available views that can be targetted
 */
_.mq = function(opts) {
	var config = {
		callback : null,
		view	: null,
		views : {
			smallest_phone			: '(max-width:374px)',
			small_phone 			: '(max-width:640px)',
			phone 					: '(max-width:767px)',
			mobile					: '(max-width:1024px)',
			phone_to_desktop		: '(min-width:563px)',
			tablet					: '(min-width:768px)',
			tablet_only 			: '(min-width:768px) and (max-width:1024px)',
			tablet_portrait 		: '(min-width:768px) and (max-width:979px)',
			tablet_landscape 		: '(min-width:980px) and (max-width:1024px)',
			desktop					: '(min-width:1025px)',
			desktop_to_large    	: '(min-width:1025px) and (max-width:1280px)',
			desktop_large			: '(min-width:1281px)',
			desktop_large_to_huge 	: '(min-width:1281px) and (max-width:1400px)',
			desktop_huge			: '(min-width:1401px)'
		}
	},

	c = _.extend(config,opts),

	currentView = null,

	mq = {
		init : function() {

			if (c.view) {

				Object.keys(c.views).forEach(function(key) {
					if (key === c.view) {
						currentView = c.views[key];
					}
				});

				var query = window.matchMedia(currentView);

				if (query.matches === true) {
					if (typeof c.callback === 'function') {
						c.callback();
					}
				}

			}

		}
	};

	return mq.init();
};

/**
 * ajax
 * @param  {Object} opts
 * @return {_.ajax~init}
 */
_.ajax = function(opts) {
	var config = {
		cache: false,
		contentType: null,
		data: null,
		dataObject: {},
		headers: {},
		type: null,
		url: null,
		success: function(resp){
			console.log(resp);
		},
		error: function(resp) {
			console.warn(resp);
		}
	},

	c = _.extend(config,opts),
	url = c.cache ? c.url : c.url + '?ts=' + Date.now().toString(),
	xhr;

	/**
	 * init
	 */
	function init() {
		xhr = new XMLHttpRequest();
		xhr.open(c.type,url,true);
		setHeaders(xhr);
		xhr.onload = onLoadHandler;
		xhr.onError = errorHandler;

		if (c.data) {
			xhr.send(_.objectToQueryString(c.data));
		} else {
			if (c.dataObject) {
				xhr.send(_.objectToQueryString(c.dataObject));
			} else {
				console.warn('data is not defined.');
			}
		}
	}

	/**
	 * set headers
	 * @param {Object} xhr
	 */
	function setHeaders(xhr) {
		var defaultContentType = 'application/x-www-form-urlencoded; charset=UTF-8',
			contentType = c.contentType ? c.contentType : defaultContentType,
			headers = c.headers;

		if (! _.isObjectEmpty(headers)) {
			if (! hasContentType(headers)) {
				headers['Content-Type'] = defaultContentType;
			}
			Object.keys(headers).forEach(function(name) {
				xhr.setRequestHeader(name, headers[name]);
			});
		} else {
			xhr.setRequestHeader('Content-Type', contentType);
		}
	}

	/**
	 * has content type
	 * @param  {Object}  headers
	 * @return {Boolean}
	 */
	function hasContentType(headers) {

		return Object.keys(headers).some(function(name) {
			return name.toLowerCase() === 'content-type';
		});
	}

	/**
	 * on load handler
	 * @callback
	 */
	function onLoadHandler() {
		var resp = xhr.responseText;

		// check if response text is an object.
		if (typeof resp !== 'object') {
			try {
				resp = JSON.parse(resp);
			} catch(e) {
			}
		}

		// check xhr status
		if (xhr.status >= 200 && xhr.status < 400) {

			// check if response has a status code
			if (resp.status) {
				// check status code for success
				if (resp.status >= 200 && resp.status < 400) {
					c.success(resp);
				} else {
					c.error(resp);
				}
			} else {
				c.success(resp);
			}

		} else {
			c.error(resp);
		}
	}

	/**
	 * on load handler
	 * @callback
	 */
	function errorHandler() {
		c.error(xhr.responseText);
	}

	return init();
};

/**
 * replace
 * @param  {string} string
 * @param  {string} needle   searched value
 * @param  {string} newValue new value you wish to replace the needle with
 * @return {string}
 */
_.replace = function(string, needle, newValue) {
	var newString;

	// if string contains needle, return new value
	if (string.indexOf(needle) !== -1) {
		newString = string.replace(needle, newValue);
	}

	// else return string as-is if needle could not be found
	else {
		newString = string;
	}

	return newString;
};

/**
 * is visible
 * @param  {element} el
 * @return {boolean}
 */
_.isVisible = function(el) {
	return el.offsetParent !== null;
};

/**
 * has class
 * @param  {element}  el
 * @param  {string}  className
 * @return {boolean}
 */
_.hasClass = function(el, className) {
	if (el.classList) {
		return el.classList.contains(className);
	}
	else {
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	}
};

/**
 * add class
 * @param {string} el
 * @param {string} className
 */
_.addClass = function(el, className) {

	if (!_.hasClass(el, className)) {
		if (el.classList) {
			el.classList.add(className);
		}
		else {
			el.className += ' ' + className;
		}
	}
};

/**
 * remove class
 * @param {element} el
 * @param {string} className
 */
_.removeClass = function(el, className) {
	if (_.hasClass(el, className)) {
		if (el.classList) {
			el.classList.remove(className);
		}
		else {
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}
};

/**
 * transition
 * fires a function before and after a timeout
 * @param {object} opts
 */
_.transition = function(opts) {
	if (opts.before === undefined) opts.before = null;
	if (opts.after === undefined) opts.before = null;
	if (opts.time === undefined) opts.time = 400;

	if (typeof opts.before === 'function') {
		opts.before();
	}

	if (typeof opts.after === 'function') {
		setTimeout(opts.after, opts.time);
	}
};

/**
 * get hidden height
 * @param {element}
 * @return {int}
 */
_.getHiddenStyles = function(el) {

	var $clone = el.cloneNode(true),
		$parent = el.parentNode,
		posVal = window.getComputedStyle($parent).position,
		body = document.body,
		docEl = document.documentElement,
		scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
		clientTop = docEl.clientTop || body.clientTop || 0,
		$cloneInDom = null,
		cloneHeight = null,
		cloneOffsetTop,
		clonePaddingTop = null,
		clonePaddingBottom = null,
		cloneRect;

	if (posVal === 'static') {
		$parent.style.position = 'relative';
	}

	// Add attribute to track element for deletion;
	$clone.setAttribute('data-clone','true');

	// Append the new cloen to to the parent.
	$parent.appendChild($clone);

	// Select that new clone
	$cloneInDom = $parent.querySelector('[data-clone="true"]');

	// Display the clone with visibility hidden so that size can be retrieved.
	$cloneInDom.style.height = 'auto';
	$cloneInDom.style.display = 'block';
	$cloneInDom.style.visibility = 'hidden';
	$cloneInDom.style.position = 'absolute';

	// Get Height
	cloneHeight = $cloneInDom.offsetHeight;

	// Get Padding Top
	clonePaddingTop = window.getComputedStyle($cloneInDom).paddingTop;

	// Get Padding Bottom;
	clonePaddingBottom = window.getComputedStyle($cloneInDom).paddingBottom;

	// Get Rectangle
	cloneRect = $cloneInDom.getBoundingClientRect();

	// Get OffsetTop
	cloneOffsetTop = Math.round(cloneRect.top + scrollTop - clientTop);

	// Delete the clone
	$cloneInDom.remove();

	// Remove the position value added to the parent when its static.
	if (posVal === 'static') {
		$parent.style.position = '';
	}

	// Return values
	return {
		elHeight: cloneHeight,
		elOffsetTop: cloneOffsetTop,
		elPaddingTop: clonePaddingTop,
		elPaddingBottom: clonePaddingBottom
	};
};

/**
 * window resize
 * Run functions on window resize.
 * @param {function} function to call on window resize
 * @param {int} how often in miliseconds to fire the debounced function
 * @param {boolean} sets whether to execute the function as soon as possible or not.
 */
_.windowResize = function(fn,threshold,execAsap) {
	if (fn === undefined) fn = null;
	if (threshold === undefined) threshold = 100;
	if (execAsap === undefined) execAsap = false;

	if (fn) {
		window.addEventListener('resize',_.debounce(fn,threshold,execAsap));
	} else {
		console.warn('No function defined.');
	}
};

/**
 * hide
 * @param {Object} obj - dom element to hide
 */
_.hide = function(obj) {
	if (obj && obj.style.display !== 'none') {
		obj.style.display = 'none';
	}
};

/**
 * show
 */
_.show = function(obj) {
	if (obj && obj.style.display === 'none') {
		obj.style.display = 'block';
	}
};

/**
 * slide up
 * @param {element} DOM Element
 * @param {int} Animation timer
 */
_.slideUp = function(el) {
	if (el === undefined) el = null;

	if (el) {
		el.style.height = el.offsetHeight + 'px';

		el.style.height = 0;
		el.style.paddingTop = 0;
		el.style.paddingBottom = 0;
	}
};

/**
 * slide down
 * @param {element} DOM Element
 * @param {int} Animation timer
 */
_.slideDown = function(el) {
	if (el === undefined) el = null;

	if (el) {
		var hiddenStyles = _.getHiddenStyles(el);
		var menuHeight = hiddenStyles.elHeight;
		var padTop = hiddenStyles.elPaddingTop;
		var padBottom = hiddenStyles.elPaddingBottom;

		el.style.display = 'block';
		el.style.paddingTop = 0;
		el.style.paddingBottom = 0;
        el.style.height = 0;


		setTimeout(function() {
	        el.style.height = menuHeight + 'px';
			el.style.paddingTop = padTop;
			el.style.paddingBottom = padBottom;
		},1);
	}
};

/**
 * get sized image url
 * @param  {string} imgUrl
 * @param  {string} size   image width, e.x. '250x'
 * @return {string}        resized image url
 */
_.getSizedImageUrl = function(imgUrl, size) {
	var i,
		n,
		r;

	if (! imgUrl) return '//cdn.searchspring.net/ajax_search/img/missing-image-75x75.gif';
	if (! size) return imgUrl;
	if (size === 'master') return _.removeProtocol(imgUrl);

	n = imgUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

	if (n !== null) {
		r = imgUrl.split(n[0]);
		i = n[0];
		return _.removeProtocol(r[0] + '_' + size + i);
	}
};

/**
 * remove protocol
 * @param  {string} url
 * @return {string}
 */
_.removeProtocol = function(url) {
	return url.replace(/http(s)?:/, '');
};

/**
 * format price
 * @param  {number} price e.x. "1200"
 * @return {string}       e.x. "12.00"
 */
_.formatPrice = function(price) {
	return (price / 100).toFixed(2);
};

/**
 * format price number
 * @param  {number} price e.x. "1200"
 * @return {number}       e.x. 12.00
 */
_.formatPriceNumber = function(price) {
	return parseFloat((price / 100).toFixed(2));
};

/**
 * format price display
 * @param  {number} price e.x. "1200"
 * @return {string}       e.x. "$12"
 */
_.formatPriceDisplay = function(price) {
	return '$' + _.formatPrice(price);
};

/**
 * number with commas
 */
_.numberWithCommas = function(n) {
	var c = '2',
	d = '.',
	t = ',';
	c = isNaN(c = Math.abs(c)) ? 2 : c;
	d = d === undefined ? '.' : d;
	t = t === undefined ? ',' : t;
	var s = n < 0 ? '-' : '',
	i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
	j = (j = i.length) > 3 ? j % 3 : 0;
	return '$' + s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};

/**
 * serialize
 * @param form object
 */
_.serialize = function(form,type) {
 	if (!form || form.nodeName !== 'FORM') {
 		return;
 	}

	var isDataObject = (type ? true : false);

 	var i, j, q = [], o = {};
 	for (i = form.elements.length - 1; i >= 0; i = i - 1) {
 		if (form.elements[i].name === '') {
 			continue;
 		}
 		switch (form.elements[i].nodeName) {
 		case 'INPUT':
 			switch (form.elements[i].type) {
 			case 'text':
 			case 'hidden':
 			case 'password':
 			case 'button':
 			case 'reset':
 			case 'submit':
 			case 'color':
 			case 'date':
 			case 'datetime-local':
 			case 'email':
 			case 'month':
 			case 'number':
 			case 'range':
 			case 'search':
 			case 'tel':
 			case 'time':
 			case 'url':
 			case 'week':
 				q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				break;
 			case 'checkbox':
 			case 'radio':
 				if (form.elements[i].checked) {
 					q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
					o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				}
 				break;
 			case 'file':
 				break;
 			}
 			break;
 		case 'TEXTAREA':
 			q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
			o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 			break;
 		case 'SELECT':
 			switch (form.elements[i].type) {
 			case 'select-one':
 				q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				break;
 			case 'select-multiple':
 				for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
 					if (form.elements[i].options[j].selected) {
 						q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].options[j].value));

						o[form.elements[i].name] = encodeURIComponent(form.elements[i].options[j].value);
 					}
 				}
 				break;
 			}
 			break;
 		case 'BUTTON':
 			switch (form.elements[i].type) {
 			case 'reset':
 			case 'submit':
 			case 'button':
 				q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				break;
 			}
 			break;
 		}
 	}

	if (isDataObject) {
		return o;
	} else {
	 	return q.join('&');
	}
};

/**
 * object to query string
 * if no object is provided, function will return original data
 * @param  {Object} data
 * @return {string}
 */
_.objectToQueryString = function(data) {
	return _.isObject(data) ? _.getQueryString(data) : data;
};

/**
 * is object
 * @param  {*}       data any type
 * @return {boolean}
 */
_.isObject = function(data) {
	return Object.prototype.toString.call(data) === '[object Object]';
};

/**
 * is delineated array
 * @param  {*}       data any type
 * @return {boolean}
 */
_.isDelimitedArray = function(str,delimiter) {
	if (!str) {
		console.warn('No string defined');
		return false;
	}

	if (!delimiter) {
		delimiter = ',';
	}

	return str.indexOf(delimiter) !== -1 ? true : false;
};

/**
 * is object empty
 * @param  {Object}  obj
 * @return {boolean}
 */
_.isObjectEmpty = function(obj) {
	return _.isObject(obj) && Object.keys(obj).length === 0;
};

/**
 * get query string
 * @param  {Object} object
 * @return {string}
 */
_.getQueryString = function(object) {
	return Object.keys(object).reduce(function(acc, item) {
		var prefix = ! acc ? '' : acc + '&';
		return prefix + _.encode(item) + '=' + _.encode(object[item]);
	}, '');
};

/**
 * encode
 * @param  {string} value
 * @return {string}
 */
_.encode = function(value) {
	return encodeURIComponent(value);
};

/**
 * Smooth scroll
 * @param  options [target: where you want the link to scroll to, link: the link you want to target with an ID ]
 */
 _.scrollTo = function(opts) {
 	var config = {
		callback: null,
		className: null,
		exec_now: false,
		id: null,
		offset: 0,
		target: null,
		timer: 500
 	},

 	c = _.extend(config, opts);

 	function init () {

		if (c.exec_now) {
			scroll();
		} else {
			if (c.id) {
				addEvents();
			} else {
				console.warn('no id defined');
			}
		}
 	}

 	function addEvents () {
		_.addEvent({
			id: c.id,
			className: c.className,
			event: 'click',
			fn: scroll
		});
 	}

    function scroll(e) {

		var start = window.pageYOffset,
			target = c.target ? c.target : this.getAttribute('href').replace('#',''),
			distance,
			duration,
			timeStart,
			timeElapsed;

		target = typeof target === 'string' ? document.getElementById(target) : target;

		if (target) {
			if (e) {
				e.preventDefault();
			}
		} else {
			return false;
		}

		distance = c.offset + target.getBoundingClientRect().top;

		duration = typeof c.timer === 'function' ? c.timer(distance) : c.timer;

		requestAnimationFrame(function(time) { timeStart = time; loop(time); });

		function loop(time) {
			timeElapsed = time - timeStart;

			window.scrollTo(0, easeInOutQuad(timeElapsed, start, distance, duration));

			if (timeElapsed < duration){
				requestAnimationFrame(loop);
			} else {
				end();
			}
		}

		function end() {
			window.scrollTo(0, start + distance);

			if (typeof c.callback === 'function'){
				c.callback();
			}

		}

 	}

	// Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
	function easeInOutQuad(t, b, c, d)  {
		t /= d / 2;
		if(t < 1) return c / 2 * t * t + b;
		t--;
		return -c / 2 * (t * (t - 2) - 1) + b;
	}

 	return init();

 };

 /**
  * is parent
  * @param  {Node} elem
  * @param  {String} selector
  * @return {Node}
  */
_.parents = function(elem, selector) {

    var parents = [];
    var firstChar;
    if ( selector ) {
        firstChar = selector.charAt(0);
    }

    // Get matches
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( selector ) {

            // If selector is a class
            if ( firstChar === '.' ) {
                if ( elem.classList.contains( selector.substr(1) ) ) {
                    parents.push( elem );
                }
            }

            // If selector is an ID
            if ( firstChar === '#' ) {
                if ( elem.id === selector.substr(1) ) {
                    parents.push( elem );
                }
            }

            // If selector is a data attribute
            if ( firstChar === '[' ) {
                if ( elem.hasAttribute( selector.substr(1, selector.length - 1) ) ) {
                    parents.push( elem );
                }
            }

            // If selector is a tag
            if ( elem.tagName.toLowerCase() === selector ) {
                parents.push( elem );
            }

        } else {
            parents.push( elem );
        }

    }

    // Return parents if any exist
    if ( parents.length === 0 ) {
        return null;
    } else {
        return parents;
    }

};

/**
 * index
 * @param  {Element} node
 * @return {Number}
 */
 _.index = function(node) {
	var c = node.parentNode.children, i = 0;
    for(; i < c.length; i++ )
        if( c[i] === node ) return i;
};

/**
 * waypoint
 * @param  {Object} opts
 * @return {_.waypoint~init}
 */
_.waypoint = function(opts) {
	var config = {
			el: null,
			in: null,
			out: null,
			offset: null
		},
		c = _.extend(config, opts);

	/**
	 * init
	 */
	function init() {
		addEvents();
		checkWindowPosition();
	}

	/**
	 * add events
	 */
	function addEvents() {

		// scroll
		window.addEventListener('scroll', checkWindowPosition, false);

		// resize
		_.windowResize(checkWindowPosition, 400);
	}

	/**
	 * check window position
	 */
	function checkWindowPosition() {
		var windowPos = window.pageYOffset || document.documentElement.scrollTop,
			elOffset = c.el.offsetTop,
			isPastEl;

			// offset
			if (c.offset) {
				elOffset -= c.offset;
			}

			isPastEl = windowPos > elOffset;

		if (isPastEl) {
			if (typeof c.in === 'function') c.in();
		} else {
			if (typeof c.out === 'function') c.out();
		}
	}

	return init();
};

/**
 * remap size values
 * @type {Function}
 * @return {String}
 * @desc This is used to remap short hand size values to full words
 */
_.remapSizeValues = function(val) {
	var label;

	if (val) {
		val = val.toLowerCase();
	}

	switch(val) {
		case 'xs':
			label = 'extra small';
			break;
		case 's':
			label = 'small';
			break;
		case 'm':
			label = 'medium';
			break;
		case 'l':
			label = 'large';
			break;
		case 'xl':
			label = 'extra large';
			break;
		case 'xxl':
			label = '2x Large';
			break;
		case '2xl':
			label = '2x Large';
			break;
		case 'xxxl':
			label = '3x Large';
			break;
		case '3xl':
			label = '3x Large';
			break;
		default:
			label = val;
			break;
	}

	return label;
};

/**
 * array to lower
 */
_.arrayToLower = function(r) {
	var c,
		i;
	if (Array.isArray(r)) {
		c = r.length;
		for (i=0;i<c;i++) {
			r[i] = r[i].toLowerCase();
		}
	} else {
		console.warn('argument not an array.');
		console.warn(r);
		return false;
	}

	return r;
};

/**
 * array to lower
 */
_.arrayToLower = function(r) {
	var c,
		i;
	if (Array.isArray(r)) {
		c = r.length;
		for (i=0;i<c;i++) {
			r[i] = r[i].toLowerCase();
		}
	} else {
		console.warn('argument not an array.');
		console.warn(r);
		return false;
	}

	return r;
};

/**
 * reduce array
 */
 _.reduceArray = function(r) {
 	var c,
 		i,
 		n = [],
 		o;
 	if (Array.isArray(r)) {
 		c = r.length;
 		for (i=0;i<c;i++) {
 			o = r[i];
 			if (n.indexOf(o) === -1) {
 				n.push(o);
 			}
 		}
 	} else {
 		console.warn('argument not an array.');
 		console.warn(r);
 		return false;
 	}

 	return n;
};

/**
 * loadJSONP( url, hollaback [, context] ) -> Null
 * - url (String): URL to data resource.
 * - hollaback (Function): Function to call when data is successfully loaded,
 *   it receives one argument: the data.
 * - context (Object): Context to invoke the hollaback function in.
**/

_.loadJSONP = (function loadJSONP( window, document, undefined ) {
  	var uuid = 0,
		head = document.head || document.getElementsByTagName( 'head' )[0],
		main_script = document.createElement( 'script' );

  	main_script.type = 'text/javascript';

	return function( url, callback, context ) { var name, script;
	    // INIT
	    name = '__jsonp_' + uuid++;
	    if ( url.match(/\?/) ) {
	      url += '&callback=' + name;
	  	} else {
	      url += '?callback=' + name;
	  	}

	    // Create script
	    script = main_script.cloneNode();
	    script.src = url;

	    // Setup handler
	    window[name] = function( data ) {
	      callback.call( ( context || window ), data );
	      head.removeChild( script );
	      script = null;
	      delete window[name];
	  	};

	    // Load JSON
	    head.appendChild( script );
	};
})( window, document );

/**
 * to number
 * @param  {number|string} n
 * @return {number}
 */
_.toNumber = function(n) {
	if (typeof n === 'string') n = parseInt(n);
	return n;
};
window.lazySizesConfig = window.lazySizesConfig || {};

function sdgRemoveLazy(el) {
	var cls = 'is-loading',
		elm = _.parents(el,'.' + cls);

	if (elm) {
		_.removeClass(elm[0],cls);
	}
}

document.addEventListener('lazybeforeunveil', function(e){
	sdgRemoveLazy(e.target);
});
(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('CustomEvent');

		event.initCustomEvent(name, !noBubbles, !noCancelable, detail || {});

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = 125;
		var RIC_DEFAULT_TIMEOUT = 666;
		var rICTimeout = RIC_DEFAULT_TIMEOUT;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});
				if(rICTimeout !== RIC_DEFAULT_TIMEOUT){
					rICTimeout = RIC_DEFAULT_TIMEOUT;
				}
			}:
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;
			if((isPriority = isPriority === true)){
				rICTimeout = 44;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || (delay < 9 && requestIdleCallback)){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};


	var loader = (function(){
		var lazyloadElems, preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;

		var defaultExpand, preloadExpand, hFac;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(e && e.target){
				addRemoveLoadEvents(e.target, resetPreloading);
			}

			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				if(preloadExpand == null){
					if(!('expand' in lazySizesConfig)){
						lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
					}

					defaultExpand = lazySizesConfig.expand;
					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				}

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			addClass(e.target, lazySizesConfig.loadedClass);
			removeClass(e.target, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia, parent;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}

			//https://bugzilla.mozilla.org/show_bug.cgi?id=1170572
			if(customMedia){
				parent = source.parentNode;
				parent.insertBefore(source.cloneNode(), source);
				parent.removeChild(source);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				if(firesLoad){
					addRemoveLoadEvents(elem, resetPreloading, true);
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);

					addClass(elem, lazySizesConfig.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(srcset || isPicture){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					if(firesLoad){
						resetPreloading(event);
					} else {
						isLoading--;
					}
					switchLoadingClass(event);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem.src || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazyloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
				hFac = lazySizesConfig.hFac;

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazyloadElems.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	return {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};
}
));
/**
 * https://github.com/aFarkas/lazysizes/tree/gh-pages/plugins/attrchange
 *
 * lazysizes attribute change / re-initialization extension
 *
 * In case you are changing the data-src/data-srcset attributes of already transformed lazyload elements dynamically, you normally
 * also must re-add the lazyload class to the element. This extension automatically detects changes to your data-* attributes and
 * adds the class for you.
 */

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';
	if(!window.addEventListener){return;}

	var rAF = window.requestAnimationFrame || setTimeout;

	var addObserver = function(){
		var connect, disconnect, observer, connected;
		var lsCfg = lazySizes.cfg;
		var attributes = {'data-bgset': 1, 'data-include': 1, 'data-poster': 1, 'data-bg': 1, 'data-script': 1};
		var regClassTest = '(\\s|^)(' + lsCfg.loadedClass;
		var docElem = document.documentElement;

		var setClass = function(target){
			rAF(function(){
				lazySizes.rC(target, lsCfg.loadedClass);
				if(lsCfg.unloadedClass){
					lazySizes.rC(target, lsCfg.unloadedClass);
				}
				lazySizes.aC(target, lsCfg.lazyClass);
			});
		};

		var onMutation = function(mutations){
			var i, len, mutation, target;
			for(i = 0, len = mutations.length; i < len; i++){
				mutation = mutations[i];
				target = mutation.target;

				if(!target.getAttribute(mutation.attributeName)){continue;}

				if(target.localName == 'source' && target.parentNode){
					target = target.parentNode.querySelector('img');
				}

				if(target && regClassTest.test(target.className)){
					setClass(target);
				}
			}
		};

		if(lsCfg.unloadedClass){
			regClassTest += '|' + lsCfg.unloadedClass;
		}

		regClassTest += '|' + lsCfg.loadingClass + ')(\\s|$)';

		regClassTest = new RegExp(regClassTest);

		attributes[lsCfg.srcAttr] = 1;
		attributes[lsCfg.srcsetAttr] = 1;

		if(window.MutationObserver){
			observer = new MutationObserver(onMutation);

			connect = function(){
				if(!connected){
					connected = true;
					observer.observe( docElem, { subtree: true, attributes: true, attributeFilter: Object.keys(attributes)} );
				}
			};
			disconnect = function(){
				if(connected){
					connected = false;
					observer.disconnect();
				}
			};
		} else {
			docElem.addEventListener('DOMAttrModified', (function(){
				var runs;
				var modifications = [];
				var callMutations = function(){
					onMutation(modifications);
					modifications = [];
					runs = false;
				};
				return function(e){
					if(connected && attributes[e.attrName] && e.newValue){
						modifications.push({target: e.target, attributeName: e.attrName});
						if(!runs){
							setTimeout(callMutations);
							runs = true;
						}
					}
				};
			})(), true);

			connect = function(){
				connected = true;
			};
			disconnect = function(){
				connected = false;
			};
		}

		addEventListener('lazybeforeunveil', disconnect, true);
		addEventListener('lazybeforeunveil', connect);

		addEventListener('lazybeforesizes', disconnect, true);
		addEventListener('lazybeforesizes', connect);
		connect();

		removeEventListener('lazybeforeunveil', addObserver);
	};


	addEventListener('lazybeforeunveil', addObserver);
}));
/**
* Header JS
*/
SDG.Header = (function() {

	function init() {
		nav();
		utility();
	}

	function nav() {
		// naviation
		$('#navAccountButton').on('click',function() {
			$('#headerAccount').click();
		});
	}

	function utility() {

		// utility sidebar
		// $('#send2').click(function() {
		// 	$.ajax({
		// 		url: '/sdgcustomer/ajax/loginPost',
		// 		method: 'POST',
		// 		data: $('#login-form').serialize(),
		// 		success: function(result) {
		// 			if(result.result === true) {
		// 				window.location.replace('/customer/account/');
		// 			} else {
		// 				$('.login_result').html('<div class="validation-advice">' + result.message + '</div>');
		// 			}
		// 		}
		// 	});
		// });
        //
		// $('#login-form').keydown(function(e) {
		// 	var key = e.which;
		// 	if (key === 13) {
		// 		$('#send2').click();
		// 	}
		// });



		// $('#register-new-user-minicart').click(function(e) {
		// 	e.preventDefault();
		// 	$.ajax({
		// 		url: '/sdgcustomer/ajax/createPost',
		// 		method: 'POST',
		// 		data: $('#register-form-validate-minicart').serialize(),
		// 		success: function(result) {
		// 			if(result.result === true) {
		// 				window.location.replace('/customer/account/');
		// 			} else {
		// 				$('.register_result').html('<div class="validation-advice">' + result.message + '</div>');
		// 			}
		// 		}
		// 	});
		// });







		// $('#forgot_submit').click(function() {
		// 	$.ajax({
		// 		url: '/sdgcustomer/ajax/forgotpasswordPost',
		// 		method: 'POST',
		// 		data: $('#form-validate').serialize(),
		// 		success: function(result) {
		// 			if(result.result === true) {
		// 				$('.pw_result').html('<div class="validation-advice">' + result.message + '</div>');
		// 			} else {
		// 				$('.pw_result').html('<div class="validation-advice">' + result.message + '</div>');
		// 			}
		// 		}
		// 	});
		// });
		//
		// $('#form-validate').on('keyup keypress', function(e) {
		// 	var code = e.keyCode || e.which;
		// 	if (code  === 13) {
		// 		e.preventDefault();
		// 		$('#forgot_submit').click();
		// 	}
		// });



		$('#closeMiniCart').click(function(e) {
			e.stopImmediatePropagation();
			$('#headerCart').find('.cart-toggle').click();
			$('.utility-overlay').hide();
		});

		$('#closeAccountMenu').click(function() {
			$('#headerAccount').click();
		});

		$('#mini-cart-form .btn-remove').click(function(e) {

			e.preventDefault();
			var btn = $(this);
			var form = $('#mini-cart-form');
			var miniCart = $('#miniCart');

			miniCart.addClass('loading');

			$.ajax({
				url: btn.attr('href'),
				data: form.serialize(),
				dataType: 'json',
				method: 'post',
				success: function(response) {
					if (response.success) {
						miniCart.removeClass('loading');
						miniCart.html(response.content);
						var cartContainer = $('#headerCart .count');
						cartContainer.html(response.qty);
						setTimeout(function() {
							$('#mini-cart-list').find('.lazy').unveil().css({'opacity':1});
						},500);
					} else {
						alert(response.message);
					}
				}
			});
		});

		$.sdg.miniCartPadding();
		$.sdg.siteMenus.forgotPasswordLink('#forgotPassword');
	}

	return {
		init: init
	};

})();

/**
 * messages
 * @requires [lib/util.js]
 */
/**
 * namespace
 * @type {Object}
 */
SDG.Messages = SDG.Messages || {};

/**
 * config
 * @type {Object}
 */
SDG.Messages.config = {
	animation: {
		type: 'slideDown'
	}, // slideDown or fadeIn
	cls: {
		show: 'is-visible'
	},
	id: null,
	dom: {
		error: 'message--error',
		msg: 'message',
		success: 'message--success'
	},
	msgs: {
		error: '<p>Failed.</p>',
		success: '<p>Success!</p>'
	},
	timer: {
		hide: 200,
		show: 200
	}
};

/**
 * @param  {Object} opts extend config option
 * @return {Function}
 */
SDG.Messages.init = function(opts) {
	/**
	 * extend config object
	 */
	var c = JSON.parse(JSON.stringify(SDG.Messages.config));
	c = _.extend(c,opts);

	// cached globals
	var isString = typeof c.id === 'string' ? true : false,
		domMsgs = isString ? document.getElementById(c.id) : c.id;

	/**
	 * show success
	 * @param  {String} val custom message value
	 */
	function showSuccess(val) {
		if (domMsgs) {
			var msg = c.msgs.success,
				html;

			if (val) {
				msg = val;
			}

			html = '<div class="'+ c.dom.msg +' '+ c.dom.success +'">'+ msg +'</div>';

			domMsgs.innerHTML = html;

			if (c.animation.type === 'slideDown') {
				_.slideDown(domMsgs,c.timer.show);
			} else {
				_.show(domMsgs);
				setTimeout(function() {
					_.addClass(domMsgs,c.cls.show);
				},1);
			}

		} else {
			console.log('No message block was found.');
		}
	}

	/**
	 * show error
	 * @param  {String} val custom message value
	 */
	function showError(val) {

		if (domMsgs) {
			var msg = c.msgs.error,
				html;

			if (val) {
				msg = val;
			}

			html = '<div class="'+ c.dom.msg +' '+ c.dom.error +'">'+ msg +'</div>';

			domMsgs.innerHTML = html;

			_.slideDown(domMsgs,c.timer.show);

		} else {
			console.log('No message block was found.');
		}
	}

	function clearMessages() {
		_.slideUp(domMsgs,c.timer.hide);

		_.transition({
			after: domMsgs.empty,
			time: c.timer.hide
		});
	}

	return {
		clear: clearMessages,
		error: showError,
		success: showSuccess
	};

};
/**
* incrementer
* @requires [lib/util.js]
*/
SDG.incrementer = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {
		action: {
			remove: 'remove',
			add: 'add'
		},
		cb: null,
		cls: {
			loading: 'is-loading'
		},
		dom: {
			btn: 'js-increment-btn',
			id: 'bag',
			increment: '.js-increment',
			input: '.js-increment-input',
			item: '.js-bag-item'
		},
		timer: 500
	};

	/**
	 * extend config with passed options
	 */
	var c = _.extend(config,opts);

	/**
	 * cached globals
	 */
	var $id = document.getElementById(c.dom.id),
		delay;

	/**
	 * init
	 * @return {Function}
	 */
	function init() {
		bindEvents();
	}

	/**
	 * bind events
	 * @return {Function}
	 */
	function bindEvents() {
		_.addEvent({
			id: $id,
			className: c.dom.btn,
			event: 'click',
			fn: increment
		});
	}

	/**
	 * increment
	 */
	function increment(e) {
		/**
		 * vars
		 */
		var item = {},
			newQty;

		/**
		 * item attributes
		 */
		item.increment = _.parents(this,c.dom.increment)[0];
		item.input = item.increment.querySelector(c.dom.input);
		item.el = _.parents(this,c.dom.item)[0];
		item.action = this.getAttribute('data-action');
		item.id = item.el.getAttribute('data-variant-id');

		var qty = parseInt(item.input.value);

		/**
		 * clear timeout
		 */
		clearTimeout(delay);

		/**
		 * get newQty
		 */
		if (item.action === c.action.add) {
			newQty = qty + 1;
		} else {
			if (qty > 0) {
				newQty = qty - 1;
			} else {
				newQty = 0;
			}
		}

		item.input.value = newQty;

		/**
		 * callback
		 */
		if (c.cb) {
			delay = setTimeout(function() {
				c.cb(item,newQty);
			},c.timer);
		}

	}

	return init();
};
/**
* namespace
* @type {Object}
*/
SDG.Bag = SDG.Bag || {};

/**
* data
* @type {Object}
*/
SDG.Bag.data = SDG.Bag.data || {};

/**
* config
* @type {Object}s
*/
SDG.Bag.config = {
	cls: {
		active: 'is-active',
		empty: 'is-empty',
		expose: 'utility-sidebar-exposed',
		loading: 'is-loading-white',
		menu_open: 'menu-open'
	},
	dom: {
		bag: 'bag',
		bag_btn: 'bagBtn',
		bag_empty: 'bagEmpty',
		increment_input: '.js-increment-input',
		item: '.js-bag-item',
		item_messages: '.js-bag-item-messages',
		items: 'bagItems',
		remove: 'js-bag-item-remove',
		subtotal: 'bagSubtotal',
		mini_cart: 'miniCart'
	},
	icon: {
		remove: 'icon--cart-close',
		add: 'icon--plus-white',
		substract: 'icon--minus-white'
	},
	img: {
		std: '184x',
		rtn: '368x'
	},
	show_event: 'click', // click, mouseenter
	timer: {
		hover: 1500,
		slide_up: 400 // This should match the animation speed of your slideup animation. Typically this is set to $normal-timer in _timers.scss file.
	},
	url: {
		cart: '/cart.js',
		update: '/cart/change.js'
	},
	use_swatch: false // sets whether to use a swatch in the bag item for color display instead of the label. Set to false to show label instead.
};
/**
 * bag - items
 * this object provides useful methods to
 * add, remove, update, and get bag items to/from the global bagItems array
 * @type {Object}
 */
SDG.Bag.Items = {

	/**
	 * add
	 * adds an object to the global bagItems array
	 * @param {Object} obj
	 */
	add: function(obj) {
		bagItems.push(obj);
	},

	/**
	 * remove
	 * deletes an object from the global bagItems array
	 * @param {number} variantId [description]
	 */
	remove: function(variantId) {
		variantId = _.toNumber(variantId);

		bagItems = bagItems.filter(function(obj) {
			return obj.id !== variantId;
		});
	},

	/**
	 * update
	 * updates a bag item's property value (the object key's value)
	 * @param {number}        variantId
	 * @param {string}        prop
	 * @param {number|string} value
	 */
	update: function(variantId, prop, value) {
		var item = this.filterArray(variantId);

		item[prop] = value;
	},

	/**
	 * get
	 * gets a bag item's property value
	 * @param  {number} variantId
	 * @return {number|string|boolean}
	 */
	get: function(variantId, prop) {
		var item = this.filterArray(variantId);

		return typeof item !== 'undefined' ? item[prop] : false;
	},

	/**
	 * empty
	 * removes all items from bagItems array
	 */
	empty: function() {
		bagItems = [];
	},

	/**
	 * filter array
	 * returns a bag item (object)
	 * @param  {number} variantId
	 * @return {Object}
	 */
	filterArray: function(variantId) {
		variantId = _.toNumber(variantId);

		return bagItems.filter(function(obj) {
			return obj.id === variantId;
		})[0];
	}
};
/**
 * bag variantId
 * @param  {number|string} variantId
 * @param  {Array}         variantsArray
 * @return {Object}
 */
SDG.Bag.variant = function(variantId, variantsArray) {
	variantId = _.toNumber(variantId);

	// config
	var c = SDG.Bag.config;

	// cached globals
	var variant = variantsArray.filter(function(obj) {
		return obj.id === variantId;
	})[0];

	/**
	 * get data
	 */
	function getData() {
		return variant;
	}

	/**
	 * is max
	 * @param  {number}  qty
	 * @return {Boolean}
	 */
	function isMax(qty) {
		if (typeof qty === 'undefined') qty = 0;

		var $bagItem = document.getElementById('bagItem' + variantId),
			$bagItemInput = $bagItem ? $bagItem.querySelector(c.dom.increment_input) : null,
			bagItemQty = $bagItemInput ? parseInt($bagItemInput.value) : 0,
			maxQty = variant.inventory_quantity;

		return qty + bagItemQty > maxQty;
	}

	/**
	 * return
	 * @type {Object}
	 */
	return {
		getData: getData,
		isMax: isMax
	};
};
/**
* refresh
* @requires [lib/util.js,lib/incrementer,lib/bag-config.js,lib/bag-empty.js,lib/bag-update.js,lib/bag-init.js]
* @type {Function}
*/
SDG.Bag.refresh = function() {
	/**
	 * shorthand config object
	 */
	var c = SDG.Bag.config;

	/**
	 * cached globals
	 */
	var $bag = document.getElementById(c.dom.bag),
		$list = document.getElementById(c.dom.items);

	function init() {
		_.ajax({
			error: onError,
			success: onSuccess,
			type: 'GET',
			url: c.url.cart
		});
	}

	function onError() {
		console.log('Bag refresh error with ajax request.');
	}

	function onSuccess(e) {
		if (e) {
			if (e.items.length > 0) {
				getItems(e);
				SDG.Bag.empty(false);
			} else {
				SDG.Bag.empty(true);
			}

			SDG.Bag.Count.set(e.item_count);
		}
	}

	function getItems(data) {
		var html = '',
			item,
			items = data.items;

		_.removeClass($bag,c.cls.empty);

		Object.keys(items).forEach(function(k) {
			item = getItemHtml(items[k]);
			html += (item);
		});

		$list.innerHTML = html;

		SDG.incrementer({
			cb: SDG.Bag.updateItemQty
		});
		bindEvents();

		SDG.Bag.recalc(data.total_price);
	}

	function bindEvents() {
		_.addEvent({
			id: $list,
			className: c.dom.remove,
			event: 'click',
			fn: beforeRemoveItem
		});
	}

	function beforeRemoveItem(e) {
		e.preventDefault();
		var item = getItem(this);
		SDG.Bag.updateItemQty(item,0);
	}

	function getItemHtml(obj) {

		var title = obj.product_title,
			img = obj.image,
			url = obj.url,
			original_price = obj.original_price,
			sale_price = obj.total_discount,
			variantId = obj.variant_id,
			currentQty = obj.quantity,
			originalPriceDisplay = _.formatPriceDisplay(original_price),
			img_std,
			img_rtn,
			item = '',
			salePriceDisplay;

		// set img
		img = img ? img : assetUrl + 'no-image.gif';
		img_std = _.getSizedImageUrl(img, c.img.std);
		img_rtn = _.getSizedImageUrl(img, c.img.rtn);

		// Item Start
		item += '<li class="bag-item js-bag-item item" id="bagItem'+ variantId +'" data-variant-id="'+ variantId +'" data-qty="'+ currentQty +'">';

		// Image
		item += '<figure class="product-image">'+
					'<a href="'+ url +'" class="bag-item__photo-ir" aria-label="Go to ' + title +' Page">'+
						'<img class="lazyload" data-srcset="'+ img_std +' 1x, '+ img_rtn +' 2x" alt="" />'+
					'</a>'+
				'</figure>';

		// Start description
		item += '<div class="product-details">';

		// Desc
		item += '<h4 class="bag-item__title">'+
					'<a href="'+ obj.url +'">'+
						obj.product_title +
					'</a>'+
				'</h4>'+
				'<div class="price-box">'+
					'<span class="price">'+ originalPriceDisplay + '</span>'+
					(sale_price !==  0 ? '<span class="price">'+ salePriceDisplay +'</span>':'')+
					'<ul class="item-options">'+
						getItemVariants(obj) +
					'</ul class="item-options">'+
				'</div>';

		// Actions
		item += '<div class="bag-item__actions">'+
					'<div class="bag-item__qty incrementer js-increment">'+
						'<input type="text" name="quantity" value="'+ currentQty +'" size="3" class="increment__input js-increment-input" tabindex="-1" />'+
						'<button type="button" class="increment__btn increment__add btn-add js-increment-btn" data-action="add">'+
							'<i class="increment__icon increment__icon--add"></i>'+
							'<span class="screenreader">Add</span>'+
						'</button>'+
						'<button type="button" class="increment__btn increment__subtr btn-subtract js-increment-btn" data-action="remove">'+
							'<i class="increment__icon increment__icon--subtr"></i>'+
							'<span class="screenreader">Subtract</span>'+
						'</button>'+
					'</div>'+
					'<a href="/cart/change/'+ variantId +'?quantity=0" title="Remove item" class="btn-remove js-bag-item-remove btn-icon" role="button" data-variant-id="'+ variantId +'">'+
					'<i class="icon icon-trash"></i>' +
						'<span class="btn-remove__text">Remove</span>'+
					'</a>'+
				'</div>';

		// Messages
		item += '<div class="bag-item__messages messages js-bag-item-messages">'+
				'</div>';

		// End Description, Item
		item += '</div></li>';

		return item;

	}

	function getItemVariants(obj) {
		/**
		 * shorthand config
		 */
		var c = SDG.Bag.config;

		/**
		 * vars
		 */
		var count,
			handle = obj.handle,
			i,
			isColor = false,
			label,
			variant,
			variants = obj.variant_options,
			html = '',
			swatch,
			swatchRetina;

		if (variants) {
			count = variants.length;

			for (i=0;i<count;i++) {
				variant = variants[i].toLowerCase();

				label = _.remapSizeValues(variant);

				isColor = handle.indexOf(label) !== -1 ? true : false;

				if (label && label !== 'default title') {
					if (isColor && c.use_swatch) {
						swatch = assetUrl + _.getSizedImageUrl('swatch-'+ label +'.png');
						swatchRetina = assetUrl + _.getSizedImageUrl('swatch-'+ label +'.png');

						html += '<li class="bag-item__variant bag-item__variant-color">'+
								'<img data-srcset="'+ swatch +' 1x, '+ swatchRetina +' 2x" class="lazyload" alt="'+ label +'" />'+
							'</li>';
					} else {
						html += '<li class="bag-item__variant">'+ label +'</li>';
					}
				}
			}
		}

		return html;
	}

	function getItem($el) {
		var item = {};

		item.el = _.parents($el,c.dom.item)[0];

		item.id = item.el.getAttribute('data-variant-id');

		return item;
	}

	return init();
};
/**
 * recalculate totals
 */
SDG.Bag.recalc = function(price) {
	var c = SDG.Bag.config,
		$sub = document.getElementById(c.dom.subtotal),
		nt;

	if (typeof(price) !== 'undefined') {
		var price_f = _.formatPrice(price);
		nt = _.numberWithCommas(price_f);
		$sub.innerHTML = nt;
	}
};
/**
 * bag empty
 */
SDG.Bag.empty = function(empty) {
	var c = SDG.Bag.config,
		$bag = document.getElementById(c.dom.bag);

	if (empty) {
		_.addClass($bag,c.cls.empty);
	} else {
		_.removeClass($bag,c.cls.empty);
	}
};
/**
 * bag count
 * @requires [lib/util.js,lib/bag-config.js]
 * namespace
 * bag config
 * count config
 * extend bag config
 * count
 */

/**
 * namespace
 * @type {Object}
 */
 SDG.Bag = SDG.Bag || {};

/**
 * bag config
 * @type {Object}
 */
SDG.Bag.config = SDG.Bag.config || {};

/**
* count config
* @type {Object}
*/
SDG.Bag.config_count = {
	dom: {
		count: 'bagBtnCount',
		count_page: 'bagBtnCount',
		page: 'your-shopping-cart'
	}
};

/**
 * extend bag config
 * @type {Object}
 */
SDG.Bag.config = _.extend(SDG.Bag.config,SDG.Bag.config_count);

SDG.Bag.Count = {

	count: null,

	/**
	 * get
	 * @return {number} bag count (number of items in bag)
	 */
	get: function() {
		return this.count;
	},

	/**
	 * set
	 * @param {number|string} n number
	 */
	set: function(n) {
		/**
		 * shorthand config
		 */
		var c = SDG.Bag.config;

		/**
		 * vars
		 */
		var $page = document.getElementById(c.dom.page);

		/**
		 * ensure n is a number
		 */
		n = typeof n !== 'string' ? n : parseInt(n);

		this.count = n;

		if ($page) {
			this.updateCount(c.dom.count_page,n);

		} else {
			this.updateCount(c.dom.count,n);
		}
	},
	updateCount: function(el,n) {
		var $count,
			arr,
			i;

		if (_.isDelimitedArray(el)) {
			arr = el.split(',');

			for (i=0;i<arr.length;i++) {
				$count = document.getElementById(arr[i]);
				$count.innerHTML = n;

				if (n === 0) {
					_.hide($count);
				} else {
					_.show($count);
				}
			}
		} else {
			$count = document.getElementById(el);
			$count.innerHTML = n;

			if (n === 0) {
				_.hide($count);
			} else {
				_.show($count);
			}
		}
	}
};
/**
 * update item quantity
 * @param {Object} item
 * @param {number} qty
 */
SDG.Bag.updateItemQty = function(item,qty) {
	var c = SDG.Bag.config,
		dataObject = {
			quantity: qty,
			id: item.id
		},
		
		$bagItem = item.el,
		$bagItemMessages = $bagItem ? $bagItem.querySelector(c.dom.item_messages) : null;

	/**
	 * init
	 */
	function init() {
		if (item.el) {
			_.addClass(item.el, c.cls.loading);
		}

		_.ajax({
			dataObject: dataObject,
			error: onError,
			success: updateItem,
			type: 'POST',
			url: c.url.update
		});
	}

	/**
	 * update item
	 * @param {Object} data
	 */
	function updateItem(data) {

		// variant and qty
		var variant = SDG.Bag.variant(item.id, bagItems),
			variantData = variant.getData(),
			variantMaxQty = variantData.inventory_quantity,
			isMax = variant.isMax(),

			// message
			message = SDG.Messages.init({
				id: $bagItemMessages,
				msgs: {
					error: '<p>Sorry, ' + variantMaxQty + ' is the max quantity available in this size.</p>',
				}
			});

		if (item.el) {

			// if set to 0
			if (qty === 0) {

				_.slideUp(item.el);

				_.transition({
					after: removeItemEl(item.el),
					timer: c.timer.slide_up
				});

				// remove item from bagItems array
				SDG.Bag.Items.remove(item.id);

			} else {

				_.removeClass(item.el,c.cls.loading);

			}
		}

		if (data.item_count === 0) {
			SDG.Bag.empty(true);
		}
	
		// if max
		if (isMax && $bagItem) {

			// update increment to reflect max amount
			item.input.value = variantMaxQty;

			// show error message
			message.error();

		} else {
			// clear message
			message.clear();

		}

		SDG.Bag.Count.set(data.item_count);

		SDG.Bag.recalc(data.total_price);
	}

	/**
	 * remove item element
	 * @param {Element} item
	 */
	function removeItemEl(item) {
		item.remove();
	}

	/**
	 * on error
	 * @param {Object} data
	 */
	function onError(data) {
		console.warn('Error updating item ' + item.id);
		console.warn(data);
	}

	return init();
};
/**
 * bag timeout
 */
SDG.Bag.timeout = null;

SDG.Bag.clearTimeout = function() {
	if (SDG.Bag.timeout) {
		clearTimeout(SDG.Bag.timeout);
	}
};

/**
 * is open
 * @return {Function} Checks if bag is open
 */
SDG.Bag.isOpen = false;

/**
 * open bag
 * @return {Function} adds expose class from the body
 */
SDG.Bag.open = function(e) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	/**
	 * cached global
	 */
	var $body = document.body,
		$miniCart = document.getElementById(c.dom.mini_cart);

	if (e) {
		console.log('1');
		e.preventDefault();

		if (e.type === 'mouseenter') {
			SDG.Bag.clearTimeout();
			_.addClass($body,c.cls.expose);
		}

		if (e.type === 'click') {
			if (SDG.Bag.isOpen) {
				SDG.Bag.close();
			} else {
				SDG.Bag.isOpen = true;
				_.addClass($body,c.cls.expose);
			}
		}

	} else {
		
		_.addClass($body,c.cls.expose);
		_.addClass($miniCart,c.cls.menu_open);
		if (!$('body').hasClass('utility-sidebar-exposed')) {
			$('.cart-toggle').trigger('click');
		}

		$('#headerCart').find('.cart').addClass('active');
		$('.utility-overlay').show();

		setTimeout(function() {
			jQuery('#bagItems').find('.lazy').unveil().css({'opacity':1});
		},500);
	}
};

/**
 * wait to close bag
 * @return {Function} removes expose class from the body
 */
SDG.Bag.waitToClose = function(e) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	SDG.Bag.timeout = setTimeout(SDG.Bag.close,c.timer.hover);
};


/**
 * close bag
 * @return {Function} removes expose class from the body
 */
SDG.Bag.close = function(e) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	/**
	 * cached global
	 */
	 var $body = document.body,
	     $miniCart = document.getElementById(c.dom.mini_cart);

	if (e) {
		e.preventDefault();
	}

	_.removeClass($body,c.cls.expose);
	_.removeClass($miniCart,c.cls.menu_open);

	SDG.Bag.isOpen = false;
};

/**
* init
* @type {Function}
*/
SDG.Bag.init = function() {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	function init() {

		// Refresh Bag
		SDG.Bag.refresh();

		// Add Events
		addEvents();
	}

	function addEvents() {
		// bag toggle
		if (c.show_event === 'mouseenter') {
			responsive();
			_.windowResize(responsive);
		}

		// close on escape get
		document.addEventListener('keyup',getKeyCode);
	}

	/**
	 * get keycode
	 * @return {Function} close modal on escape key
	 */
	function getKeyCode(e) {
		if (e.keyCode === 27) {
			SDG.Bag.close();
		}
	}

	/**
	 * bind click
	 * @type {Function}
	 */
	function bindClick() {
		_.addEvent({
			id: c.dom.bag_btn,
			event: 'click',
			fn: SDG.Bag.open
		});

		unbindHover();
	}

	/**
	 * bind click
	 * @type {Function}
	 */
	function unbindClick() {
		_.removeEvent({
			id: c.dom.bag_btn,
			event: 'click',
			fn: SDG.Bag.open
		});
	}

	/**
	 * bind hover
	 * @type {Function}
	 */
	function bindHover() {
		_.addEvent({
			id: c.dom.bag_btn + ',' + c.dom.bag,
			event: 'mouseenter',
			fn: SDG.Bag.open
		});
		_.addEvent({
			id: c.dom.bag_btn +','+ c.dom.bag,
			event: 'mouseleave',
			fn: SDG.Bag.waitToClose
		});
		unbindClick();
	}

	/**
	 * unbind hover
	 * @type {Function}
	 */
	function unbindHover() {
		_.removeEvent({
			id: c.dom.bag_btn + ',' + c.dom.bag,
			event: 'mouseenter',
			fn: SDG.Bag.open
		});
		_.removeEvent({
			id: c.dom.bag_btn +','+ c.dom.bag,
			event: 'mouseleave',
			fn: SDG.Bag.waitToClose
		});
	}

	/**
	 * responsive
	 * @type {Function}
	 */
	function responsive() {
		_.mq({
			view: 'desktop',
			callback: bindHover
		});
		_.mq({
			view: 'mobile',
			callback: bindClick
		});
	}

	return init();
};
/**
 * set cookie
 * @param  {String} c_name name of the cookie
 * @param  {String} value  value of the cookie
 * @param  {Number} exdays number of days to set the cookie
 * @return {Function}      sets cookie
 */
SDG.setCookie = function(c_name,value,exdays) {
	var exdate=new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value=encodeURI(value) +
	((exdays===null) ? '' : ('; expires='+exdate.toUTCString()));
	document.cookie=c_name + '=' + c_value +'; path=/';
};

/**
 * get cookie
 * @param  {String} c_name name of the cookie
 * @return {String}        value of the cookie
 */
SDG.getCookie = function(c_name) {
	var i,x,y,ARRcookies=document.cookie.split(';');
	for (i=0;i<ARRcookies.length;i++) {
		x=ARRcookies[i].substr(0,ARRcookies[i].indexOf('='));
		y=ARRcookies[i].substr(ARRcookies[i].indexOf('=')+1);
		x=x.replace(/^\s+|\s+$/g,'');
		if (x===c_name) {
			return decodeURI(y);
		}
	}
};

/**
 * delete cookie
 * @param {string} c_name name of the cookie
 */
SDG.deleteCookie = function(c_name) {
	document.cookie = c_name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
/**
 * input placeholder
 * @requires [lib/util.js]
 * @return   {Object}
 */
SDG.placeholder = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {
		id: 'main',
		sel: 'input-placeholder',
		cls: 'has-value'
	},

	c = _.extend(config,opts),

	domId = document.getElementById(c.id),
	domInputWraps = domId.querySelectorAll('.' + c.sel),
	domInputWrap,
	domInput;

	/**
	 * init
	 * @return {Function}
	 */
	function init() {
		addEvents();
		checkForExistingValues();
	}

	/**
	 * add events
	 * @return {Function}
	 */
	function addEvents() {

		// keyup event for inputs
		_.addEvent({
			id: c.id,
			className: c.sel + ' input',
			event: 'keyup',
			fn: checkValue
		});

		// change event for inputs
		_.addEvent({
			id: c.id,
			className: c.sel + ' input',
			event: 'change',
			fn: checkValue
		});

		// keyup event for textarea
		_.addEvent({
			id: c.id,
			className: c.sel + ' textarea',
			event: 'keyup',
			fn: checkValue
		});

		// change event for textarea
		_.addEvent({
			id: c.id,
			className: c.sel + ' textarea',
			event: 'change',
			fn: checkValue
		});
	}

	/**
	 * check for existing values
	 * @type {Function}
	 */
	function checkForExistingValues() {
		Object.keys(domInputWraps).forEach(function(key) {
			domInputWrap = domInputWraps[key];
			domInput = domInputWrap.querySelector('input') ? domInputWrap.querySelector('input') : domInputWrap.querySelector('textarea');

			if (domInput) {
				checkValue(domInput);
			}
		});
	}

	/**
	 * check value
	 * @type {Function}
	 */
	function checkValue(el) {
		var field = el.target ? el.target : el;

		if (field.value && field.value !== '') {
			_.addClass(field.parentNode,c.cls);
		} else {
			_.removeClass(field.parentNode,c.cls);
		}
	}

	/**
	 * return
	 * @type {Object}
	 */
	return {
		init: init,
		refresh: checkForExistingValues
	};
};
/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */
;(function($){$.fn.unveil=function(threshold,callback){var $w=$(window),th=threshold||0,retina=window.devicePixelRatio>1,attrib=retina?"data-src-retina":"data-src",images=this,loaded;this.one("unveil",function(){var source=this.getAttribute(attrib);source=source||this.getAttribute("data-src");if(source){this.setAttribute("src",source);if(typeof callback==="function")callback.call(this);}});function unveil(){var inview=images.filter(function(){var $e=$(this),wt=$w.scrollTop(),wb=wt+$w.height(),et=$e.offset().top,eb=et+$e.height();return eb>=wt-th&&et<=wb+th;});loaded=inview.trigger("unveil");images=images.not(loaded);}$w.scroll(unveil);$w.resize(unveil);unveil();return this;};})(window.jQuery||window.Zepto);
/**
* searchspring on dom ready
*
* namespace
* on after search
* fire functions
*/

/**
* namespace
* @type {Object}
*/
SDG.SearchSpring = SDG.SearchSpring || {};

/**
* on after search
* @param {Object} $scope angular's scope
*/
SDG.SearchSpring.onAfterSearch = function($scope) {

	// scope globals
	$scope.storage = {};
	$scope.touts = [];

	/**
	* init
	*/
	function init() {
		pushStarRatingData();
		loopThroughFacets();
		productFlags();
	}

	/**
	* push star rating data
	*/
	function pushStarRatingData() {
		var star = 'yotpo-icon-star';
		var half_star = 'yotpo-icon-half-star';
		var empty_star = 'yotpo-icon-empty-star';

		// loop over results
		angular.forEach($scope.results, function(result) {
			// create array of ratings stars
			var rating = result.reviews_product_score;
			if (rating) {
				var rating_array = [];
				var full_stars = Math.floor(rating / 1),
				i;

				for (i = 0; i < full_stars; i++) {
					rating_array.push(star);
				}

				if (rating - full_stars >= 0.75) {
					rating_array.push(star);
				} else if (rating - full_stars >= 0.3) {
					rating_array.push(half_star);
				}

				for (i = rating_array.length; i < 5; i++) {
					rating_array.push(empty_star);
				}

				result.rating_array = rating_array;
			}
		});
	}

	/**
	* loop through facets
	* @return {[type]} [description]
	*/
	function loopThroughFacets() {
		angular.forEach($scope.facets, function(facet) {
			if (!$scope.storage[facet.field]) {
				$scope.storage[facet.field] = '';
			}
			if (facet.field === 'parent_color') {
				$scope.swatches = facet.values;
			}
		});
	}

	// product flags
	function productFlags() {
		angular.forEach($scope.results, function(result) {
			var tags = result.tags;
			if (! tags) return false;
			if (typeof tags == "string") {
				tags = tags.split(',');    
			};
			for (var i = 0; i < tags.length; i++) {
				if (tags[i].indexOf('Flag:') > -1) {
					var flags = tags[i].split(':')[1].trim();
					flags = flags === 'Bestseller' ? 'Best Seller' : flags;
					// var twoWordFlag = flags.split(' ');
                    //
					// if (twoWordFlag.length === 2) {
					// 	console.log('mhm');
					// }

					result.flag = flags;
				}
			}
		});
	}

	/**
	* autocomplete go
	* @param {String} url
	*/
	$scope.acGo = function(url) {
		window.location = url;
	};

	/**
	* get data
	*/
	$scope.getData = function($event) {
		var $btn = $($event.target),
		isQuickviewActive = $btn.hasClass('quickview-is-active');

		if (isQuickviewActive) {
			$btn.attr('aria-expanded', 'false');
			SDG.Quickview.closeAll();
		} else {
			$btn.attr('aria-expanded', 'true');
			SDG.Quickview.getData(this.result.handle, $btn);
		}
	};

	/**
	* page changed
	*/
	$scope.pageChanged = function() {
		$('body,html').animate({
			scrollTop: 0
		}, 100);
		$('.lazy').removeAttr('style');
	};

	/**
	* toggle menus
	* @param {String} a
	* @param {String} b
	* @param {String} x
	* @param {String} y
	*/
	$scope.toggleMenus = function(a, b, x, y) {
		if ($(x).hasClass('active') && $(y).hasClass('open')) {
			$(x).removeClass('active');
			$(y).removeClass('open');
		}
		$(a).toggleClass('active');
		$(b).toggleClass('open');
	};

	return init();
};

/**
* fire functions
*/
(function() {
	var $main = document.getElementById('main');

	// set ready flag
	if ($main) {
		$main.setAttribute('data-ss-aftersearch-ready', 'true');
	}
})();
/**
 * searchspring on dom ready
 *
 * required lib functions
 * namespace
 * flag
 * on dom ready
 * fire functions
 */

/**
 * namespace
 * @type {Object}
 */
SDG.SearchSpring = SDG.SearchSpring || {};

/**
 * flag
 * @type {Object}
 */
SDG.SearchSpring.OnDomReadyFlag = {
	has_init: false
};

/**
 * on dom ready
 */
SDG.SearchSpring.onDomReady = function() {
	$.sdg.searchSpringFilter();

	activeFilters();
};

/**
 * fire functions
 */
(function() {
	var $results = document.getElementById('results');

	// set ready flag
	if ($results) {
		$results.setAttribute('data-ss-domready-ready', 'true');
	}
})();

var activeFilters = function(){

	var $filtersArray = [];
	var $facets = [].slice.call(document.querySelectorAll('.js-searchspring-facets'));


	$facets.forEach(function(item){
		var filter = [].slice.call(item.querySelectorAll('.facet_container'));
		filter.forEach(function(filter){
			$filtersArray.push(filter);
		});
	});

	$filtersArray.forEach( function(item) {

		var activeFiltersLength = item.querySelectorAll('.highlight').length;
		var $item = item.querySelectorAll('.facet_title');
		var countSpan = document.createElement('span');
		countSpan.className = 'count';

		if ($item[0].getElementsByClassName('count').length === 0) {
			$item[0].appendChild(countSpan);
		}

		if (activeFiltersLength !== 0) {
			$item[0].getElementsByClassName('count')[0].innerHTML = ' (' + activeFiltersLength + ')';
		} else {
			$item[0].getElementsByClassName('count')[0].remove();
		}
	});

};

/*
global
escape: true,
unescape: true,

*/

/*
////////////////////////////////////////////////////////////////////////////////
--------------------------------------------------------------------------------
SDG Custom Functions

1. Run DOM Ready
2. Cookies
3. Debounce
3.5 Media Query
4. Placeholder
5. Placeholder Background
6. Custom File Upload
7. Modals
8. Accordion
9. Tabs
10. Scroll To Button
11. Autofill input placeholder from title value
12. Lazy Load Images
13. Responsive Lazy Load Images
14. Site Menus
15. Follower
16. Welcome Modal
17. Olark
18. Category Toolbar
19. Toggle Section
20. Phone Toggle Section
21. Show More Container
22. Incrementer
23. Quickview
24. Press Quickview
25. Blog Menu
26. Lazy Load Products
27. SearchSpring Filter
28. Extend Validation
29. Default RWD
30. Functions to run on load

////////////////////////////////////////////////////////////////////////////////
--------------------------------------------------------------------------------
*/


(function($) {

	$.sdg = {};

	/*
	----------------------------------------------------------------------------
	1. Run DOM Ready
	----------------------------------------------------------------------------
	*/
	$.sdg.runDomReady = function() {
		$.sdg.siteMenus();
		
		$.sdg.modalTrigger();
		$.sdg.lazyLoadImages();
		$.sdg.responsiveLazyLoad();
		//$.sdg.welcomeModal();
		$.sdg.vipNewsletter();
		$.sdg.removeSsScroll();
	};

	/*
	----------------------------------------------------------------------------
	2. Cookies
	----------------------------------------------------------------------------
	*/
	$.sdg.setCookie = function(c_name,value,exdays) {
		var exdate=new Date();
		exdate.setDate(exdate.getDate() + exdays);
		var c_value = escape(value) + ((exdays===null) ? '' : ('; expires='+exdate.toUTCString()));
		document.cookie=c_name + '=' + c_value;
	};

	$.sdg.getCookie = function(c_name) {
		var i,x,y,ARRcookies=document.cookie.split(';');
		for (i=0;i<ARRcookies.length;i++) {
			x=ARRcookies[i].substr(0,ARRcookies[i].indexOf('='));
			y=ARRcookies[i].substr(ARRcookies[i].indexOf('=')+1);
			x=x.replace(/^\s+|\s+$/g,'');
			if (x===c_name) {
				return unescape(y);
			}
		}
	};

	/*
	----------------------------------------------------------------------------
	3. Debounce
	----------------------------------------------------------------------------
	*/
	$.sdg.debounce = function (func, threshold, execAsap) {

		var timeout;

		return function debounced () {
			var obj = this, args = arguments;
			function delayed () {
				if (!execAsap)
				func.apply(obj, args);
				timeout = null;
			}

			if (timeout)
			clearTimeout(timeout);
			else if (execAsap)
			func.apply(obj, args);

			timeout = setTimeout(delayed, threshold || 100);
		};

	};

	/*
	----------------------------------------------------------------------------
	3.5 Media Query
	----------------------------------------------------------------------------
	*/
	$.sdg.mq = function(opts) {
		var config = {
			view	: null,
			callback : null,
			views : {
				small_phone 			: '(max-width:640px)',
				phone 					: '(max-width:767px)',
				mobile					: '(max-width:1024px)',
				phone_to_desktop		: '(min-width:563px)',
				tablet					: '(min-width:768px)',
				tablet_only 			: '(min-width:768px) and (max-width:1024px)',
				tablet_portrait 		: '(min-width:768px) and (max-width:979px)',
				tablet_landscape 		: '(min-width:980px) and (max-width:1024px)',
				desktop					: '(min-width:1025px)',
				desktop_to_large    	: '(min-width:1025px) and (max-width:1280px)',
				desktop_large			: '(min-width:1281px)',
				desktop_large_to_huge 	: '(min-width:1281px) and (max-width:1400px)',
				desktop_huge			: '(min-width:1401px)'
			}
		},
		c = $.extend(config,opts),
		mq = {
			init : function() {

				if (c.view) {

					var currentView = null;

					$.each(c.views,function(key,value) {
						if (key === c.view) {
							currentView = value;
						}
					});

					var query = Modernizr.mq(currentView);

					if (query) {
						c.callback();
					}

				}

			}
		};

		return mq.init();
	};

	/*
	----------------------------------------------------------------------------
	4. Placeholder
	----------------------------------------------------------------------------
	*/
	/* Placeholder Function */
	$.sdg.inputPlaceholder = function(identifier,focusClass) {

		$(identifier).each(function() {
			var default_value = this.value;
			$(this).focus(function() {
				$(this).addClass(focusClass);
				if(this.value === default_value) {
					this.value = '';
				}
			});
			$(this).blur(function() {
				if(this.value === '') {
					this.value = default_value;
					$(this).removeClass(focusClass);
				}
			});
		});

	};

	/*
	----------------------------------------------------------------------------
	5. Placeholder Background
	----------------------------------------------------------------------------
	*/
	/* Placeholder Function */
	$.sdg.inputPlaceholderBackground = function(identifier,placeholderObject) {

		$(identifier).focus(function() {
			if($(this).val() === '') {

				$(this).parent().find(placeholderObject).addClass('hide');
			}
		});
		$(identifier).blur(function() {
			if($(this).val() === '') {
				$(this).parent().find(placeholderObject).removeClass('hide');
			}
		});

	};

	/*
	----------------------------------------------------------------------------
	6. Custom File Upload
	----------------------------------------------------------------------------
	*/
	$.sdg.customFileInput = function(id,noFileMessage) {

		$(id + ' input[type="file"]').change(function() {

			var fileSelected = $(this).val().replace(/^.*[\\\/]/, '');

			if (fileSelected === '') {
				fileSelected = noFileMessage;
			}

			$(this).next('.file-input-base').find('.faux-input').html(fileSelected);
		});
	};

	/*
	----------------------------------------------------------------------------
	7. Modals
	Notes:
	1) The button that opens the modal will require the modal-trigger class.
	2) The button that opens the modal will require a data-open-modal attribute with the ID of the modal to open.
	3) The modal will require the modal class and an id that matches the data-open-modal attribute on the modal trigger.
	----------------------------------------------------------------------------
	*/

	$.sdg.modalTrigger = function() {

		$('.modal-trigger').click(function(e) {

			var modalToOpen = '#' + $(this).data('open-modal');

			e.preventDefault();

			$('body').addClass('no-overflow');

			$(modalToOpen).fadeIn(250).next('.modal-overlay').fadeIn(250);

		});

		$('.modal').find('.btn-close').click(function() {
			$(this).parents('.modal').fadeOut(250, function() {
				$.sdg.modalClose();
			}).next('.modal-overlay').fadeOut(250);
		});

		$(document).keyup(function(e) {
			if (e.keyCode === 27) {
				$('.modal').fadeOut(250, function() {
					$.sdg.modalClose();
				}).next('.modal-overlay').fadeOut(250);
			}
		});

	};

	$.sdg.modalClose = function() {

		if (window.location.hash) window.location.hash = '';
		$('body').removeClass('no-overflow');

	};


	/*
	----------------------------------------------------------------------------
	8. Accordion
	Notes:
	parentTrigger = the click object
	childContainer = the container you want to have slide open
	If you want a menu item open by default, add "open" to the child container.
	----------------------------------------------------------------------------
	*/
	$.sdg.accordion = function(parentTrigger,childContainer,scrollScope) {

		$(parentTrigger).on('click',function(e) {

			var buttonClicked = $(this),
			buttonOffset;

			if (!$(this).hasClass('disabled')) {


				setTimeout(function() {
					if (scrollScope === 'body') {
						buttonOffset = parseInt(buttonClicked.offset().top);
						buttonOffset = buttonOffset - 63;
						$('html,body').animate({ scrollTop : buttonOffset},250,'swing');
					} else if (scrollScope !== null) {
						buttonOffset = parseInt(buttonClicked.offset().top - $(scrollScope).offset().top);
						buttonOffset = buttonOffset - parseInt($(scrollScope).offset().top + 63);
						$(scrollScope).animate({ scrollTop : buttonOffset},250,'swing');
					}
				},250);

				//e.preventDefault();
				var checkElement = $(this).next();
				$(parentTrigger).removeClass('active');
				$(this).addClass('active');

				/* Checks if the item you clicked on is currently open, and if so it closes it and removes all classes */
				if ((checkElement.is(childContainer)) && (checkElement.is(':visible'))) {

					/* Check to see if open class is present, if so remove it */
					if ($(childContainer + '.open')) {
						$(childContainer + '.open').slideUp(250, function () {
							$(this).removeClass('open');
						});
					}
					$(this).removeClass('active');

					checkElement.slideUp(250);
				}

				if ((checkElement.is(childContainer)) && (!checkElement.is(':visible'))) {

					/* Check to see if open class is present, if so remove it */
					if ($(childContainer + '.open')) {
						$(childContainer + '.open').slideUp(250, function () {
							$(this).removeClass('open');
						});
					}

					$(childContainer + ':visible').slideUp(250);

					checkElement.slideDown(250);
				}

				if (checkElement.is(childContainer)) {
					return false;
				} else {
					return true;
				}
			}

		});

	};


	$.sdg.accordion.collapseAccordion = function(accordion) {
		accordion = accordion;
		var activeClass = 'active';

		$('#'+accordion).find('.'+activeClass).removeClass(activeClass).next().slideUp(250);
	};

	/*
	----------------------------------------------------------------------------
	9. Tabs
	----------------------------------------------------------------------------
	*/
	$.sdg.tabs = function(outerContainer,tabHeader,tabButton,tabContentContainer,tabContent,activeClass,openIdentifier) {
		if (typeof(outerContainer) === 'undefined') outerContainer = '.tabs';
		if (typeof(tabHeader) === 'undefined') tabHeader = '.tabs-header';
		if (typeof(tabButton) === 'undefined') tabButton = 'button';
		if (typeof(tabContentContainer) === 'undefined') tabContentContainer = '.tab-content-container';
		if (typeof(tabContent) === 'undefined') tabContent = '.tab-content';
		if (typeof(activeClass) === 'undefined') activeClass = 'active';
		if (typeof(openIdentifier) === 'undefined') openIdentifier = 'open';

		var openPanel = $(tabContentContainer).find('.open');
		var openPanelHeight = $(tabContentContainer).find('.open').height();

		/* Add height to the tab container because inner panels are absolute positioned */
		$(tabContentContainer).css({minHeight: openPanelHeight});

		/* Add active class to the currently open panel */
		var activeTab = $(openPanel).attr('id');

		$(tabHeader).find(tabButton + '[data-open-tab="' + activeTab + '"]').addClass(activeClass);

		$(tabHeader).find(tabButton).click(function() {
			var tabToOpen = '#' + $(this).data('open-tab');

			var newTabHeight = $(tabToOpen).height();

			if ($(tabToOpen).is(':visible')) {
				return undefined;
			} else {
				$(tabHeader).find('.' + activeClass).removeClass(activeClass);

				var $this = $(this);

				$(this).addClass(activeClass);

				$(this).closest(outerContainer).find(tabContent).removeClass(openIdentifier).fadeOut(100);


				$(tabContentContainer).animate({
					minHeight: newTabHeight
				}, 250,
				function() {
					$this.closest(outerContainer)
					.find(tabToOpen)
					.fadeIn(100)
					.addClass(openIdentifier);
				});
			}

		});


		$(window).on('resize', $.sdg.debounce(function() {
			var tabContentHeight = $(outerContainer).find(tabContent + ':visible').height();

			$(tabContentContainer).animate({
				minHeight: tabContentHeight
			});

		}));
	};

	/*
	----------------------------------------------------------------------------
	10. Scroll To Button
	----------------------------------------------------------------------------
	*/
	$.sdg.scrollToBtn = function(trigger,container,fadein) {

		if (fadein === true) {
			$(window).on('scroll',$.sdg.debounce(function() {
				if ($('body').scrollTop() >= 100) {
					$(trigger).addClass('fade-in');
				} else {
					$(trigger).removeClass('fade-in');
				}
			}));
		}

		var containerTopPos = $(container).offset().top;

		$(trigger).click(function() {
			$('html,body').animate({scrollTop: containerTopPos}, 600, 'swing');
		});
	};



	/*
	----------------------------------------------------------------------------
	11. Autofill input placeholder from title value

	For Login/Registration/Checkout input boxes
	Copy value from "title" attribute and place it to "placeholder" value
	----------------------------------------------------------------------------
	*/
	$.sdg.addPlaceholderValue = function(container) {
		var input_boxes = $(container).find('input[type="text"]');
		input_boxes.each(function() {
			var title = $(this).attr('title') || '';

			$(this).attr('placeholder',title.toLowerCase());
		});
	};

	/*
	----------------------------------------------------------------------------
	12. Lazy Load Images
	---------------------------------------------------------------------------
	*/
	$.sdg.lazyLoadImages = function() {
		$('img.lazy').unveil(200, function() {
			var wrapper = $(this).parent();

			$(this).load(function() {
				var image = $(this);

				setTimeout(function() {
					image.css({opacity:1});
					wrapper.removeClass('is-loading');
				},500);

			});
		});
	};

	/*
	----------------------------------------------------------------------------
	13. Responsive Lazy Load
	----------------------------------------------------------------------------
	*/
	$.sdg.responsiveLazyLoad = function() {
		var init = function() {
			lazyLoadImages();
			windowResize();
		},

		lazyLoadImages = function() {
			if ($('#desktop').is(':visible') && !$('.desktop-lazy').hasClass('loaded')) {
				$('.desktop-lazy').unveil(200,function() {

					$(this).load(function() {
						$(this)
						.css({opacity:1})
						.addClass('loaded')
						.parent().removeClass('is-loading');
					});
				});
			}

			if ($('#mobile').is(':visible') && !$('.mobile-lazy').hasClass('loaded')) {
				$('.mobile-lazy').unveil(200,function() {

					$(this).load(function() {
						$(this)
						.css({opacity:1})
						.addClass('loaded')
						.parent().removeClass('is-loading');
					});
				});
			}

			if ($('#desktop-and-tablet').is(':visible') && !$('.desktop-and-tablet-lazy').hasClass('loaded')) {
				$('.desktop-and-tablet-lazy').unveil(200,function() {

					$(this).load(function() {
						$(this)
						.css({opacity:1})
						.addClass('loaded')
						.parent().removeClass('is-loading');
					});
				});
			}

			if ($('#tablet').is(':visible') && !$('.tablet-lazy').hasClass('loaded')) {
				$('.tablet-lazy').unveil(200,function() {

					$(this).load(function() {
						$(this)
						.css({opacity:1})
						.addClass('loaded')
						.parent().removeClass('is-loading');
					});
				});
			}

			if ($('#phone').is(':visible') && !$('.phone-lazy').hasClass('loaded')) {
				$('.phone-lazy').unveil(200,function() {

					$(this).load(function() {
						$(this)
						.css({opacity:1})
						.addClass('loaded')
						.parent().removeClass('is-loading');
					});
				});
			}
		},

		windowResize = function() {
			$(window).on('resize', $.sdg.debounce(function() {
				lazyLoadImages();
			}));
		};

		init();
	};

	/*
	----------------------------------------------------------------------------
	14. Site Menus
	----------------------------------------------------------------------------
	*/
	$.sdg.siteMenus = function() {

		var navToggleButton = '#navToggle',
		footerTrigger = '#footer .footer-trigger',
		footerAccordion = '.footer-accordion',
		scrollScope = 'body',
		navigation = '#userActionHeader',
		container = '#utilitySidebar',
		button = '.btn-utility',
		navExposeClass = 'nav-exposed',
		utilityExposeClass = 'utility-sidebar-exposed',
		menuOpenClass = 'menu-open',
		// navScope = '.navigation',
		// navTrigger = '#nav .isActive .nav--litter',
		// navAccordion = '#nav .nav__kittens',
		activeClass = 'active',
		accountExposeClass = 'account-menu-open',
		account = 'accountMenu',
		accountLoginButton = '.account-login-button',
		accountSignIn = '#accountSignIn',
		backToSignInButton = '.btn-back-to-login';

		var init,
		navToggle,
		utilitySidebar,
		footerMenu,
		windowResize,
		footerAccountToggle,
		navButtonClick,
		accountLoginButtonClick,
		backToSignIn;

		init = function() {
			navToggle(navToggleButton);
			footerMenu();
			//mobileNavAccordion();
			utilitySidebar();
			windowResize();
			//searchSite('#searchSite','.search-field','#searchButton');
			footerAccountToggle('#footerAccount','.btn-link','#headerAccount');
		};

		navToggle = function(navToggleButton) {
			$(navToggleButton).on('click',function() {

				if ($(this).hasClass(activeClass)) {
					$(this).removeClass(activeClass);
					$('body').removeClass(navExposeClass);
				} else {
					$(this).addClass(activeClass);
					$('body').addClass(navExposeClass);
				}

				if ($('body').hasClass(utilityExposeClass)) {
					$('body').removeClass(utilityExposeClass);
				}

				$('#'+account).find('.'+accountExposeClass).removeClass(accountExposeClass);
				$(navigation).find('.'+activeClass).removeClass(activeClass);
			});
		};

		utilitySidebar = function() {

			init = function() {
				navButtonClick();
				accountLoginButtonClick();
				backToSignIn();
			};

			navButtonClick = function() {
				$(navigation).on('click',button,function(e) {
					var menuToOpen = $(this).data('open-utility');
					e.preventDefault();
					$(navToggleButton).removeClass(activeClass);

					if ($('body').hasClass(navExposeClass)) {
						$('body').removeClass(navExposeClass);
						$.sdg.accordion.collapseAccordion('nav');
					}

					$('#'+account).find('.'+accountExposeClass).removeClass(accountExposeClass);

					if ($(this).hasClass(activeClass)) {
						$(this).removeClass(activeClass);
						$('body').removeClass(navExposeClass).removeClass(utilityExposeClass);
						$(container + ' .'+ menuOpenClass).removeClass(menuOpenClass);
						$(container + ' .message-visible').removeClass('message-visible').fadeOut(200);
						$(this).focus();
					} else {
						$(navigation).find('.'+activeClass).removeClass(activeClass);
						$(this).addClass(activeClass);
						$('body').addClass(utilityExposeClass);
						$(container + ' .'+ menuOpenClass).removeClass(menuOpenClass);
						$('#'+menuToOpen).addClass(menuOpenClass);
						if(menuToOpen === 'miniCart') {
							$('.utility-overlay').show();
						}
						$('#'+account).find('.'+accountExposeClass).removeClass(accountExposeClass);

						if (menuToOpen === account) {
							$(accountSignIn).addClass(accountExposeClass);
						}
						setTimeout(function(){
							trapFocus(document.getElementById(menuToOpen),$('#'+menuToOpen).find('.is-empty').length); // Trap Focus in Modal
						},500);



					}

					$(container).find('.inner').animate({scrollTop: 0},250);
				});
			};

			/**
			* Function Trap Focus to Modal
			* @type {function}
			* @param {domElement} - modal element in the dom.
			*/

			function trapFocus(element,length)
			{
			    var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])'),
			        firstFocusableEl = focusableEls[0],
			        lastFocusableEl = focusableEls[focusableEls.length - 1],
			        KEYCODE_TAB = 9;

			    if(length)
			    	lastFocusableEl.focus();
			    else
			    	firstFocusableEl.focus();// Focus to first focusable element in the modal

			    element.addEventListener('keydown', function(e) {
			        var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

			        if (!isTabPressed) {
			            return;
			        }

			        if ( e.shiftKey ) /* shift + tab */ {
			            if (document.activeElement === firstFocusableEl) {
			                lastFocusableEl.focus();
			                e.preventDefault();
			            }
			        } else /* tab */ {
			            if (document.activeElement === lastFocusableEl) {
			                firstFocusableEl.focus();
			                e.preventDefault();
			            }
			        }
			    });
			}

			accountLoginButtonClick = function() {
				$(container).on('click',accountLoginButton,function(e) {
					// e.preventDefault();
					// var accountMenuToOpen = $(this).data('account-menu');
					// $(container).find('.'+accountExposeClass).removeClass(accountExposeClass);
					// $('#'+accountMenuToOpen).addClass(accountExposeClass);
					// $(container).find('.inner').animate({scrollTop: 0},250);
					return true;
				});
			};

			backToSignIn = function() {
				$('#'+account).find(backToSignInButton).on('click',function() {
					$('#'+account).find('.'+accountExposeClass).removeClass(accountExposeClass);
					$(accountSignIn).addClass(accountExposeClass);
					$(container).find('.inner').animate({scrollTop: 0},250);
				});
			};

			footerAccountToggle = function(footerContainer,trigger,button) {
				$(footerContainer).on('click',trigger,function(e) {
					e.preventDefault();

					var message = $(this).data('account-message');

					if (message) {
						if ($('#' + message).hasClass('message-visible')) {
							$(container + ' .message-visible').removeClass('message-visible').fadeOut(200);
							$(button).click();
						} else {

							if ($('body').hasClass(utilityExposeClass)) {
								if (!$('#' + message).hasClass('message-visible')) {
									$(container + ' .message-visible').removeClass('message-visible').fadeOut(200,function() {
										$('#'+message).fadeIn(200).addClass('message-visible');
									});
								}
							} else {
								$('#'+message).fadeIn(200).addClass('message-visible');
								$(button).click();
							}
						}
					} else {
						$(button).click();
					}

				});
			};

			init();
		};

		footerMenu = function() {
			if ($('#mobile').is(':visible')) {
				$.sdg.accordion(footerTrigger,footerAccordion,scrollScope);
			}
		};

		// mobileNavAccordion = function() {
		// 	if ($('#mobile').is(':visible')) {
		//
		//
		// 		$(navTrigger).click(function(e) {
		// 			/*
		// 			if ($(this).hasClass('active')) {
		// 				location.href = $(this).attr('href');
		// 			} else {
		// 				e.preventDefault();
		// 			}
		// 			*/
		// 			if ($(this).parent().hasClass('isActive')) {
		// 				e.preventDefault();
		// 			} else {
		// 				location.href = $(this).attr('href');
		// 			}
		// 		});
		//
		// 		$.sdg.accordion(navTrigger,navAccordion,navScope);
		//
		// 	}
		// },

		windowResize = function() {
			$(window).on('resize',$.sdg.debounce(function() {
				$(footerTrigger).unbind('click');

				if ($('#mobile').is(':visible')) {
					$.sdg.accordion(footerTrigger,footerAccordion,scrollScope);
				} else {
					$(footerTrigger).removeClass(activeClass);
					$(footerAccordion).removeAttr('style');
					$(navToggleButton).removeClass(activeClass);
					$('body').removeClass(navExposeClass);
				}
			}));
		};

		init();
	};

	$.sdg.siteMenus.forgotPasswordLink = function(button) {
		$(button).on('click',function(e) {
			$('#headerAccount').click();
			$('#btnAccountForgotPassword').click();
		});
	};

	/*
	----------------------------------------------------------------------------
	15. Follower
	----------------------------------------------------------------------------
	*/

	$.sdg.follower = function(follower, stopPos,offsetAmount) {

		follower = $(follower);
		stopPos = $(stopPos);
		var startTop = follower.offset().top-43;

		$(window).scroll(function(event) {
			var newTop = $(window).scrollTop();
			var followerHeight = follower.outerHeight();
			var footPos = stopPos.offset().top - followerHeight - offsetAmount;

			if (newTop > startTop && newTop < footPos) {
				follower.parent().addClass('following').removeClass('follower-stopped');
				follower.removeAttr('style');
			} else if (newTop > footPos) {
				follower.parent().removeClass('following').addClass('follower-stopped');
				follower.css('top',(($('.category-products').height() - followerHeight) + 43) - offsetAmount);
			} else {
				follower.parent().removeClass('following');
			}
		});
	};

	/*
	----------------------------------------------------------------------------
	16. Welcome Modal
	----------------------------------------------------------------------------
	*/
	$.sdg.welcomeModal = function() {
		if ($('#join-vip-list').length > 0) {
			if ($.sdg.getCookie('threeSixtyWelcome') !== 'set') {
				window.setTimeout(function() {
					$('#join-vip-list').fadeIn(250);
					$('.modal-vip-list-overlay').fadeIn(250);
					$('#join-vip-list').find('input[type=text]').focus();
					if ($('#desktop').is(':visible')) {
						$('body').addClass('no-overflow');
					}
				}, 1000);
			}

			$('#join-vip-list').on('click', '.btn-close', function() {
				$.sdg.setCookie('threeSixtyWelcome', 'set',1000);
				$('#join-vip-list').fadeOut(250);
				$('.modal-vip-list-overlay').fadeOut(250);
				if ($('#desktop').is(':visible')) {
					$('body').removeClass('no-overflow');
				}
			});

			$('#join-vip-list').on('click', '.btn-continue-shopping', function() {
				$('.btn-close').trigger('click');
			});

			$(document).keyup(function(e) {
				if (e.keyCode === 27) {
					if ($('#join-vip-list').is(':visible')) {
						$.sdg.setCookie('threeSixtyWelcome', 'set',1000);
					}
				}
			});
		}
	};

	// Private Sale Modal

	$.sdg.privateSale = function(opts) {
		var config = {
			container : '#privateSale',
			cookie : 'privateSale',
			subscribe : '#privateSale_subscribe',
			subscribeForm : '#privateSale_subscribe_form',
			thankYou : '#privateSale_thank_you',
			btnClose : '.btn-close-private-sale',
			btnContinue: '.btn-continue-shopping',
			modalOverlay : '.modal-overlay',
			source : 'Private Sale',
			showThanks: 'show-thanks-message',
			loading: 'loading',
			hide: 'hide',
			btnSubmit: '#newsletterSubmit',
			disabled: 'disabled'
		},
		c = $.extend(config, opts),
		privateSale = {
			init: function() {
				privateSale.openModal();

			},
			openModal: function() {
				if ($(c.container).length > 0) {
					if ($.sdg.getCookie(c.cookie) !== 'set') {
						window.setTimeout(function() {
							$(c.container).fadeIn(250);
							$(c.modalOverlay).fadeIn(250);
							$(c.container).find('input[type=text]').focus();
						}, 1000);
					}
					privateSale.closeModal();
					privateSale.klaviyo();
				}
			},
			closeModal: function() {
				$(c.container).on('click', c.btnClose, function(e) {
					//alert('close');
					e.stopPropagation();
					window.location.href = '/';
				});

				$(c.container).on('click', c.btnContinue, function() {
					$(c.container).fadeOut(250);
					$(c.modalOverlay).fadeOut(250);
				});
			},
			klaviyo: function() {

				// var validateForm = new VarienForm(c.subscribeForm.replace('#',''),true);
				//
				// validateForm.validator.options.onFormValidate = function(validationPassed, form) {
				//     if(validationPassed){
				//          $(c.subscribeForm).addClass(c.loading).addClass(c.disabled);
				//     }
				// };
				if (typeof KlaviyoSubscribe !== 'undefined') {
					KlaviyoSubscribe.attachToForms(c.subscribeForm, {
						hide_form_on_success: true,
						extra_properties: {
							$source: c.source
						},
						success: function($form) {
							$(c.subscribe).addClass(c.hide);
							$(c.thankYou).removeClass(c.hide).addClass(c.showThanks);
							$(c.subscribeForm).removeClass(c.loading).removeClass(c.disabled);
							$.sdg.setCookie(c.cookie, 'set',5);
						}
					});
				}

			}
		};

		return privateSale.init();

	};

	



	/*
	----------------------------------------------------------------------------
	18. Category Toolbar
	----------------------------------------------------------------------------
	*/
	$.sdg.categoryToolbar = function() {

		var init,
		toggleMenus,
		filterClone,
		windowResize;

		init = function() {
			toggleMenus('#toolbar','.btn-toggle','.mobile-category-menu');
			windowResize('#mobile-toolbar .btn-toggle','#mobile-toolbar .mobile-category-menu');
			filterClone('#categoryFilters','#mobileCategoryFilters .inner');
			$.sdg.accordion('#mobileCategoryFilters h4','#mobileCategoryFilters .filter-list',null);
			$('#mobileCategoryFilters').find('.filter:first').find('h4').click();
			$.sdg.follower('#toolbar','#footer',260);
		};

		toggleMenus = function(container,button,menu) {
			$(container).on('click',button,function() {
				if ($(this).hasClass('active')) {
					$(this).removeClass('active').next(menu).removeClass('open');
				} else {
					$(container).find('.active').removeClass('active').next(menu).removeClass('open');
					$(this).addClass('active').next(menu).addClass('open');
				}
			});
		};

		filterClone = function(cloneFrom,cloneTo) {
			$(cloneFrom).clone().appendTo(cloneTo).removeAttr('id');
		};

		windowResize = function(button,container) {
			$(window).on('resize',$.sdg.debounce(function() {
				$(button).removeClass('active');
				$(container).removeClass('open');
			}));
		};

		init();
	};

	/*
	----------------------------------------------------------------------------
	19. Toggle Section
	----------------------------------------------------------------------------
	*/
	$.sdg.toggleSection = function(container,toggle,section,timer) {

		var activeClass = 'active',
		openClass = 'open';

		$(container).find(toggle).on('click',function() {
			if ($(this).hasClass(activeClass)) {
				$(this).removeClass(activeClass)
				.next(section).slideUp(timer).removeClass(openClass);
			} else {
				$(this).addClass(activeClass)
				.next(section).slideDown(timer).addClass(openClass);
			}
		});

	};

	/*
	----------------------------------------------------------------------------
	20. Phone Toggle Section
	----------------------------------------------------------------------------
	*/
	$.sdg.phoneToggleSection = function(container,toggleButton,section,timer) {

		var activeClass = 'active',
		openClass = 'open';

		var init,
		toggleClick,
		windowResize,
		openSection,
		detectHashChange;

		init = function() {

			if ($('#phone').is(':visible')) {
				toggleClick();
				openSection();
				detectHashChange();
			}

			windowResize();
		};

		toggleClick = function() {

			$(container).find(toggleButton).on('click',function(e) {
				e.preventDefault();

				if ($(this).hasClass(activeClass)) {
					$(this).removeClass(activeClass)
					.next(section).slideUp(timer).removeClass(openClass);
				} else {
					$(this).addClass(activeClass)
					.next(section).slideDown(timer).addClass(openClass);
				}
			});

		};

		windowResize = function() {

			$(window).on('resize',$.sdg.debounce(function() {

				$(container).find(toggleButton).unbind('click').removeClass(activeClass).next(section).removeAttr('style').removeClass(openClass);

				if ($('#phone').is(':visible')) {
					toggleClick();

					detectHashChange();
				}

			}));

		};

		openSection = function() {
			if (window.location.hash) {
				var sectionToOpen = window.location.hash;
				sectionToOpen = sectionToOpen.replace('#','');
				var target = $(container).find('a[name="' + sectionToOpen + '"]').next(toggleButton);
				if (!target.hasClass('active')) {
					$(container).find('a[name="' + sectionToOpen + '"]').next(toggleButton).click();
				}
			}
		};

		detectHashChange = function(callback) {
			$(window).on('hashchange',function() {
				openSection();
			});
		};

		init();

	};

	/*
	----------------------------------------------------------------------------
	21. Show More Container
	----------------------------------------------------------------------------
	*/
	$.sdg.showMoreContainer = function(container,button,item) {

		var init,
		buttonClick;

		init = function() {
			buttonClick();
		};
		buttonClick = function() {
			$(container).find(button).on('click',function() {

				var hideContainers = $(this).prev(item).find('.hide-desktop,.hide-tablet,.hide-phone');

				if ($(this).hasClass('active')) {
					$(this).removeClass('active').find('span').html('show more');
					hideContainers.removeAttr('style');
				} else {
					$(this).addClass('active').find('span').html('show less');
					hideContainers.show();
				}
			});
		};

		init();
	};



	/*
	----------------------------------------------------------------------------
	22b. Mini Cart Padding
	----------------------------------------------------------------------------
	*/
	$.sdg.miniCartPadding = function() {
		$('#bagForm').css('padding-bottom', $('.mini-cart-footer').outerHeight() + 90);
	};


	/*
	----------------------------------------------------------------------------
	24. Press Quickview
	----------------------------------------------------------------------------
	*/
	$.sdg.pressQuickview = function(containerId,buttonClass,modalButtonClass,listItemClass,quickviewClass,modalId,carouselClass) {
		console.log('getting other file');
		var init,
			clickAction,
			openQuickview,
			openQuickviewModal,
			closeQuickviewModal,
			closeButton,
			windowResize;

		init = function() {
			clickAction();
			closeButton();
			closeQuickviewModal();
			windowResize();
		};

		clickAction = function() {
			$(containerId).on('click',buttonClass,function() {

				var button = $(this),
					listItem = button.parents(listItemClass),
					quickview = listItem.find(quickviewClass),
					carousel = quickview.find(carouselClass),
					triggerHeight = button.height() / 2,
					quickviewHeight = quickview.find('.inner').outerHeight(),
					quickviewOffset = quickview.offset().top,
					listItemOffset = listItem.offset().top,
					headerOffset = $('#header').height()-triggerHeight;

				openQuickview(button,listItem,quickview,carousel,triggerHeight,quickviewHeight,quickviewOffset,listItemOffset,headerOffset);
			});

			$(containerId).on('click',modalButtonClass,function() {
				var modalButton = $(this),
					listItem = modalButton.parents(listItemClass),
					quickview = listItem.find(quickviewClass);

				openQuickviewModal(modalButton,listItem,quickview);
			});
		};

		openQuickview = function(button,listItem,quickview,carousel,triggerHeight,quickviewHeight,quickviewOffset,listItemOffset,headerOffset) {
			if (!button.hasClass('quickview-visible')) {
				if ($('.open-quickview').length > 0) {

					//console.log($(containerId).find('.open-quckview').parent(listItemClass));

					$(containerId).find('.open-quickview').parent(listItemClass).removeClass('quickview-triggered').animate({marginBottom: 0},200)
					.find('.quickview-visible').removeClass('quickview-visible');

					$(containerId).find('.open-quickview').removeClass('open-quickview').animate({height:0},200, function() {
						quickview.addClass('open-quickview').animate({height:quickviewHeight},200);

						listItem.addClass('quickview-triggered').animate({marginBottom: quickviewHeight},200)
						.find(button).addClass('quickview-visible');

					});

				} else {


					var pressNumber = quickview.attr('quickview'),
					$pressCarousel = document.getElementById('pressCarousel-'+pressNumber);

					quickview.addClass('open-quickview').animate({height:quickviewHeight},200);

					listItem.addClass('quickview-triggered').animate({marginBottom: quickviewHeight},200)
					.find(button).addClass('quickview-visible');

					require([path.flickity], function(Flickity) {
						new Flickity($pressCarousel, {
							contain: true,
							pageDots: true,
							prevNextButtons: false,
							watchCSS: true,
							wrapAround: false
						});
					});

				}

				setTimeout(function(){
					$('html,body').animate({scrollTop: listItem.offset().top + listItem.height()/2 },500);
				},500);
			} else {
				$(containerId).find('.open-quickview').find('.btn-close-alt').click();
			}
		};

		openQuickviewModal = function(modalButton,listItem,quickview,carousel) {
			quickview.find('.press-view').clone().appendTo($(modalId).find('.modal-inner'));
			$('body').addClass('no-overflow');
			$(modalId ).fadeIn(2500,function() {

				// var $pressCarousel = document.getElementById('pressCarousel');
                //
				// require([path.flickity], function(Flickity) {
				// 	new Flickity($pressCarousel, {
				// 		contain: true,
				// 		pageDots: true,
				// 		prevNextButtons: false,
				// 		watchCSS: true,
				// 		wrapAround: true
				// 	});
				// });
			});
			document.ontouchmove = function(e){ e.preventDefault(); };
		};

		closeQuickviewModal = function() {
			$(modalId).on('click','.btn-close',function() {
				$(modalId).fadeOut(250,function() {
					$(modalId).find('.modal-inner').empty();
					$('body').removeClass('no-overflow');
				});
				document.ontouchmove = function(e){ return true; };
			});

			$(document).keyup(function(e) {
				if (e.keyCode === 27) {
					$(modalId).find('.btn-close').click();
				}
			});
		};

		closeButton = function() {
			$(containerId).on('click','.btn-close-alt', function() {

				var clicked = $(this);

				clicked.parent(quickviewClass).removeClass('open-quickview')
				.animate({height:0},200)
				.parents(listItemClass).removeClass('quickview-triggered').animate({marginBottom:0},200)
				.find(buttonClass).removeClass('quickview-visible');

				$('html,body').animate({scrollTop: $(this).parents(listItemClass).offset().top-$('#header').height()-43},500);
				document.ontouchmove = function(e){ return true; };
			});
		};

		windowResize = function() {
			$(window).on('resize',$.sdg.debounce(function() {
				if ($(containerId).find('.open-quickview').length > 0) {
					var newHeight = $(containerId).find('.open-quickview').find('.inner').outerHeight();
					$(containerId).find('.quickview-triggered').animate({marginBottom:newHeight},200);
					$(containerId).find('.open-quickview').animate({height:newHeight},200);

					if ($('#phone').is(':visible')) {
						$(containerId).find('.open-quickview').find('.btn-close-alt').click();
					}
				}

				if ($('#phone').is(':hidden')) {
					$(modalId).find('.btn-close').click();
				}
			}));
		};

		init();
	};

	/*
	----------------------------------------------------------------------------
	25. Blog Menu
	----------------------------------------------------------------------------
	*/
	$.sdg.blogMenu = function(container,button,menu) {

		var init,
		buttonClick,
		windowResize;

		init = function() {
			buttonClick(container,button,menu);
			windowResize(container,button,menu);
		};

		buttonClick = function(container,button,menu) {
			$(container).on('click',button,function() {
				//console.log('something happened');
				if ($(this).hasClass('active')) {
					$(this).removeClass('active').next(menu).removeClass('open');
				} else {
					$(container).find('.active').removeClass('active').next(menu).removeClass('open');
					$(this).addClass('active').next(menu).addClass('open');
				}
			});
		};

		windowResize = function(container,button,menu) {
			$(window).on('resize',$.sdg.debounce(function() {
				$(button).removeClass('active');
				$(menu).removeClass('open');
			}));
		};

		init();
	};


	$.sdg.vipNewsletter = function() {
		if (typeof KlaviyoSubscribe !== 'undefined') {
			KlaviyoSubscribe.attachToForms('#vip_list_subscribe_form', {
				hide_form_on_success: true,
				extra_properties: {
					$source: 'Modal Pop-up'
				},
				success: function($form) {
					$('#vip_list_subscribe_form').removeClass('loading').removeClass('loading-white').removeClass('disabled');
					$('#vip-list-newsletter-contact-form').addClass('hide-contact-form').addClass('hide');
					$('#vip-list-thanks-message').removeClass('hide').addClass('show-thanks-message');
					$.sdg.setCookie('threeSixtyWelcome', 'set',3);
				}
			});
		}

	};




	/*
	----------------------------------------------------------------------------
	26. Lazy Load Products
	----------------------------------------------------------------------------
	*/
	/*jshint ignore:start*/
	$.sdg.$isProductsLoading = false;
	$.sdg.$currentPage = 1;
	$.sdg.$pages = 0;
	$.sdg.$currentSortDir;
	$.sdg.$currentSortField;
	$.sdg.$searchQuery = false;
	/*jshint ignore:end*/

	$.sdg.runCategoryLazyLoadCollection = function() {

		if ($(window).scrollTop() + $(window).height() - $('#searchspring-search_results').height() - $('#searchspring-search_results').position().top - 100 > 0 && !$.sdg.$isProductsLoading) {
			$.sdg.$isProductsLoading = true;
			if ($.sdg.$currentPage < $.sdg.$pages) {
				$('#view-more-loading').slideDown(
					function(event) {
						$.sdg.$currentPage++;

						var currentOpts = '';
						if (window.location.href.indexOf('?') !== -1) currentOpts = '&'+window.location.href.slice(window.location.href.indexOf('?') + 1);

						if ($.sdg.$currentSortField && currentOpts.indexOf('order') === -1) {
							currentOpts +='&dir='+$.sdg.$currentSortDir+'&order='+$.sdg.$currentSortField;
						}

						var urlString = '';

						if ($.sdg.$searchQuery) {
							urlString = '/catalogsearch/result/ajax/?p='+$.sdg.$currentPage+'&limit=12'+currentOpts;
						} else {
							urlString = '/catalog/category/ajax/?id='+$.sdg.$currentCategoryId+'&p='+$.sdg.$currentPage+'&limit=12'+currentOpts;
						}

						$.ajax({
							method: 'get',
							url: urlString,
							success: function(response) {
								$('#view-more-loading').hide();
								$('#searchspring-search_results').append(response);
								$('#searchspring-search_results .product-item').fadeIn(200,function() {
									$('#searchspring-search_results').find('.lazy').unveil(200,function() {
										$(this).parent().addClass('loading');

										$(this).load(function() {
											$(this).css({opacity:1});
											$(this).parent().removeClass('loading');
										});
										$('#searchspring-search_results').find('.lazy').trigger('unveil');
									});
								});
								$.sdg.$isProductsLoading = false;
							}
						});
					}
				);
			} else {
				$.sdg.$isProductsLoading = false;
			}
		}

	};

	/*
	----------------------------------------------------------------------------
	27. SearchSpring Filter
	----------------------------------------------------------------------------
	*/
	$.sdg.searchSpringFilter = function(e) {

		$(document).off().on('click', '.facet_container', function(e) {
			var self = $(this);

			if ($(this).hasClass('active')) {
				self.find('button').attr('aria-expanded', 'false');

				if ($(e.target).hasClass('show_more_less') === false) {
					$(this).find('.element_container').removeClass('active');
					$(this).removeClass('active');
				}
			} else {

				self.find('button').attr('aria-expanded', 'true');
				if ($(e.target).hasClass('show_more_less') === false) {
					$(this).siblings().removeClass('active');
					$(this).siblings().find('.element_container').removeClass('active');
					$(this).addClass('active');
					setTimeout(function() {
						self.find('.element_container').addClass('active');
					},200);
				}
			}

		});
		$('html').on('click', function(e) {
			if ($(e.target).hasClass('element_container') || $(e.target).hasClass('show_more_less') || $(e.target).hasClass('facet_title')) {
				return undefined;
			} else {
				if ($('.facet_container').hasClass('active')) {
					setTimeout(function() {
						$('.element_container').removeClass('active');
						$('.facet_container').removeClass('active');
					}, 100);
				}

			}
		});

		$(window).scroll(function() {
			var scroll_pos = $('body').scrollTop();
			var header_height = $('header').outerHeight();
			var grid = $('#product-list') || 0;
			var grid_pos = grid.offset() || 0;

			if (scroll_pos > (grid_pos.top + header_height)) {
				$('#toolbar').addClass('follow').css('top',header_height+'px').css('left',grid_pos.left+'px').css('width', grid.outerWidth()+'px');
			} else {
				$('#toolbar').removeClass('follow').attr('style','');
			}

		});
	};

	/*
	----------------------------------------------------------------------------
	27. Remove SearchSpring Scroll position
	----------------------------------------------------------------------------
	*/
	$.sdg.removeSsScroll = function() {
		$('#nav, #header a').click(function() {
			if (sessionStorage.getItem('ssScroll') !== 0) {
				sessionStorage.removeItem('ssScroll');
			}
		});
	};

})(jQuery);


/*
----------------------------------------------------------------------------
30. Functions to run on load
----------------------------------------------------------------------------
*/
jQuery('document').ready(function($j) {
	// =====================================================================
	// Shared Vars
	// =====================================================================

	Modernizr.addTest('ios', function () {
		return navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
	});

	require(['jquery', path.jquery_validate], function() {

		$.validator.setDefaults({
			errorClass: 'validation-advice',
			errorElement: 'div',
		});
		$.validator.addMethod('myEmail', function(value, element) {
			return this.optional( element ) || ( /^[a-z0-9]+([-._][a-z0-9]+)*@([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,4}$/.test( value ) && /^(?=.{1,64}@.{4,64}$)(?=.{6,100}$).*/.test( value ) );
		}, 'Please enter valid email address.');

		var email_rules = {
			rules: {
				email: {
					required: true,
					email: true // myEmail: true
				}
			}
		};

		$('#customer_login').validate();
		$('#customer_login_page').validate();
		$('#forgot_password').validate();
		$('#create_customer').validate();
		$('#create_customer_page').validate();
		$('#vip_list_subscribe_form').validate(email_rules);
		$('#ajax_newsletter_subscribe_form').validate(email_rules);
		$('#ajax_newsletter_subscribe_form3').validate(email_rules);

		$('#activate_password').validate({
			rules: {
				password: 'required',
				'customer[password_confirmation]': {
					equalTo: '#CustomerPasswordActivate'
				}
			}
		});

		$.sdg.phoneToggleSection('#legal','.mobile-toggle','.mobile-toggle-section',250);
		$.sdg.blogMenu('#blogNavigation','#btnCategoryMenu','#categoryMenu');

	});

	SDG.Bag.init();



	// =====================================================================
	// Generic, efficient window resize handler
	// =====================================================================

	// Using setTimeout since Web-Kit and some other browsers call the resize function constantly upon window resizing.
	var resizeTimer;
	$j(window).resize(function (e) {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			$j(window).trigger('delayed-resize', e);
		}, 250);
	});


	$.sdg.runDomReady();

	// =====================================================================
	// Products View
	// =====================================================================

	// Config buttons can be changed using keyboard. Use tabs & arrows to change values
	$('.config__radio').focus(function(){
		$(this).parent().find('.config__btn').click();
	});

	// =====================================================================
	// Products Quick View
	// =====================================================================

	// Config buttons can be changed using keyboard. Use tabs & arrows to change values
	// in Collection Page & Search Page

	$('#results').on('focus','.config__radio',function(){
		$(this).parent().find('.config__btn').click();
	});
});

// ==========================================================================
// Minicart Overlay On Click
// ==========================================================================
//

$('.utility-overlay').on('click', function() {
	$('.cart-toggle').trigger('click');
	$('.utility-overlay').hide();
});
/**
* common functions
*
* run dom ready
* run
* execute run and run dom ready
*/

/**
* run dom ready
*/

SDG.runDomReady = function() {
	_.ready(function() {

		// header
		SDG.Header.init();



		// require(['jquery', path.validate], function() {
		// 	$('create_customer').validate();
		// });


	});
};

/**
* run
*/
SDG.run = function() {



	var $variableMenu = document.getElementById('variableMenu');

	// variable menu
	if ($variableMenu) {
		require([path.variable_menu]);
	}
};


/**
* execute run and run dom ready
*/
SDG.run();
SDG.runDomReady();